import TopbarNav from "components/navigational-component/topbar-nav/TopbarNav";
import { v4 as uuidv4 } from "uuid";
import PublishSubscribe, {
  EventTypes,
} from "components/utility-component/wafer-map-widget/PublishSubscribe";
import {
  DieType,
  ReticleReference,
  WaferDefinitionData,
  WaferMapConfig,
  ZoneData,
  StandardReticle,
  ComponentHeaderData,
  ReticleSiteAttributeMeta,
  ReticleGridRectCoords,
  RectCoord,
} from "components/utility-component/wafer-map-widget/wafer-map/web-gl-utils/Types";
import { CheckBox, ColorBox, DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  PatternRule,
  NumericRule,
  RangeRule,
  Scrolling,
  Selection,
  StringLengthRule,
} from "devextreme-react/data-grid";
import _ from "lodash";
import React from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import toast from "CustomToast";
import type { ToastOptions } from "react-toastify";
import "./wafer-control-map.scss";
// eslint-disable-next-line no-unused-vars
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowUp,
  faCrosshairs,
  faEdit,
  faMinus,
  faPlus,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Label from "components/wrapped-component/hint-controls/Label";
import Textbox from "components/wrapped-component/hint-controls/Textbox";
import DevExtremeTextBox from "devextreme-react/text-box";
import CustomizedDropdown from "components/wrapped-component/customized-dropdown/CustomizedDropdown";
import AttributesGrid from "components/device-setup/attributes-grid";
import ModalPopup from "components/wrapped-component/modal-popup/modal-popup";
import getDropDownOptions from "components/getDropDownOptions";
// eslint-disable-next-line no-unused-vars
import ComponentHeader, {
  componentHeaderStates,
} from "components/wrapped-component/component-header/component-header";
import { withRouter } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import {
  ActiveTab,
  CalculationMethod,
  DieColorType,
  ExclusionType,
  MarkingMode,
  MiddleViewport,
  NotchPosition,
  SelectionMode,
  ActionOnWaferData,
  WaferAxisDirection,
  WaferOriginLocation,
  DieSpecType,
  MetaColumnType,
  FeatureSpecificWaferTag,
  ReticlePlotSequence,
} from "components/utility-component/wafer-map-widget/wafer-map/web-gl-utils/Enums";
import WaferPlotter, {
  ActionType,
  WaferAdditionalControl,
} from "components/utility-component/wafer-map-widget/wafer-map-v2/WaferPlotter/WaferPlotter";
import WaferUtils from "components/utility-component/wafer-map-widget/wafer-map-v2/Utils/WaferUtils";
import WaferMapVariablesV2, {
  DieData,
  Dies,
} from "components/utility-component/wafer-map-widget/wafer-map-v2/Utils/WaferMapVariablesClassV2";
import { httpWaferControlMap } from "services/http.wafer-control-map";
import { httpDieType } from "services/http.die-types";
import EditableDataGrid from "components/wrapped-component/editable-data-grid/EditableDataGrid";
import WaferDefinition from "./wafer-definition";
// eslint-disable-next-line no-unused-vars
import { DrawLayoutData, DrawLayoutPanResizeMode } from "./DrawLayout";
import { UtilityFunctions } from "./utility";
import commonFunctions from "../../customFunctions";
import PCMWATSiteMapTab, {
  PCMWATSiteMapTabData,
  ReticleCalculationMethod,
  ReticleInsertDirection,
  ReticlePanDirection,
  ReticlePanMode,
} from "./pcm-wat-site-map-tab";
import DieCountSummary from "./die-count-summary";
import PCMWATSiteMapSideBar from "./pcm-wat-site-map-side-bar";
// eslint-disable-next-line no-unused-vars
import DefineZonesTab from "./define-zones";
import HomeDieCoordsForm from "./home-die-coords-form";
import DrawPattern from "./draw-pattern";

type WaferControlMapState = {
  name: string;
  owner: string;
  access: string;
  version: number;
  state: string;
  description: string;
  facility?: string;
  workCenter?: string;
  programName?: string;
  lotId?: string;
  waferId?: string;
  waferDefinitionData: WaferDefinitionData;
  ringPanOffsetXMultiplier: number;
  ringPanOffsetYMultiplier: number;
  drawLayout: DrawLayoutData;
  pcmWatSiteMapTabData: PCMWATSiteMapTabData;
  dieTypes: DieType[];
  enabledDieTypes: { [key: string]: boolean };
  currentDieTypeId: string | null;
  waferMapConfig: WaferMapConfig | null;
  orignalWaferDimensions: { height: number; width: number };
  middleViewport: MiddleViewport;
  activeTab: ActiveTab;
  ringDiameterToWaferDiameterRatio: number;
  collapseTabsColumn: boolean;
  collapseDieSummaryColumn: boolean;
  allWCMAttributeMetas: any[];
  WCMAttributeDefinitions: any[];
  pcmWatTestMethod: string;
  watProbingSequence: string;
  pcmWatSiteNumber: number | null;
  maxPcmWatSiteNumber: number;
  showWATPCMSites: boolean;
  dieLabelDisplayMode: DieLabelDisplayMode;
  zones: ZoneData[];
  selectedZoneId: string | null;
  isInSavingState: boolean;
  isLoading: boolean;
  isInsertDieControlActive: boolean;
  isDeleteModeActive: boolean;
  parsedFileData?: any;
  parsedWaferMapData?: string[][];
  memoryDetails: {
    name: string;
    rows: number | null;
    columns: number | null;
  };
  patternDefinition: {
    singleRowFailureBits: `${number}` | null;
    singleColumnFailureBits: `${number}` | null;
    partialRowFailureBits: `${number}` | `${number}%` | null;
    partialColumnFailureBits: `${number}` | `${number}%` | null;
  },
  partialRowFailureBitsType: 'Count' | 'Percentage';
  partialColumnFailureBitsType: 'Count' | 'Percentage';
  drawPattern: {
    inputRows: number | null;
    inputCols: number | null;
    patterns: Array<{
      id: string;
      rows: number;
      cols: number;
      grid: boolean[][];
    }>;
    activePatternIndex: number;
    isDrawing: boolean;
    drawState: boolean;
    isEraserMode: boolean;
  };
};

type DieLabelDisplayMode = "reticleSite" | "hardBin" | "softBin" | "none";

export const UOMs = [
  ["MILLIMETERS", "Millimeter"],
  ["INCHES", "Inches"],
  ["MICRONS", "Microns"],
  ["CENTIMETERS", "Centimeter"],
  ["MILS", "Mils"],
];

export const reticleIncrementUOMs = [
  ["die", "Die"],
  ["reticle", "Reticle"],
];

export function DIAMETERS(UOM: string): string[][] {
  return [
    ["3", "3"],
    ["4", "4"],
    ["6", "6"],
    ["8", "8"],
    ["12", "12"],
  ].map((d: string[]) => {
    return [
      UtilityFunctions.inchToOtherUnit(+d[0], UOM, true).toString(),
      UtilityFunctions.inchToOtherUnit(+d[1], UOM, true).toString(),
    ];
  });
}

export const NOTCH_POSITIONS = [
  ['UNKNOWN', 'Unknown'],
  ["DOWN", "Down"],
  ["UP", "Up"],
  ["LEFT", "Left"],
  ["RIGHT", "Right"],
];

export const WAFER_AXIS_DIRECTION: {
  axisDirection: WaferAxisDirection;
  label: string;
}[] = [
  {
    axisDirection: WaferAxisDirection.DOWN_RIGHT,
    label: "Right, Down",
  },
  {
    axisDirection: WaferAxisDirection.UP_RIGHT,
    label: "Right, Up",
  },
  {
    axisDirection: WaferAxisDirection.DOWN_LEFT,
    label: "Left, Down",
  },
  {
    axisDirection: WaferAxisDirection.UP_LEFT,
    label: "Left, Up",
  },
];

export const WAFER_ORIGIN_LOCATION: {
  originLocation: WaferOriginLocation;
  label: string;
}[] = [
  {
    originLocation: WaferOriginLocation.UPPER_RIGHT,
    label: "Upper Right",
  },
  {
    originLocation: WaferOriginLocation.UPPER_LEFT,
    label: "Upper Left",
  },
  {
    originLocation: WaferOriginLocation.LOWER_RIGHT,
    label: "Lower Right",
  },
  {
    originLocation: WaferOriginLocation.LOWER_LEFT,
    label: "Lower Left",
  },
  {
    originLocation: WaferOriginLocation.CENTER,
    label: "Center",
  },
];

const DIE_LABEL_DISPLAY_OPTIONS: { label: string; value: DieLabelDisplayMode }[] = [
  { label: "Reticle Site Number", value: "reticleSite" },
  { label: "Hard Bin Number", value: "hardBin" },
  { label: "Soft Bin Number", value: "softBin" },
  { label: "None", value: "none" },
];

export const STANDARD_RETICLE_WATPCM_SITE_LIST = [
  ["Street Top", "Street Top"],
  ["Street Bottom", "Street Bottom"],
  ["Street Left", "Street Left"],
  ["Street Right", "Street Right"],
];

export const DEFAULT_DIE_COLOR = "#666666";

export const NOTCH_FLAT_TOGGLE_DIAMETER_VALUE = 200;

export const WAFER_DIAMETER_EXEMPTED_FROM_RETICLE_COLLISION_CROPPING = 100;

const DEVICE_WAFER_KEY = "deviceWafer";

const WAFER_PLOTTER_CANVAS_HEIGHT = 2500;

/** Shown when reticle top-left does not land on die-grid boundaries (whole die steps). Long copy: keep open until dismissed; use close button like former warning toasts. */
const RETICLE_ALIGNMENT_TOAST_OPTIONS = {
  autoClose: false as const,
  closeOnClick: true,
  closeButton: true,
  /** Applied to the outer Toastify row (portal); styled in wafer-control-map.scss */
  className: "wcm-reticle-alignment-toast-outer",
} as Partial<ToastOptions>;

const RETICLE_ALIGNMENT_ISSUE_TOAST = (
  <div className="wcm-reticle-alignment-toast">
    <strong className="wcm-reticle-alignment-toast__title">
      Reticle Alignment Issue
    </strong>
    <p className="wcm-reticle-alignment-toast__body">
      The current reticle configuration cannot be aligned to the die grid. This is
      usually caused by a combination of reticle size, reference point, or offset values
      that result in the reticle not fitting precisely on die boundaries. Please adjust
      the reticle size, offset, or reference point to resolve the alignment. Following is
      the exact list of fields used for reticle alignment over die grid:
    </p>
    <ul className="wcm-reticle-alignment-toast__list">
      <li>Reticle Size (Width / Height)</li>
      <li>Reticle Reference Point</li>
      <li>Reticle Offset (X / Y)</li>
      <li>Reticle Unit of Measure (UOM)</li>
      <li>Die Step Size (X / Y)</li>
      <li>Die UOM</li>
      <li>Wafer/Grid Inputs (Rows, Columns, Background Offsets)</li>
    </ul>
  </div>
);

enum WCMContextMenuAction {
  COLLAPSE_WAFER,
  EXPAND_WAFER,
  COLLAPSE_DEFINITION_TABS,
  EXPAND_DEFINITION_TABS,
  COLLAPSE_DIE_SUMMARY,
  EXPAND_DIE_SUMMARY,
}

class WaferControlMap extends React.Component<any, WaferControlMapState> {
  dieTypesDatagrid: DataGrid | null = null;

  zonesDatagrid: DataGrid | null = null;

  waferDefinitionRef: any = null;

  waferDiv: any = null;

  plotter: WaferPlotter | null = null;

  canvasDimension = 800;

  resizeObserver: ResizeObserver | null = null;

  deviceWafer: WaferUtils | null = null;

  isUpdateWCM: boolean = false;

  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: false,
      isInSavingState: false,
      name: "",
      owner: "",
      access: "PUBLIC",
      version: 1,
      state: componentHeaderStates[0][0],
      description: "",
      allWCMAttributeMetas: [],
      WCMAttributeDefinitions: [],
      collapseTabsColumn: false,
      collapseDieSummaryColumn: false,
      pcmWatTestMethod: "sampling",
      watProbingSequence: "top_left_z_pattern",
      pcmWatSiteNumber: null,
      maxPcmWatSiteNumber: 10,
      showWATPCMSites: true,
      dieLabelDisplayMode: "reticleSite",
      selectedZoneId: null,
      waferDefinitionData: {
        version: 1, // only for frontend
        waferMaxCols: 0,
        waferMaxRows: 0,
        waferRowOffset: 0,
        waferColOffset: 0,
        calculationMethod: CalculationMethod.AUTO,
        waferDiameterUOM: UOMs[1][0],
        waferEdgeExclusionUOM: UOMs[0][0],
        waferFlatKeepOutUOM: UOMs[0][0],
        waferNotchKeepOutUOM: UOMs[0][0],
        waferBaseFlatUOM: UOMs[0][0],
        waferScribeLineUOM: UOMs[0][0],
        waferDiameter: +DIAMETERS(UOMs[1][0])[4][0],
        waferEdgeExclusion: 0,
        waferFlatKeepOut: 0,
        waferNotchKeepOut: 0,
        waferBaseFlat: 0,
        waferScribeLine: 0,
        waferInputNotchPosition: NOTCH_POSITIONS[1][0],
        waferOutputNotchPosition: NOTCH_POSITIONS[0][0],
        waferOriginLocation: WaferOriginLocation.UPPER_LEFT,
        waferAxisDirection: WaferAxisDirection.DOWN_RIGHT,
        xOriginValue: 0,
        yOriginValue: 0,
        waferPGDW: 0,
        dieUOM: UOMs[3][0],
        dieSpecType: DieSpecType.BOTH,
        dieSizeX: 2,
        dieSizeY: 2,
        dieStepSizeX: 3,
        dieStepSizeY: 3,
        reticleUOM: UOMs[0][0],
        reticleSizeX: 2,
        reticleSizeY: 2,
        reticleOffsetX: 0,
        reticleOffsetY: 0,
        reticleReference: "CENTER",
        standardReticle: {
          WATPCMSite: STANDARD_RETICLE_WATPCM_SITE_LIST[0][0],
          reticle: [],
          siteAttributesData: [],
          hasSiteAttributes: false,
          reticleSiteAttributesMeta: [],
        },
        exclusionType: ExclusionType.NONE,
        edgeDieThreshold: 0,
      },
      zones: [],
      orignalWaferDimensions: { height: 0, width: 0 },
      ringPanOffsetXMultiplier: 0,
      ringPanOffsetYMultiplier: 0,
      ringDiameterToWaferDiameterRatio: 1,
      drawLayout: {
        ringSize: 0,
        ringUOM: UOMs[0][0],
        increment: 1,
        incrementUOM: UOMs[0][0],
        overlayReticle: false,
        markWaferCenter: true,
        drawLayoutPanResizeMode: DrawLayoutPanResizeMode.RING,
        showReferenceReticle: false,
        showRing: false,
      },
      pcmWatSiteMapTabData: {
        reticleCalculationMethod: ReticleCalculationMethod.ROWS_COLS,
        maxReticleCols: 0,
        maxReticleRows: 0,
        panIncrement: 1,
        panIncrementUOM: reticleIncrementUOMs[0][0],
        panMode: ReticlePanMode.SELECTED,
      },
      activeTab: ActiveTab.WAFER_DEFINTION,
      middleViewport: MiddleViewport.WAFER,
      waferMapConfig: null,
      currentDieTypeId: null,
      dieTypes: [],
      enabledDieTypes: {},
      isInsertDieControlActive: false,
      isDeleteModeActive: false,
      memoryDetails: {
        name: "",
        rows: 484,
        columns: 512,
      },
      patternDefinition: {
        singleRowFailureBits: null,
        singleColumnFailureBits: null,
        partialRowFailureBits: null,
        partialColumnFailureBits: null
  },
  partialRowFailureBitsType: 'Count',
  partialColumnFailureBitsType: 'Count',
      drawPattern: {
        inputRows: 40,
        inputCols: 50,
        patterns: [],
        activePatternIndex: -1,
        isDrawing: false,
        drawState: true,
        isEraserMode: false,
      },
    };
  }

  setWaferInstanceHandler = (utils: WaferUtils) => {
    this.deviceWafer = utils;
    this.setSubsribers();
    // synchronize enabled die types with wafer variables when wafer instance is ready
    if (this.state.enabledDieTypes) {
      this.changeWaferMapVariable({ enabledDieTypes: this.state.enabledDieTypes }, true);
    }
    // Ensure reticle origin start position values are set when wafer instance is ready
    // This is especially important when loading from backend with overlayReticle already true
    const { waferDefinitionData, drawLayout } = this.state;
    if (drawLayout && drawLayout.overlayReticle && waferDefinitionData) {
      const reticleOriginStartX = waferDefinitionData.reticleOriginStartX !== undefined && 
                                  waferDefinitionData.reticleOriginStartX !== null && 
                                  waferDefinitionData.reticleOriginStartX !== '' 
                                  ? Number(waferDefinitionData.reticleOriginStartX) 
                                  : undefined;
      const reticleOriginStartY = waferDefinitionData.reticleOriginStartY !== undefined && 
                                  waferDefinitionData.reticleOriginStartY !== null && 
                                  waferDefinitionData.reticleOriginStartY !== '' 
                                  ? Number(waferDefinitionData.reticleOriginStartY) 
                                  : undefined;
      if (reticleOriginStartX !== undefined || reticleOriginStartY !== undefined) {
        this.changeWaferMapVariable({
          reticleOriginStartX,
          reticleOriginStartY,
        }, true);
      }
    }
  };

  onDieTypeToggle = (dieTypeId: string, enabled: boolean) => {
    this.setState((prevState: WaferControlMapState) => {
      const newEnabled = { ...(prevState.enabledDieTypes || {}) };
      newEnabled[dieTypeId] = enabled;
      const newCurrentDieTypeId = !enabled && prevState.currentDieTypeId === dieTypeId ? null : prevState.currentDieTypeId;
      return { enabledDieTypes: newEnabled, currentDieTypeId: newCurrentDieTypeId } as unknown as WaferControlMapState;
    }, () => {
      const currentDieType = this.state.currentDieTypeId;
      // If disabling, clear selection for dies of that type so they are not left selected
      if (!enabled && this.deviceWafer) {
        // defensively clone waferData; guard against missing structures
        const waferData = _.cloneDeep(this.deviceWafer.waferMapVariables?.waferData ?? null);

        if (!waferData || !Array.isArray(waferData.dies)) {
          // Nothing to clear; still notify renderer of enabledDieTypes change
          this.changeWaferMapVariable(
            { enabledDieTypes: this.state.enabledDieTypes, currentDieType },
            true,
          );
          return;
        }

        for (let i = 0; i < waferData.dies.length; i += 1) {
          const row = waferData.dies[i];
          if (!Array.isArray(row)) continue;
          for (let j = 0; j < row.length; j += 1) {
            const die = row[j];
            if (die && die.dieType === dieTypeId) {
              die.isSelected = false;
              die.isUnderSelection = false;
            }
          }
        }
        this.changeWaferMapVariable(
          { enabledDieTypes: this.state.enabledDieTypes, currentDieType, waferData },
          true,
        );
      } else {
        this.changeWaferMapVariable(
          { enabledDieTypes: this.state.enabledDieTypes, currentDieType },
          true,
        );
      }
    });
  };

  hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : {
          r: 0,
          g: 0,
          b: 0,
        };
  };

  loadAttributeMetaAndDefinitions = async (
    loadWhat: "meta" | "def" | "both" = "both",
  ) => {
    const { match } = this.props;
    let wcmAttributeDefinitionResponse: any = null;
    let wcmAttributeMetaResponse: any = null;
    if (loadWhat === "both" || loadWhat === "meta") {
      wcmAttributeMetaResponse =
        await httpWaferControlMap.getWaferControlMapAttributeMetas();
    }
    if (
      match.params.id !== undefined &&
      (loadWhat === "both" || loadWhat === "def")
    ) {
      wcmAttributeDefinitionResponse =
        await httpWaferControlMap.getWaferControlMapAttributeDefinitions(
          match.params.id,
        );
    }
    const newState: any = {};
    if (loadWhat === "both" || loadWhat === "def") {
      newState.WCMAttributeDefinitions = [];
    }
    if (loadWhat === "both" || loadWhat === "meta") {
      newState.allWCMAttributeMetas = [];
    }

    if (
      wcmAttributeMetaResponse &&
      wcmAttributeMetaResponse.success &&
      wcmAttributeMetaResponse.statusCode === 200
    ) {
      newState.allWCMAttributeMetas = wcmAttributeMetaResponse.data;
    }
    if (
      wcmAttributeDefinitionResponse &&
      wcmAttributeDefinitionResponse.success &&
      wcmAttributeDefinitionResponse.statusCode === 200
    ) {
      newState.WCMAttributeDefinitions = this.mapAttributeDefinitions(
        wcmAttributeDefinitionResponse.data,
      );
    }
    return newState;
  };

  loadDataFromBackend = async () => {
    this.setState({ isLoading: true }, async () => {
      const { match, history } = this.props;
      let wcmDataResponse: any = null;
      if (match.params.id !== undefined) {
        wcmDataResponse = await httpWaferControlMap.getWaferControlMap(
          match.params.id,
        );
        this.isUpdateWCM = true;
      }
      const dieTypesResponse = await httpDieType.getDieTypes(match.params.id);
      const attrMetaAndDefs = await this.loadAttributeMetaAndDefinitions();
      let isWaferDataLoadedSuccessfully = false;
      this.setState(
        (prevState: WaferControlMapState) => {
          const newState: any = {
            isLoading: false,
            allWCMAttributeMetas: prevState.allWCMAttributeMetas,
            WCMAttributeDefinitions: prevState.WCMAttributeDefinitions,
            zones: prevState.zones,
            dieTypes: prevState.dieTypes,
            currentDieTypeId: prevState.currentDieTypeId,
            ringDiameterToWaferDiameterRatio:
              prevState.ringDiameterToWaferDiameterRatio,
            middleViewport: prevState.middleViewport,
            orignalWaferDimensions: prevState.orignalWaferDimensions,
            waferMapConfig: prevState.waferMapConfig,
            waferDefinitionData: prevState.waferDefinitionData,
            drawLayout: prevState.drawLayout,
            name: prevState.name,
            owner: prevState.owner,
            version: prevState.version,
            access: prevState.access,
            state: prevState.state,
            description: prevState.description,
            facility: prevState.facility,
            workCenter: prevState.workCenter,
            programName: prevState.programName,
            lotId: prevState.lotId,
            waferId: prevState.waferId,
            memoryDetails: prevState.memoryDetails,
            patternDefinition: prevState.patternDefinition,
          };

          if (
            dieTypesResponse &&
            dieTypesResponse.success &&
            dieTypesResponse.statusCode === 200
          ) {
            newState.dieTypes = this.normalizeDieTypes(dieTypesResponse.data);
            newState.currentDieTypeId =
              newState.dieTypes.length > 0 ? newState.dieTypes[0].id : null;
            // initialize enabled map (all enabled by default)
            const enabledMap: { [key: string]: boolean } = {};
            newState.dieTypes.forEach((dt: DieType) => { enabledMap[dt.id] = true; });
            newState.enabledDieTypes = enabledMap;
          }
          newState.allWCMAttributeMetas = attrMetaAndDefs.allWCMAttributeMetas;
          newState.WCMAttributeDefinitions =
            attrMetaAndDefs.WCMAttributeDefinitions;
          if (
            wcmDataResponse &&
            wcmDataResponse.success &&
            wcmDataResponse.statusCode === 200
          ) {
            isWaferDataLoadedSuccessfully = true;
            const waferDefinitionData: WaferDefinitionData = {
              calculationMethod: CalculationMethod[
                wcmDataResponse.data.drawMethod
              ] as unknown as CalculationMethod,
              dieSizeX: wcmDataResponse.data.dieWidth,
              dieSizeY: wcmDataResponse.data.dieHeight,
              dieSpecType: DieSpecType[
                wcmDataResponse.data.dieDimensionType
              ] as unknown as DieSpecType,
              waferEdgeExclusionUOM: wcmDataResponse.data.edgeExclusionUOM,
              dieStepSizeX: wcmDataResponse.data.dieStepWidth,
              dieStepSizeY: wcmDataResponse.data.dieStepHeight,
              reticleOffsetX: wcmDataResponse.data.reticleOffsetX,
              reticleOffsetY: wcmDataResponse.data.reticleOffsetY,
              dieUOM: wcmDataResponse.data.dieUOM,
              exclusionType: ExclusionType[
                wcmDataResponse.data.exclusionOption
              ] as unknown as ExclusionType,
              reticleReference: wcmDataResponse.data.reticleReference,
              reticlePlotSequence: wcmDataResponse.data.reticlePlotSequence || ReticlePlotSequence.HORIZONTAL_LEFT_TO_RIGHT,
              reticleNumberStartX: wcmDataResponse.data.reticleNumberStartX,
              reticleNumberStartY: wcmDataResponse.data.reticleNumberStartY,
              reticleOriginStartX: wcmDataResponse.data.reticleOriginStartX,
              reticleOriginStartY: wcmDataResponse.data.reticleOriginStartY,
              reticleSizeX: wcmDataResponse.data.reticleCols,
              reticleSizeY: wcmDataResponse.data.reticleRows,
              reticleUOM: wcmDataResponse.data.reticleUOM,
              waferAxisDirection: WaferAxisDirection[
                wcmDataResponse.data.axisDirection
              ] as unknown as WaferAxisDirection,
              waferBaseFlat: wcmDataResponse.data.baseFlat,
              waferBaseFlatUOM: wcmDataResponse.data.baseFlatUOM,
              waferColOffset: wcmDataResponse.data.axisOffsetX,
              waferDiameter: wcmDataResponse.data.diameter,
              waferDiameterUOM: wcmDataResponse.data.diameterUOM,
              waferEdgeExclusion: wcmDataResponse.data.edgeExclusion,
              waferFlatKeepOut: wcmDataResponse.data.flatKeepOut,
              waferFlatKeepOutUOM: wcmDataResponse.data.flatKeepOutUOM,
              waferInputNotchPosition: wcmDataResponse.data.inputNotchPosition,
              waferOutputNotchPosition:
                wcmDataResponse.data.outputNotchPosition,
              waferMaxCols: wcmDataResponse.data.fixedCols,
              waferMaxRows: wcmDataResponse.data.fixedRows,
              waferNotchKeepOut: wcmDataResponse.data.notchKeepOut,
              waferNotchKeepOutUOM: wcmDataResponse.data.notchKeepOutUOM,
              waferOriginLocation: WaferOriginLocation[
                wcmDataResponse.data.originLocation
              ] as unknown as WaferOriginLocation,
              xOriginValue: wcmDataResponse.data.xOriginValue ?? 0,
              yOriginValue: wcmDataResponse.data.yOriginValue ?? 0,
              waferPGDW: wcmDataResponse.data.pgdw,
              waferRowOffset: wcmDataResponse.data.axisOffsetY,
              waferScribeLine: wcmDataResponse.data.scribeLine,
              waferScribeLineUOM: wcmDataResponse.data.scribeLineUOM,
              version: 1,
              standardReticle: {
                WATPCMSite: wcmDataResponse.data.reticleWATPCMSite,
                reticle: this.getStandardReticleEditorReticle(
                  wcmDataResponse.data.reticleSites,
                ),
                siteAttributesData: this.getSiteAttributesData(
                  wcmDataResponse.data.reticleSiteAttributeMappings,
                  wcmDataResponse.data.reticleSiteAttributes,
                ),
                hasSiteAttributes: wcmDataResponse.data.hasSiteAttributes,
                reticleSiteAttributesMeta:
                  wcmDataResponse.data.reticleSiteAttributes.map((rsa: any) => {
                    return {
                      ...rsa,
                      columnMeta: {
                        ...rsa.columnMeta,
                        type: MetaColumnType[
                          rsa.columnMeta.type
                        ] as unknown as MetaColumnType,
                      },
                    };
                  }),
              },
              edgeDieThreshold: wcmDataResponse.data.threshold,
            };
            const waferDiameter = UtilityFunctions.toBaseUnit({
              value: waferDefinitionData.waferDiameter,
              UOM: waferDefinitionData.waferDiameterUOM,
              isDiameter: true,
            });
            const waferEdgeExclusion = UtilityFunctions.toBaseUnit({
              value: waferDefinitionData.waferEdgeExclusion,
              UOM: waferDefinitionData.waferEdgeExclusionUOM,
            });
            const dieStepSizeX = UtilityFunctions.toBaseUnit({
              value: waferDefinitionData.dieStepSizeX,
              UOM: waferDefinitionData.dieUOM,
            });
            const dieStepSizeY = UtilityFunctions.toBaseUnit({
              value: waferDefinitionData.dieStepSizeY,
              UOM: waferDefinitionData.dieUOM,
            });

            const newDrawLayout = _.cloneDeep(prevState.drawLayout);
            newDrawLayout.overlayReticle = wcmDataResponse.data.overlayReticle;
            newDrawLayout.showReferenceReticle =
              wcmDataResponse.data.overlayReticle &&
              waferDefinitionData.calculationMethod ===
                CalculationMethod.RETICLE;
            Object.assign(
              newDrawLayout,
              this.applyWaferDiameterToDrawLayout(newDrawLayout, waferDefinitionData),
            );
            newDrawLayout.showRing = false;
            const dies = this.getDies2D(
              wcmDataResponse.data.dies,
              waferDefinitionData.standardReticle,
            );
            const maxRowsAndCols = UtilityFunctions.getMaxRowsAndCols(dies);
            const reticleData = this.getReticleGridRectCoords(
              wcmDataResponse.data.reticles,
            );
            waferDefinitionData.version =
              prevState.waferDefinitionData.version + 1;

            newState.zones = wcmDataResponse.data.zones.map(
              (z: any): ZoneData => {
                return {
                  id: z.id,
                  zoneName: z.name,
                  zoneType: z.type,
                  markedPCMSiteNumbers: z.markedPCMSiteNumbers,
                  numberOfZones: z.numberOfZones,
                  zoneApplication: z.zoneApplication,
                  createdBy: z.createdBy,
                  createdOn: z.createdOn,
                  updatedBy: z.updatedBy,
                  updatedOn: z.updatedOn,
                  horizontalZoneRowNumbers: z.horizontalZoneRowNumbers,
                  verticalZoneColNumbers: z.verticalZoneColNumbers,
                  xcoords: z.xCoords,
                  ycoords: z.yCoords,
                };
              },
            );
            newState.ringDiameterToWaferDiameterRatio =
              (waferDiameter - 2 * waferEdgeExclusion) / waferDiameter;
            newState.middleViewport = MiddleViewport.WAFER;
            newState.orignalWaferDimensions = {
              height: wcmDataResponse.data.waferHeightOrignal,
              width: wcmDataResponse.data.waferWidthOrignal,
            };
            newState.waferMapConfig = {
              data: {
                dies,
                waferMaxRows: maxRowsAndCols.maxRows,
                waferMaxCols: maxRowsAndCols.maxCols,
              },
              reticleGridRectCoords: reticleData.reticleGridRectCoords,
              referenceReticleGridRectCoords:
                reticleData.referenceReticleGridRectCoords,
              dieSize: {
                dieWidth:
                  dieStepSizeX > dieStepSizeY
                    ? 32 * (dieStepSizeX / dieStepSizeY)
                    : 32,
                dieHeight:
                  dieStepSizeY > dieStepSizeX
                    ? 32 * (dieStepSizeY / dieStepSizeX)
                    : 32,
              },
              showDieText:
                waferDefinitionData.calculationMethod ===
                CalculationMethod.RETICLE,
              reticleSize: {
                x:
                  waferDefinitionData.standardReticle.reticle.length > 0
                    ? waferDefinitionData.standardReticle.reticle[0].length
                    : 0,
                y: waferDefinitionData.standardReticle.reticle.length,
              },
              dieTextField:
                waferDefinitionData.calculationMethod ===
                CalculationMethod.RETICLE
                  ? "reticleSite"
                  : "",
              dieWidthToStreetWidthRatio:
                wcmDataResponse.data.dieWidth ===
                wcmDataResponse.data.dieStepWidth
                  ? Infinity
                  : wcmDataResponse.data.dieWidthToStreetWidthRatio,
              dieHeightToStreetHeightRatio:
                wcmDataResponse.data.dieHeight ===
                wcmDataResponse.data.dieStepHeight
                  ? Infinity
                  : wcmDataResponse.data.dieHeightToStreetHeightRatio,
              waferWidthToColsRatio: wcmDataResponse.data.waferWidthToColsRatio,
              waferHeightToRowsRatio:
                wcmDataResponse.data.waferHeightToRowsRatio,
              waferBGOffsetXDies: wcmDataResponse.data.waferBGOffsetXDies,
              waferBGOffsetYDies: wcmDataResponse.data.waferBGOffsetYDies,
            };
            newState.waferDefinitionData = waferDefinitionData;
            if (waferDefinitionData.calculationMethod === CalculationMethod.RETICLE) {
              const maxReticleLayout = UtilityFunctions.getPcmWatMaxReticleRowsCols({
                waferDefinitionData,
                waferMapConfig: newState.waferMapConfig,
              });
              if (maxReticleLayout.maxReticleRows > 0 && maxReticleLayout.maxReticleCols > 0) {
                newState.pcmWatSiteMapTabData = {
                  ...prevState.pcmWatSiteMapTabData,
                  maxReticleRows: maxReticleLayout.maxReticleRows,
                  maxReticleCols: maxReticleLayout.maxReticleCols,
                };
              }
            }
            newState.drawLayout = newDrawLayout;
            newState.name = wcmDataResponse.data.name;
            newState.owner = wcmDataResponse.data.owner;
            newState.version = wcmDataResponse.data.version;
            newState.access = wcmDataResponse.data.access;
            newState.state = wcmDataResponse.data.state;
            newState.description = wcmDataResponse.data.description;
            // Load metadata fields from API response
            if (wcmDataResponse.data.facility !== undefined) {
              newState.facility = wcmDataResponse.data.facility;
            }
            if (wcmDataResponse.data.workCenter !== undefined) {
              newState.workCenter = wcmDataResponse.data.workCenter;
            }
            if (wcmDataResponse.data.programName !== undefined) {
              newState.programName = wcmDataResponse.data.programName;
            }
            if (wcmDataResponse.data.lotId !== undefined) {
              newState.lotId = wcmDataResponse.data.lotId;
            }
            if (wcmDataResponse.data.waferId !== undefined) {
              newState.waferId = wcmDataResponse.data.waferId;
            }
            if (wcmDataResponse.data.memoryDetails != null) {
              newState.memoryDetails = {
                ...prevState.memoryDetails,
                ...wcmDataResponse.data.memoryDetails,
              };
            }
            if (wcmDataResponse.data.patternDefinition != null) {
              newState.patternDefinition = {
                ...prevState.patternDefinition,
                ...wcmDataResponse.data.patternDefinition,
              };
              newState.partialRowFailureBitsType =
                typeof newState.patternDefinition.partialRowFailureBits === "string" &&
                newState.patternDefinition.partialRowFailureBits.endsWith("%")
                  ? "Percentage"
                  : "Count";
              newState.partialColumnFailureBitsType =
                typeof newState.patternDefinition.partialColumnFailureBits === "string" &&
                newState.patternDefinition.partialColumnFailureBits.endsWith("%")
                  ? "Percentage"
                  : "Count";
            }

            if (wcmDataResponse.data.complexPatterns && Array.isArray(wcmDataResponse.data.complexPatterns)) {
              const patternsMap = new Map<string, any[]>();
              wcmDataResponse.data.complexPatterns.forEach((p: any) => {
                if (p.deviceID) {
                  if (!patternsMap.has(p.deviceID)) {
                    patternsMap.set(p.deviceID, []);
                  }
                  patternsMap.get(p.deviceID)!.push(p);
                }
              });

              const patterns: any[] = [];
              patternsMap.forEach((points, deviceID) => {
                let maxRow = 0;
                let maxCol = 0;
                points.forEach((p: any) => {
                  if (p.y > maxRow) maxRow = p.y;
                  if (p.x > maxCol) maxCol = p.x;
                });
                const MAX_PATTERN_DIMENSION = 1000;
                const rows = maxRow + 1;
                const cols = maxCol + 1;
                if (
                  rows <= 0 ||
                  cols <= 0 ||
                  rows > MAX_PATTERN_DIMENSION ||
                  cols > MAX_PATTERN_DIMENSION
                ) {
                  toast.warning(
                    `Pattern "${deviceID}" is out of supported bounds (${MAX_PATTERN_DIMENSION}x${MAX_PATTERN_DIMENSION}).`,
                  );
                  return;
                }

                const grid: boolean[][] = [];
                for (let r = 0; r < rows; r++) {
                  grid.push(new Array(cols).fill(false));
                }

                points.forEach((p: any) => {
                  if (p.isSelected && p.y >= 0 && p.y < rows && p.x >= 0 && p.x < cols) {
                    grid[p.y][p.x] = true;
                  }
                });

                patterns.push({
                  id: deviceID,
                  rows,
                  cols,
                  grid,
                });
              });

              newState.drawPattern = {
                ...prevState.drawPattern,
                patterns,
                activePatternIndex: patterns.length > 0 ? 0 : -1,
              };
            }
          }
          return newState;
        },
        () => {
          if (isWaferDataLoadedSuccessfully) {
            this.addWafer(true);
          } else {
            if (wcmDataResponse) toast.error(wcmDataResponse.message);
            history.push("/wafer-control-map");
          }
          // push enabled die types to wafer variables if available
          if (this.state.enabledDieTypes) {
            this.changeWaferMapVariable({ enabledDieTypes: this.state.enabledDieTypes }, true);
          }
        },
      );
    });
  };

  resizeHandler = () => {
    if (this.waferDiv) {
      const newWidth = this.waferDiv.offsetWidth;
      if (newWidth !== this.canvasDimension && newWidth > 0) {
        this.canvasDimension = newWidth;
        this.updateCanvasDimensions();
      }
    }
  };

  async componentDidMount() {
    // Add resize listener for responsive behavior
    window.addEventListener('resize', this.resizeHandler);

    // Check if we have parsed file data from location state
    const locationState = (this.props as any).location?.state;
    if (locationState?.parsedFileData) {
      await this.populateFromParsedFile(locationState.parsedFileData);
    } else {
      await this.loadDataFromBackend();
    }

    // Setup dimensions and observers after DOM is ready
    // Using requestAnimationFrame ensures DOM has been updated after async data loading
    requestAnimationFrame(() => {
      if (this.waferDiv) {
        this.canvasDimension = this.waferDiv.offsetWidth;
        this.updateCanvasDimensions();
        
        // Use ResizeObserver for more accurate container size tracking
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => {
            this.resizeHandler();
          });
          this.resizeObserver.observe(this.waferDiv);
        }
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // Clean up grid-related intervals and observers
    if ((this as any)._editModeCheckInterval) {
      clearInterval((this as any)._editModeCheckInterval);
      (this as any)._editModeCheckInterval = null;
    }

    if ((this as any)._commandColumnObserver) {
      (this as any)._commandColumnObserver.disconnect();
      (this as any)._commandColumnObserver = null;
    }

    // Clean up scroll tracking
    clearTimeout(this.scrollTimeoutId);
    this.scrollTimeoutId = null;
  }

  // Helper function to find closest wafer diameter option

  mapFlatProbedToNotchPosition = (flatProbed: any) => {
    if (flatProbed === undefined || flatProbed === null) return "DOWN";

    // Handle numeric values
    const numVal = Number(flatProbed);
    if (!isNaN(numVal)) {
      // 0=BOTTOM/DOWN, 90=RIGHT, 180=TOP/UP, 270=LEFT
      if (numVal === 0) return "DOWN";
      if (numVal === 90) return "RIGHT";
      if (numVal === 180) return "UP";
      if (numVal === 270) return "LEFT";
    }

    // Handle string values
    if (typeof flatProbed === "string") {
      const upperVal = flatProbed.toUpperCase();
      if (upperVal.includes("RIGHT") || upperVal.includes("3")) return "RIGHT";
      if (upperVal.includes("LEFT") || upperVal.includes("9")) return "LEFT";
      if (upperVal.includes("UP") || upperVal.includes("TOP") || upperVal.includes("12")) return "UP";
      if (upperVal.includes("DOWN") || upperVal.includes("BOTTOM") || upperVal.includes("6")) return "DOWN";
    }

    return "DOWN";
  };

  /**
   * Returns human-readable names for parameters that were missing or invalid in the imported file.
   * Used only for the informational toast; does not affect any other logic.
   * Treats 0 / "0" / null / "" as missing.
   */
  getMissingParamsFromFile = (metadata: any): string[] => {
    if (!metadata) {
      return ['Wafer size', 'Die width', 'Die height', 'First die (reference die)'];
    }
    const missing: string[] = [];
    const hasWaferSize = metadata.waferSize != null && metadata.waferSize !== '' && Number(metadata.waferSize) > 0;
    if (!hasWaferSize) missing.push('Wafer size');
    const hasDieWidth = metadata.xSize != null && metadata.xSize !== '' && Number(metadata.xSize) > 0;
    const hasDieHeight = metadata.ySize != null && metadata.ySize !== '' && Number(metadata.ySize) > 0;
    if (!hasDieWidth) missing.push('Die width');
    if (!hasDieHeight) missing.push('Die height');
    const hasReferenceDie = metadata.referenceDie != null && String(metadata.referenceDie).trim() !== '';
    if (!hasReferenceDie) missing.push('First die (reference die)');
    return missing;
  };

  populateFromParsedFile = async (parsedFileData: any) => {
    this.setState({ isLoading: true }, async () => {
      const dieTypesResponse = await httpDieType.getDieTypes();
      const attrMetaAndDefs = await this.loadAttributeMetaAndDefinitions();

      const { metadata } = parsedFileData;
      const { rows, columns } = metadata;

      // Only for toast message and for applying defaults consistently (0/"0" = use default)
      const missingParams = this.getMissingParamsFromFile(metadata);
      const hasWaferSize = !missingParams.includes('Wafer size');
      const hasDieWidth = !missingParams.includes('Die width');
      const hasDieHeight = !missingParams.includes('Die height');

      // Find closest diameter option in inches
      let selectedWaferDiameter = 8; // Default to 8 inches (approximately 200mm)
      if (hasWaferSize && metadata?.waferSize != null && metadata.waferSize !== '' && Number(metadata.waferSize) > 0) {
        selectedWaferDiameter = commonFunctions.findClosestWaferDiameter(
          metadata.waferSize,
          "INCHES",
        );
      }

      // Populate state with parsed data
      this.setState(
        (prevState: WaferControlMapState) => {
          const newState: any = {
            isLoading: false,
            allWCMAttributeMetas: attrMetaAndDefs.allWCMAttributeMetas,
            WCMAttributeDefinitions: attrMetaAndDefs.WCMAttributeDefinitions,
            zones: prevState.zones,
            dieTypes: prevState.dieTypes,
            currentDieTypeId: prevState.currentDieTypeId,
            ringDiameterToWaferDiameterRatio:
              prevState.ringDiameterToWaferDiameterRatio,
            middleViewport: prevState.middleViewport,
            orignalWaferDimensions: prevState.orignalWaferDimensions,
            waferMapConfig: prevState.waferMapConfig,
            drawLayout: prevState.drawLayout,
            // Populate header fields
            lotId: metadata.lotId || prevState.lotId,
            waferId: metadata.waferId || prevState.waferId,
            memoryDetails: prevState.memoryDetails,
            patternDefinition: prevState.patternDefinition,
            name: metadata.productId || prevState.name, // PRODUCT ID maps to name field
            programName: metadata.productId ? `${metadata.productId}_TP` : prevState.programName, // programName is deviceName_TP
            facility: prevState.facility,
            workCenter: prevState.workCenter,
            owner: prevState.owner,
            version: prevState.version,
            access: prevState.access,
            state: prevState.state,
            description: prevState.description,
            // Update wafer definition data
            waferDefinitionData: {
              ...prevState.waferDefinitionData,
              calculationMethod: CalculationMethod.ROWS_COLS, // Use Fixed Rows/Cols method
              waferMaxRows: rows || prevState.waferDefinitionData.waferMaxRows,
              waferMaxCols:
                columns || prevState.waferDefinitionData.waferMaxCols,
              // Populate from metadata when present (0/"0" = use default)
              waferDiameter: hasWaferSize
                ? commonFunctions.findClosestWaferDiameter(
                    metadata.waferSize,
                    "INCHES",
                  )
                : 8,
              waferDiameterUOM: hasWaferSize
                ? UOMs[1][0]
                : prevState.waferDefinitionData.waferDiameterUOM || UOMs[1][0],
              dieSizeX: hasDieWidth
                ? Number(metadata.xSize)
                : prevState.waferDefinitionData.dieSizeX,
              dieSizeY: hasDieHeight
                ? Number(metadata.ySize)
                : prevState.waferDefinitionData.dieSizeY,
              dieStepSizeX: hasDieWidth
                ? parseFloat((Number(metadata.xSize) * 1.05).toFixed(3))
                : prevState.waferDefinitionData.dieStepSizeX,
              dieStepSizeY: hasDieHeight
                ? parseFloat((Number(metadata.ySize) * 1.05).toFixed(3))
                : prevState.waferDefinitionData.dieStepSizeY,
              // Map FLAT_NOTCH_LOCATION from file to notch position
              // flatProbed values: 0=BOTTOM/DOWN, 90=RIGHT, 180=TOP/UP, 270=LEFT
              waferInputNotchPosition:
                metadata.flatProbed !== undefined
                  ? this.mapFlatProbedToNotchPosition(
                      metadata.flatProbed,
                    )
                  : prevState.waferDefinitionData.waferInputNotchPosition,
              waferOutputNotchPosition: NOTCH_POSITIONS[0][0],
              xOriginValue: 0,
              yOriginValue: 0,
            },
            // Store parsed characters for later use
            parsedFileData,
          };

          if (
            dieTypesResponse &&
            dieTypesResponse.success &&
            dieTypesResponse.statusCode === 200
          ) {
            const normalizedDieTypes = this.normalizeDieTypes(dieTypesResponse.data);

            // Apply bin values from parsed file to die types
            if (parsedFileData.dieTypeMappingArray && Array.isArray(parsedFileData.dieTypeMappingArray)) {
              const dieTypesToUpdate: DieType[] = [];

              parsedFileData.dieTypeMappingArray.forEach((mapping: any) => {
                if (mapping.dieType) {
                  const dieTypeName = String(mapping.dieType).trim();
                  const hardBin = mapping.hardBinNo ? parseInt(mapping.hardBinNo, 10) : null;
                  const softBin = mapping.softBinNo ? parseInt(mapping.softBinNo, 10) : null;

                  if (dieTypeName && (hardBin !== null || softBin !== null)) {
                    const dieType = commonFunctions.findDieTypeByName(dieTypeName, normalizedDieTypes);
                    if (dieType) {
                      let changed = false;
                      if (hardBin !== null && !isNaN(hardBin) && dieType.hardBin !== hardBin) {
                        dieType.hardBin = hardBin;
                        changed = true;
                      }
                      if (softBin !== null && !isNaN(softBin) && dieType.softBin !== softBin) {
                        dieType.softBin = softBin;
                        changed = true;
                      }

                      if (changed && !dieTypesToUpdate.includes(dieType)) {
                        dieTypesToUpdate.push(dieType);
                      }
                    }
                  }
                }
              });

              // Persist changes to backend
              if (dieTypesToUpdate.length > 0) {
                Promise.all(dieTypesToUpdate.map(dt =>
                  httpDieType.putDieType({
                    name: dt.name,
                    color: dt.color,
                    isProbed: dt.isProbed,
                    isYielded: dt.isYielded,
                    isTouchDownAllowed: dt.isTouchDownAllowed,
                    character: dt.character,
                    hardBin: dt.hardBin,
                    softBin: dt.softBin,
                    hardBinFlag: dt.hardBinFlag,
                    softBinFlag: dt.softBinFlag
                  }, dt.id)
                )).catch(err => console.error("Failed to update die types", err));
              }
            }

            newState.dieTypes = normalizedDieTypes;
            newState.currentDieTypeId =
              newState.dieTypes.length > 0 ? newState.dieTypes[0].id : null;
          }

          return newState;
        },
        () => {
          // After state is set, draw the wafer map with the parsed data
          this.drawWaferMapFromParsedData(parsedFileData);

          // Trigger wafer definition save to draw the map after a delay to ensure state is fully updated
          setTimeout(() => {
            const currentWaferDefinitionData = this.state.waferDefinitionData;
            if (currentWaferDefinitionData) {
              this.onSaveWaferDefinitionData(currentWaferDefinitionData);
            }
            // Informational toast only: list which params were missing (reference die excluded from toast)
            const missingParamsForToast = missingParams.filter((p) => p !== 'First die (reference die)');
            if (missingParamsForToast.length > 0) {
              const part =
                missingParamsForToast.length === 1
                  ? missingParamsForToast[0]
                  : missingParamsForToast.length === 2
                    ? `${missingParamsForToast[0]} and ${missingParamsForToast[1]}`
                    : `${missingParamsForToast.slice(0, -1).join(', ')}, and ${missingParamsForToast[missingParamsForToast.length - 1]}`;
              toast.info(
                `Device map has been plotted successfully. ${part} ${missingParamsForToast.length === 1 ? 'was' : 'were'} not available in the imported file, so default values were used.`,
              );
            }
          }, 500);
        },
      );
    });
  };

  drawWaferMapFromParsedData = (parsedFileData: any) => {
    const { allCharacters, metadata } = parsedFileData;
    const { rows, columns } = metadata;

    if (!rows || !columns || !allCharacters || allCharacters.length === 0) {
      console.error("Missing required data for drawing wafer map:", {
        rows,
        columns,
        allCharactersLength: allCharacters?.length,
      });
      return;
    }

    // Create a 2D array to represent the wafer map
    const waferMap: string[][] = [];
    for (let i = 0; i < rows; i++) {
      waferMap[i] = new Array(columns).fill(" ");
    }

    // Populate the wafer map with characters from parsed data
    let charactersPlaced = 0;
    let outOfBoundsCount = 0;
    allCharacters.forEach((charData: any) => {
      const x = parseInt(charData.x, 10);
      const y = parseInt(charData.y, 10);
      if (
        !isNaN(x) &&
        !isNaN(y) &&
        y >= 0 &&
        y < rows &&
        x >= 0 &&
        x < columns
      ) {
        waferMap[y][x] = charData.char;
        charactersPlaced++;
      } else {
        outOfBoundsCount++;
      }
    });

    // Store the wafer map data for use in getWaferData
    this.setState((prevState: WaferControlMapState) => ({
      ...prevState,
      parsedWaferMapData: waferMap,
    }));
  };

  getSiteAttributesData = (
    reticleSiteAttributeMappings: {
      [siteNumber: number]: { [columnName: string]: string };
    },
    reticleSiteAttributes: ReticleSiteAttributeMeta[],
  ) => {
    const dataTypeMappings: { [columnName: string]: MetaColumnType } = {};
    for (let i = 0; i < reticleSiteAttributes.length; i += 1) {
      dataTypeMappings[reticleSiteAttributes[i].columnMeta.columnName] =
        MetaColumnType[
          reticleSiteAttributes[i].columnMeta.type
        ] as unknown as MetaColumnType;
    }
    const siteAttributesData: any[] = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const siteNumber in reticleSiteAttributeMappings) {
      const row: { [columnName: string]: any } = { siteNumber: +siteNumber };
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const columnName in reticleSiteAttributeMappings[siteNumber]) {
        const value = reticleSiteAttributeMappings[siteNumber][columnName];
        if (columnName !== "siteNumber") {
          if (dataTypeMappings[columnName] === MetaColumnType.BOOL) {
            row[columnName] = value === "true";
          } else if (dataTypeMappings[columnName] === MetaColumnType.DECIMAL) {
            row[columnName] = +value;
          } else if (dataTypeMappings[columnName] === MetaColumnType.VARCHAR) {
            row[columnName] = value;
          } else if (dataTypeMappings[columnName] === MetaColumnType.DATETIME) {
            row[columnName] = Date.parse(value);
          }
        }
      }
      siteAttributesData.push(row);
    }
    return siteAttributesData;
  };

  getDies2D = (dies: any[], standardReticle?: StandardReticle) => {
    let maxRow = -1;
    let maxCol = -1;

    for (let i = 0; i < dies.length; i += 1) {
      if (dies[i].dieRow > maxRow) {
        maxRow = dies[i].dieRow;
      }
      if (dies[i].dieCol > maxCol) {
        maxCol = dies[i].dieCol;
      }
    }

    const dies2D: Dies = [];

    for (let i = 0; i < maxRow + 1; i += 1) {
      dies2D.push([]);
      for (let j = 0; j < maxCol + 1; j += 1) {
        dies2D[i].push(null);
      }
    }
    for (let i = 0; i < dies.length; i += 1) {
      if (!dies[i].isDieNull) {
        const dieData: DieData = {
          x: dies[i].dieXCalculation,
          y: dies[i].dieYCalculation,
          xTrue: dies[i].dieX,
          yTrue: dies[i].dieY,
          referenceXUm: dies[i].referenceXUm,
          referenceYUm: dies[i].referenceYUm,
          binColor: DEFAULT_DIE_COLOR,
          isSelected: false,
          isCropped: dies[i].isCropped,
          isDeleted: dies[i].isDeleted,
          dieType: dies[i].dieType ? dies[i].dieType.id : null,
        };

        if (dies[i].reticleSubRow !== null) {
          dieData.reticleY = dies[i].reticleSubRow;
        }
        if (dies[i].reticleSubCol !== null) {
          dieData.reticleX = dies[i].reticleSubCol;
        }
        if (dies[i].zoneInfo !== null) {
          dieData.zoneInfo = dies[i].zoneInfo;
        }
        if (
          standardReticle &&
          dies[i].reticleSubRow !== null &&
          dies[i].reticleSubCol !== null
        ) {
          dieData.reticleSite =
            standardReticle.reticle[dieData.reticleY][dieData.reticleX];
        }
        dies2D[dies[i].dieRow][dies[i].dieCol] = dieData;
      }
    }
    return dies2D;
  };

  getReticleGridRectCoords = (reticles: any[]) => {
    const reticleGridRectCoords: ReticleGridRectCoords = {};
    let referenceReticleGridRectCoords: RectCoord | null = null;
    for (let i = 0; i < reticles.length; i += 1) {
      const rectCoord: RectCoord = {
        startX: reticles[i].startX,
        startY: reticles[i].startY,
        endX: reticles[i].endX,
        endY: reticles[i].endY,
      };
      if (!reticles[i].isReferenceReticle) {
        reticleGridRectCoords[JSON.stringify(rectCoord)] = {
          isSelected: false,
          isUnderSelection: false,
          watPCMSiteNumber: reticles[i].watpcmSiteNumber,
        };
      } else {
        referenceReticleGridRectCoords = rectCoord;
      }
    }
    return { reticleGridRectCoords, referenceReticleGridRectCoords };
  };

  getStandardReticleEditorReticle = (
    reticleSites: { siteRow: number; siteCol: number; siteNumber: number }[],
  ) => {
    let maxRow = -1;
    let maxCol = -1;

    for (let i = 0; i < reticleSites.length; i += 1) {
      if (reticleSites[i].siteRow > maxRow) {
        maxRow = reticleSites[i].siteRow;
      }
      if (reticleSites[i].siteCol > maxCol) {
        maxCol = reticleSites[i].siteCol;
      }
    }
    const standardReticleEditorReticle: number[][] = [];

    for (let i = 0; i < maxRow + 1; i += 1) {
      standardReticleEditorReticle.push([]);
      for (let j = 0; j < maxCol + 1; j += 1) {
        standardReticleEditorReticle[i].push(-1);
      }
    }

    for (let i = 0; i < reticleSites.length; i += 1) {
      standardReticleEditorReticle[reticleSites[i].siteRow][
        reticleSites[i].siteCol
      ] = reticleSites[i].siteNumber;
    }
    return standardReticleEditorReticle;
  };

  setSubsribers = () => {
    if (!this.deviceWafer) return;
    const ps = PublishSubscribe();
    ps.subscribeToOthersID(
      EventTypes.SELECTION_ON_WAFER,
      () => {
        if (this.state.isDeleteModeActive && this.deviceWafer) {
          this.deviceWafer.performActionAndSendResponse({
            action: ActionOnWaferData.DELETE_SELECTED_DIES,
            config: {},
          });
        } else {
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            { action: ActionOnWaferData.DEFAULT, config: {} },
            "myid",
          );
        }
      },
      DEVICE_WAFER_KEY,
      "myid",
    );
    ps.subscribeToOthersID(
      EventTypes.DIES_MARKED_ON_WAFER,
      (data: any) => {
        // This allows us to verify when renderWafer() has actually updated the data
        const previousDieTypeCountInfo = this.deviceWafer
          ? _.cloneDeep(this.deviceWafer.waferMapVariables.dieTypeCountInfo)
          : {};
        
        this.setState((prevState: WaferControlMapState) => {
          const newWaferDefinitionData = _.cloneDeep(
            prevState.waferDefinitionData,
          );
          newWaferDefinitionData.waferColOffset = data.colOffset;
          newWaferDefinitionData.waferRowOffset = data.rowOffset;
          newWaferDefinitionData.version += 1;
          return {
            waferDefinitionData: newWaferDefinitionData,
          };
        }, () => {
          // Poll for dieTypeCountInfo changes using requestAnimationFrame
          let frameCount = 0;
          const maxFrames = 5; 
          
          const checkForUpdate = () => {
            if (!this.deviceWafer) {
              this.forceUpdate();
              return;
            }
            
            const currentDieTypeCountInfo = this.deviceWafer.waferMapVariables.dieTypeCountInfo;
            
            // Check if dieTypeCountInfo has changed (renderWafer has completed)
            const hasChanged = !_.isEqual(previousDieTypeCountInfo, currentDieTypeCountInfo);
            
            if (hasChanged || frameCount >= maxFrames) {
              this.forceUpdate();
            } else {
              frameCount += 1;
              requestAnimationFrame(checkForUpdate);
            }
          };
          
          requestAnimationFrame(checkForUpdate);
        });
      },
      DEVICE_WAFER_KEY,
      "myid",
    );
    ps.subscribeToOthersID(
      EventTypes.WAFER_DATA_RESPONSE,
      (data: any) => {
        this.setState(
          (prevState: WaferControlMapState) => {
            const newState = {
              waferMapConfig: prevState.waferMapConfig,
              waferDefinitionData: prevState.waferDefinitionData,
            };
            if (prevState.waferMapConfig) {
              const newWaferMapConfig = _.cloneDeep(prevState.waferMapConfig);
              newWaferMapConfig.data = _.cloneDeep(data.data);
              // Sync BG offsets and ratios from waferMapVariables so that
              // reticle overlay calculations use correct values after grid changes
              if (this.deviceWafer) {
                newWaferMapConfig.waferBGOffsetXDies = this.deviceWafer.waferMapVariables.waferBGOffsetXDies;
                newWaferMapConfig.waferBGOffsetYDies = this.deviceWafer.waferMapVariables.waferBGOffsetYDies;
                newWaferMapConfig.waferHeightToRowsRatio = this.deviceWafer.waferMapVariables.waferHeightToRowsRatio;
                newWaferMapConfig.waferWidthToColsRatio = this.deviceWafer.waferMapVariables.waferWidthToColsRatio;
                // Keep the locally cached reticle layout in sync with the live plotter.
                // Die edits and grid operations mutate the plotter-owned reticle state first.
                newWaferMapConfig.reticleGridRectCoords = _.cloneDeep(
                  this.deviceWafer.waferMapVariables.reticleGridRectCoords,
                );
                newWaferMapConfig.referenceReticleGridRectCoords = _.cloneDeep(
                  this.deviceWafer.waferMapVariables.referenceReticleGridRectCoords,
                );
              }
              newState.waferMapConfig = newWaferMapConfig;
            }
            if (
              data.action === ActionOnWaferData.DELETE_ROW_COL ||
              data.action === ActionOnWaferData.SHIFT_INSERT_DIES ||
              data.action === ActionOnWaferData.INSERT_ROW_COL ||
              data.action === ActionOnWaferData.INSERT_DIE
            ) {
              newState.waferDefinitionData = _.cloneDeep(
                prevState.waferDefinitionData,
              );
              newState.waferDefinitionData.waferColOffset = data.colOffset;
              newState.waferDefinitionData.waferRowOffset = data.rowOffset;
              newState.waferDefinitionData.version += 1;
            }
            return newState;
          },
          async () => {
            await this.callActionHanler(data);
            const reticleLayoutSyncActions = [
              ActionOnWaferData.APPLY_RETICLE,
              ActionOnWaferData.PAN_RETICLE,
              ActionOnWaferData.SHIFT_INSERT_RETICLE,
              ActionOnWaferData.CROP_SELECTED_RETICLES_ON_WAFER,
            ];
            if (
              this.state.drawLayout.overlayReticle
              && reticleLayoutSyncActions.includes(data.action)
            ) {
              this.syncPcmWatMaxReticleRowsCols();
            }
            const shouldReapplyReticle = this.state.drawLayout.overlayReticle
              && (
                data.action === ActionOnWaferData.INSERT_ROW_COL
                || data.action === ActionOnWaferData.DELETE_ROW_COL
                || data.action === ActionOnWaferData.SHIFT_INSERT_DIES
                || data.action === ActionOnWaferData.SHIFT_DELETE_DIES
                || data.action === ActionOnWaferData.INSERT_DIE
              );
            if (shouldReapplyReticle) {
              const plan = UtilityFunctions.buildReticleReapplyAfterGridEdit({
                waferDefinitionData: this.state.waferDefinitionData,
                waferMapConfig: this.state.waferMapConfig,
              });
              if (!plan) {
                return;
              }
              const { changedVariables, reticleTopLeft } = plan;

              // Grid edits clear per-die reticle metadata in wafer utils; re-apply it
              // without mutating unrelated UI state (zones/selected zone, label mode).
              this.changeWaferMapVariable(changedVariables);
              if (this.state.waferMapConfig) {
                this.setState((prevState: WaferControlMapState) => ({
                  waferMapConfig: {
                    ...prevState.waferMapConfig!,
                    showDieText: changedVariables.showDieText,
                    dieTextField: changedVariables.dieTextField,
                  },
                }));
              }
              PublishSubscribe().publishWithOthersID(
                EventTypes.WAFER_DATA_REQUEST,
                {
                  action: ActionOnWaferData.APPLY_RETICLE,
                  config: {
                    reticleTopLeft,
                    preserveExistingReticleLayout: true,
                  },
                },
                "myid",
              );
            }
          },
        );
      },
      DEVICE_WAFER_KEY,
      "myid",
    );
    ps.subscribeToOthersID(
      EventTypes.WAFER_DATA_REQUEST,
      this.deviceWafer.performActionAndSendResponse,
      "myid",
      DEVICE_WAFER_KEY,
    );
    ps.subscribeToOthersID(
      EventTypes.CHANGE_WAFER_MAP_VARIABLES,
      this.deviceWafer.changeWaferMapVariables,
      "myid",
      DEVICE_WAFER_KEY,
    );
  };

  callActionHanler = async (data: any) => {
    if (this.plotter) {
      if (data.action === ActionOnWaferData.CROP) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: `${UtilityFunctions.upperToLowerCase(
              ActionOnWaferData[data.action],
            )}`,
            actionUndoMessage: `${UtilityFunctions.upperToLowerCase(
              ActionOnWaferData[data.action],
            )}`,
          },
        );
      } else if (data.action === ActionOnWaferData.INSERT_ROW_COL) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: `Insert ${data.config.dimension} ${data.config.direction}`,
            actionUndoMessage: `Insert ${data.config.dimension} ${data.config.direction}`,
          },
        );
      } else if (data.action === ActionOnWaferData.REDRAW) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Redraw dies",
            actionUndoMessage: "Redraw dies",
          },
        );
      } else if (data.action === ActionOnWaferData.SHIFT_INSERT_DIES) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: `Shift insert ${data.config.direction}`,
            actionUndoMessage: `Shift insert ${data.config.direction}`,
          },
        );
      } else if (data.action === ActionOnWaferData.DELETE_ROW_COL) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: `Delete ${data.config.dimension} ${data.config.direction}`,
            actionUndoMessage: `Delete ${data.config.dimension} ${data.config.direction}`,
          },
        );
      } else if (data.action === ActionOnWaferData.SHIFT_DELETE_DIES) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: `Shift delete ${data.config.direction}`,
            actionUndoMessage: `Shift delete ${data.config.direction}`,
          },
        );
      } else if (data.action === ActionOnWaferData.DELETE_SELECTED_DIES) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Delete selected dies",
            actionUndoMessage: "Delete selected dies",
          },
        );
      } else if (data.action === ActionOnWaferData.INSERT_DIE) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Insert die",
            actionUndoMessage: "Insert die",
          },
        );
      } else if (
        data.action === ActionOnWaferData.CROP_SELECTED_RETICLES_ON_WAFER
      ) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Crop reticles",
            actionUndoMessage: "Crop reticles",
          },
        );
      } else if (data.action === ActionOnWaferData.PAN_RETICLE) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Pan reticles",
            actionUndoMessage: "Pan reticles",
          },
        );
      } else if (data.action === ActionOnWaferData.SHIFT_INSERT_RETICLE) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Insert reticles",
            actionUndoMessage: "Insert reticles",
          },
        );
      }
    }
  };

  // Helper function to normalize die type names for matching

  getWaferData = (rows: number, cols: number) => {
    const { dieTypes, parsedWaferMapData, parsedFileData } = this.state;
    const data: Dies = [];

    // Safety check: ensure dieTypes are loaded
    if (!dieTypes || dieTypes.length === 0) {
      for (let y = 0; y < rows; y += 1) {
        data.push([]);
        for (let x = 0; x < cols; x += 1) {
          data[y].push({
            binColor: DEFAULT_DIE_COLOR,
            isSelected: false,
            isCropped: false,
            isDeleted: false,
            softBin: Math.floor(Math.random() * 1000),
            dieType: null,
          });
        }
      }
      return data;
    }

    // If we have parsed wafer map data, use it to populate dies
    if (parsedWaferMapData && parsedFileData) {
      // Create a lookup map from character to die type name using dieTypeMappingArray
      const characterToDieTypeMap: Record<string, string> = {};
      // Create a lookup map from character to bin values
      const characterToBinMap: Record<string, { hardBin: string | null; hardBinName: string | null; softBin: string | null; softBinName: string | null }> = {};
      if (
        parsedFileData.dieTypeMappingArray &&
        Array.isArray(parsedFileData.dieTypeMappingArray)
      ) {
        parsedFileData.dieTypeMappingArray.forEach((mapping: any) => {
          if (mapping.character !== undefined && mapping.dieType) {
            const dieTypeName = String(mapping.dieType).trim();
            // Add to map if dieType is not empty (including "Unidentified" if user explicitly selected it)
            if (dieTypeName !== "") {
              characterToDieTypeMap[mapping.character] = dieTypeName;
            }
          }
          // Store bin values for each character
          if (mapping.character !== undefined) {
            characterToBinMap[mapping.character] = {
              hardBin: mapping.hardBinNo || null,
              hardBinName: mapping.hardBinName || null,
              softBin: mapping.softBinNo || null,
              softBinName: mapping.softBinName || null,
            };
          }
        });
      }

      // Fallback to dieTypeMappings object if dieTypeMappingArray is not available
      const dieTypeMappings = parsedFileData.dieTypeMappings || {};

      // Find "Unassigned" die type for unmapped characters
      let unassignedDieType = dieTypes.find(
        (dt: DieType) => dt.name.toLowerCase() === "unassigned",
      );

      // If "Unassigned" is not found, try to find a suitable fallback
      if (!unassignedDieType) {
        // Try to find "Probed Die" or any probed die type as fallback
        unassignedDieType =
          dieTypes.find(
            (dt: DieType) =>
              dt.name.toLowerCase().includes("probed") && dt.isProbed === true,
          ) ||
          dieTypes.find((dt: DieType) => dt.isProbed === true) ||
          dieTypes[0];
      }

      const unassignedDieTypeId = unassignedDieType
        ? unassignedDieType.id
        : null;

      // Create a fast lookup map: normalized name -> DieType object
      const dieTypeLookupMap: Record<string, DieType> = {};
      dieTypes.forEach((dt: DieType) => {
        // Add multiple keys for fast lookup
        const normalized = commonFunctions.normalizeDieTypeName(dt.name);
        dieTypeLookupMap[normalized] = dt;
        dieTypeLookupMap[dt.name.toLowerCase().trim()] = dt; // Also add exact lowercase match
        dieTypeLookupMap[dt.name] = dt; // And exact match
      });

      // Clear cache before processing
      commonFunctions.clearDieTypeMatchCache();

      // Track die type matching results (for internal tracking)
      const dieTypeMatchResults: Record<
        string,
        { requested: string; found: string | null; foundId: string | null }
      > = {};

      for (let y = 0; y < rows; y += 1) {
        data.push([]);
        for (let x = 0; x < cols; x += 1) {
          const char =
            parsedWaferMapData[y] && parsedWaferMapData[y][x]
              ? parsedWaferMapData[y][x]
              : " ";

          // Get die type name from mapping array ONLY if character is mapped
          let dieTypeName: string | null = null;
          let dieTypeId: string | null = null;

          if (characterToDieTypeMap[char]) {
            // Character is mapped in dieTypeMappingArray
            dieTypeName = characterToDieTypeMap[char];
            const trimmedDieTypeName = dieTypeName.trim();

            // Try fast lookup first (exact match)
            let foundDieType: DieType | undefined =
              dieTypeLookupMap[trimmedDieTypeName] ||
              dieTypeLookupMap[trimmedDieTypeName.toLowerCase()];

            // If not found, use the improved findDieTypeByName helper
            if (!foundDieType) {
              foundDieType =
                commonFunctions.findDieTypeByName(
                  trimmedDieTypeName,
                  dieTypes,
                ) || undefined;
            }

            if (foundDieType) {
              dieTypeId = foundDieType.id;
              // Track match result
              if (!dieTypeMatchResults[trimmedDieTypeName]) {
                dieTypeMatchResults[trimmedDieTypeName] = {
                  requested: trimmedDieTypeName,
                  found: foundDieType.name,
                  foundId: foundDieType.id,
                };
              }
            } else {
              // Track failed match
              if (!dieTypeMatchResults[trimmedDieTypeName]) {
                dieTypeMatchResults[trimmedDieTypeName] = {
                  requested: trimmedDieTypeName,
                  found: null,
                  foundId: null,
                };
              }
              dieTypeId = unassignedDieTypeId;
            }
          } else {
            // Character is NOT mapped - use "Unassigned" as default
            dieTypeId = unassignedDieTypeId;
          }

          // Determine if cropped: ONLY spaces and dots should be cropped on initial load
          // All other characters should be visible regardless of isProbed property
          const isCropped = char === "." || char === " ";

          // Ensure dieTypeId is never null - use fallback if needed
          const finalDieTypeId = dieTypeId || unassignedDieTypeId;

          // Extract hard bin and soft bin values from the mapped bin data
          const binData = characterToBinMap[char];
          const hardBinRaw = binData?.hardBin ? parseInt(binData.hardBin, 10) : null;
          const softBinRaw = binData?.softBin ? parseInt(binData.softBin, 10) : null;

          data[y].push({
            binColor: DEFAULT_DIE_COLOR,
            isSelected: false,
            isCropped,
            isDeleted: false,
            hardBin: hardBinRaw !== null && !isNaN(hardBinRaw) ? hardBinRaw : null,
            softBin: softBinRaw !== null && !isNaN(softBinRaw) ? softBinRaw : null,
            dieType: finalDieTypeId, // This must be a valid die type ID, not null
          });
        }
      }
    } else {
      // Default behavior - create empty wafer map
      for (let y = 0; y < rows; y += 1) {
        data.push([]);
        for (let x = 0; x < cols; x += 1) {
          data[y].push({
            binColor: DEFAULT_DIE_COLOR,
            isSelected: false,
            isCropped: false,
            isDeleted: false,
            softBin: Math.floor(Math.random() * 1000),
            dieType: UtilityFunctions.getDieTypeIdFromName(
              "UnAssigned",
              dieTypes,
            ),
          });
        }
      }
    }
    return data;
  };

  getWaferDataUsingReticle = (
    dieStepSizeX: number,
    dieStepSizeY: number,
    reticleSizeX: number,
    reticleSizeY: number,
    reticleOffsetX: number,
    reticleOffsetY: number,
    waferDiameter: number,
    standardReticle: StandardReticle,
    reticleReference: ReticleReference,
  ) => {
    const { dieTypes } = this.state;
    if (
      reticleSizeY !== standardReticle.reticle.length ||
      reticleSizeX !== standardReticle.reticle[0].length
    ) {
      toast.warning(
        "Reticle Size and Dimensions Mismatch. Generate Reticle With New Dimensions",
      );
      return null;
    }
    const reticleWidth = dieStepSizeX * reticleSizeX;
    const reticleHeight = dieStepSizeY * reticleSizeY;
    const waferRadius = waferDiameter / 2;

    const reticleRows = Math.ceil(waferDiameter / reticleHeight) + 1;
    const reticleCols = Math.ceil(waferDiameter / reticleWidth) + 1;

    const dataRows = reticleRows * reticleSizeY;
    const dataCols = reticleCols * reticleSizeX;

    if (
      UtilityFunctions.euclideanDistance(
        { x: 0, y: 0 },
        { x: reticleOffsetX, y: reticleOffsetY },
      ) > waferRadius
    ) {
      toast.warning("Reticle offset can not be greater than wafer radius.");
      return null;
    }

    let data: Dies = [];
    for (let i = 0; i < dataRows; i += 1) {
      data.push([]);
      for (let j = 0; j < dataCols; j += 1) {
        data[i].push(null);
      }
    }

    const maxXLimit = reticleCols * reticleWidth;
    const maxYLimit = reticleRows * reticleHeight;

    const waferCenter = { x: -1, y: -1 };
    for (
      let i = 0;
      i < reticleRows && waferCenter.x === -1 && waferCenter.y === -1;
      i += 1
    ) {
      for (
        let j = 0;
        j < reticleCols && waferCenter.x === -1 && waferCenter.y === -1;
        j += 1
      ) {
        const reticleReferencePoint = UtilityFunctions.getReticleReference(
          j,
          i,
          reticleWidth,
          reticleHeight,
          reticleReference,
        ); // in terms of base units
        // eslint-disable-next-line no-underscore-dangle
        const _waferCenter = {
          x: reticleReferencePoint.x - reticleOffsetX,
          y: reticleReferencePoint.y + reticleOffsetY,
        };
        const waferLeft = {
          x: _waferCenter.x - waferRadius,
          y: _waferCenter.y,
        };
        const waferRight = {
          x: _waferCenter.x + waferRadius,
          y: _waferCenter.y,
        };
        const waferTop = { x: _waferCenter.x, y: _waferCenter.y - waferRadius };
        const waferBottom = {
          x: _waferCenter.x,
          y: _waferCenter.y + waferRadius,
        };
        if (
          UtilityFunctions.coordInRange(
            waferLeft,
            { min: 0, max: maxXLimit },
            { min: 0, max: maxYLimit },
          ) &&
          UtilityFunctions.coordInRange(
            waferRight,
            { min: 0, max: maxXLimit },
            { min: 0, max: maxYLimit },
          ) &&
          UtilityFunctions.coordInRange(
            waferTop,
            { min: 0, max: maxXLimit },
            { min: 0, max: maxYLimit },
          ) &&
          UtilityFunctions.coordInRange(
            waferBottom,
            { min: 0, max: maxXLimit },
            { min: 0, max: maxYLimit },
          )
        ) {
          waferCenter.x = _waferCenter.x;
          waferCenter.y = _waferCenter.y;
        }
      }
    }
    const newWaferCenter = { x: -1, y: -1 };
    if (waferCenter.x !== -1 && waferCenter.y !== -1) {
      for (let i = 0; i < reticleRows; i += 1) {
        for (let j = 0; j < reticleCols; j += 1) {
          const reticleReferencePoint = UtilityFunctions.getReticleReference(
            j,
            i,
            reticleWidth,
            reticleHeight,
            reticleReference,
          ); // in terms of base units
          const topLeft = UtilityFunctions.getReticleReference(
            j,
            i,
            reticleWidth,
            reticleHeight,
            "TOP_LEFT",
          ); // in terms of base units
          const topRight = UtilityFunctions.getReticleReference(
            j,
            i,
            reticleWidth,
            reticleHeight,
            "TOP_RIGHT",
          ); // in terms of base units
          const bottomLeft = UtilityFunctions.getReticleReference(
            j,
            i,
            reticleWidth,
            reticleHeight,
            "BOTTOM_LEFT",
          ); // in terms of base units
          const bottomRight = UtilityFunctions.getReticleReference(
            j,
            i,
            reticleWidth,
            reticleHeight,
            "BOTTOM_RIGHT",
          ); // in terms of base units

          const h = waferCenter.x;
          const k = maxYLimit - waferCenter.y;

          const reticleLeftSideIntersectionPoints =
            UtilityFunctions.getYCoordsOfIntersectionOfVerticleLineWithCircle(
              topLeft.x,
              h,
              k,
              waferRadius,
            );
          const reticleRightSideIntersectionPoints =
            UtilityFunctions.getYCoordsOfIntersectionOfVerticleLineWithCircle(
              topRight.x,
              h,
              k,
              waferRadius,
            );
          const reticleTopSideIntersectionPoints =
            UtilityFunctions.getXCoordsOfIntersectionOfHorizontalLineWithCircle(
              maxYLimit - topLeft.y,
              h,
              k,
              waferRadius,
            );
          const reticleBottomSideIntersectionPoints =
            UtilityFunctions.getXCoordsOfIntersectionOfHorizontalLineWithCircle(
              maxYLimit - bottomLeft.y,
              h,
              k,
              waferRadius,
            );

          if (
            (reticleLeftSideIntersectionPoints &&
              !(
                maxYLimit - reticleLeftSideIntersectionPoints.p1 >=
                  bottomLeft.y &&
                maxYLimit - reticleLeftSideIntersectionPoints.p2 >= bottomLeft.y
              ) &&
              !(
                maxYLimit - reticleLeftSideIntersectionPoints.p1 <= topLeft.y &&
                maxYLimit - reticleLeftSideIntersectionPoints.p2 <= topLeft.y
              )) ||
            (reticleRightSideIntersectionPoints &&
              !(
                maxYLimit - reticleRightSideIntersectionPoints.p1 >=
                  bottomRight.y &&
                maxYLimit - reticleRightSideIntersectionPoints.p2 >=
                  bottomRight.y
              ) &&
              !(
                maxYLimit - reticleRightSideIntersectionPoints.p1 <=
                  topRight.y &&
                maxYLimit - reticleRightSideIntersectionPoints.p2 <= topRight.y
              )) ||
            (reticleTopSideIntersectionPoints &&
              !(
                reticleTopSideIntersectionPoints.p1 >= topRight.x &&
                reticleTopSideIntersectionPoints.p2 >= topRight.x
              ) &&
              !(
                reticleTopSideIntersectionPoints.p1 <= topLeft.x &&
                reticleTopSideIntersectionPoints.p2 <= topLeft.x
              )) ||
            (reticleBottomSideIntersectionPoints &&
              !(
                reticleBottomSideIntersectionPoints.p1 >= bottomRight.x &&
                reticleBottomSideIntersectionPoints.p2 >= bottomRight.x
              ) &&
              !(
                reticleBottomSideIntersectionPoints.p1 <= bottomLeft.x &&
                reticleBottomSideIntersectionPoints.p2 <= bottomLeft.x
              ))
          ) {
            const referenceReticle =
              UtilityFunctions.areFloatsEqual(
                reticleReferencePoint.x - waferCenter.x,
                reticleOffsetX,
              ) &&
              UtilityFunctions.areFloatsEqual(
                waferCenter.y - reticleReferencePoint.y,
                reticleOffsetY,
              );
            // this reticle is included
            for (
              let a = i * reticleSizeY, c = 0;
              a < i * reticleSizeY + reticleSizeY;
              a += 1, c += 1
            ) {
              for (
                let b = j * reticleSizeX, d = 0;
                b < j * reticleSizeX + reticleSizeX;
                b += 1, d += 1
              ) {
                data[a][b] = {
                  binColor: DEFAULT_DIE_COLOR,
                  reticleSite: standardReticle.reticle[c][d],
                  referenceReticle,
                  reticleX: d,
                  reticleY: c,
                  isSelected: false,
                  dieType:
                    +standardReticle.WATPCMSite ===
                    standardReticle.reticle[c][d]
                      ? UtilityFunctions.getDieTypeIdFromName(
                          "WATPCM",
                          dieTypes,
                        )
                      : UtilityFunctions.getDieTypeIdFromName(
                          "UnAssigned",
                          dieTypes,
                        ),
                  isCropped: false,
                  isDeleted: false,
                  softBin: Math.floor(Math.random() * 1000),
                };
              }
            }
          }
        }
      }
      // remove all null rows
      data = data.filter((dataRow: any[]) => {
        return !dataRow.reduce(
          (result, currData) => result && currData === null,
          true,
        );
      });
      // remove all null cols
      data = data.map((x: any) =>
        x.filter((dat: any, idx: number) =>
          data.slice(1).some((arr: any[]) => arr[idx] !== null),
        ),
      );
      if (data.length === 0) {
        toast.warning("Calculation Error. Please contact administrator.");
        return null;
      }
      const newReticleRows = data.length / reticleSizeY;
      const newReticleCols = data[0].length / reticleSizeX;

      for (
        let i = 0;
        i < newReticleRows &&
        newWaferCenter.x === -1 &&
        newWaferCenter.y === -1;
        i += 1
      ) {
        for (
          let j = 0;
          j < newReticleCols &&
          newWaferCenter.x === -1 &&
          newWaferCenter.y === -1;
          j += 1
        ) {
          const dataY = i * reticleSizeY;
          const dataX = j * reticleSizeX;
          if (data[dataY][dataX] && data[dataY][dataX]!.referenceReticle) {
            const reticleReferencePoint = UtilityFunctions.getReticleReference(
              j,
              i,
              reticleWidth,
              reticleHeight,
              reticleReference,
            );
            newWaferCenter.x = reticleReferencePoint.x - reticleOffsetX;
            newWaferCenter.y = reticleReferencePoint.y + reticleOffsetY;
          }
        }
      }
    } else {
      toast.warning("Calculation Error. Please contact administrator.");
      return null;
    }
    if (newWaferCenter.x === -1 || newWaferCenter.y === -1) {
      toast.warning("Calculation Error. Please contact administrator.");
      return null;
    }
    return {
      // to get center just remove the below 2 lines to default
      waferHeightToRowsRatio: (2 * (waferRadius / dieStepSizeY)) / data.length,
      waferWidthToColsRatio:
        (2 * (waferRadius / dieStepSizeX)) / data[0].length,
      waferBGOffsetXDies:
        (newWaferCenter.x - (data[0].length / 2) * dieStepSizeX) / dieStepSizeX,
      waferBGOffsetYDies:
        (newWaferCenter.y - (data.length / 2) * dieStepSizeY) / dieStepSizeY,
      data,
    };
  };

  onSaveWaferDefinitionData = (data: WaferDefinitionData) => {
    const { waferDefinitionData: prevWaferDefinitionData, waferMapConfig: prevWaferMapConfig } = this.state;
    
    // If only origin values changed, apply translation instead of full recalculation.
    // Any placement input change (offset, axis, reticle geometry, etc.) must rebuild the grid.
    if (
      this.hasOnlyOriginValueChanged(prevWaferDefinitionData, data)
      && prevWaferMapConfig
      && prevWaferMapConfig.data
      && prevWaferMapConfig.data.dies
    ) {
      const translationOffsetX = (data.xOriginValue - prevWaferDefinitionData.xOriginValue);
      const translationOffsetY = (data.yOriginValue - prevWaferDefinitionData.yOriginValue);
      
      // Prefer the dies currently present in the plotter (includes manual die inserts/edits).
      const previousDies: Dies =
        this.deviceWafer?.waferMapVariables?.waferData?.dies ?? prevWaferMapConfig.data.dies;
      const translatedDies = this.applyTranslationToDies(previousDies, translationOffsetX, translationOffsetY);
      
      const updatedWaferMapConfig = _.cloneDeep(prevWaferMapConfig);
      updatedWaferMapConfig.data = {
        ...updatedWaferMapConfig.data,
        dies: translatedDies,
      };

      const updatedWaferDefinitionData = _.cloneDeep(data);
      updatedWaferDefinitionData.version = prevWaferDefinitionData.version + 1;

      this.setState(
        {
          waferDefinitionData: updatedWaferDefinitionData,
          waferMapConfig: updatedWaferMapConfig,
        },
        () => {
          this.addWafer();
          toast.success('Origin values updated and grid shifted successfully');
        },
      );
      return;
    }

    // If the user clicks "Define" again with the same placement inputs, do not rebuild dies.
    // Rebuilding would discard any manually inserted dies (including grid expansions/offset changes).
    if (
      this.deviceWafer
      && prevWaferMapConfig
      && this.isWaferDefinitionInputsCompatibleForDieMerge(prevWaferDefinitionData, data)
    ) {
      let existingDies: Dies =
        _.cloneDeep(this.deviceWafer.waferMapVariables?.waferData?.dies ?? prevWaferMapConfig.data.dies);
      if (data.calculationMethod === CalculationMethod.RETICLE) {
        const watPcmDieTypeId = UtilityFunctions.getDieTypeIdFromName(
          "WATPCM",
          this.state.dieTypes,
        );
        existingDies = WaferUtils.applyReticleMetadataToMissingDies(
          existingDies,
          data.standardReticle,
          watPcmDieTypeId || undefined,
        );
      }
      const maxRowsAndCols = UtilityFunctions.getMaxRowsAndCols(existingDies);

      const updatedWaferMapConfig = _.cloneDeep(prevWaferMapConfig);
      updatedWaferMapConfig.data = {
        dies: existingDies,
        waferMaxRows: maxRowsAndCols.maxRows,
        waferMaxCols: maxRowsAndCols.maxCols,
      };

      // Preserve plotter-derived view/offset ratios so expanded grids keep their alignment.
      updatedWaferMapConfig.waferBGOffsetXDies = this.deviceWafer.waferMapVariables.waferBGOffsetXDies;
      updatedWaferMapConfig.waferBGOffsetYDies = this.deviceWafer.waferMapVariables.waferBGOffsetYDies;
      updatedWaferMapConfig.waferWidthToColsRatio = this.deviceWafer.waferMapVariables.waferWidthToColsRatio;
      updatedWaferMapConfig.waferHeightToRowsRatio = this.deviceWafer.waferMapVariables.waferHeightToRowsRatio;

      const updatedWaferDefinitionData = _.cloneDeep(data);
      updatedWaferDefinitionData.version = prevWaferDefinitionData.version + 1;

      this.setState(
        (prevState: WaferControlMapState) => {
          const newDrawLayout = _.cloneDeep(prevState.drawLayout);
          newDrawLayout.overlayReticle = data.calculationMethod === CalculationMethod.RETICLE;
          newDrawLayout.showReferenceReticle = data.calculationMethod === CalculationMethod.RETICLE;
          Object.assign(
            newDrawLayout,
            this.applyWaferDiameterToDrawLayout(newDrawLayout, data),
          );
          return {
            waferDefinitionData: updatedWaferDefinitionData,
            waferMapConfig: updatedWaferMapConfig,
            drawLayout: newDrawLayout,
            middleViewport: MiddleViewport.WAFER,
            isInsertDieControlActive: false,
            isDeleteModeActive: false,
          };
        },
        () => {
          this.addWafer();
          // Re-apply reticle metadata so newly inserted dies receive reticle fields.
          // Suppress warning in this idempotent redraw path to avoid false alerts.
          if (data.calculationMethod === CalculationMethod.RETICLE) {
            this.syncPcmWatMaxReticleRowsCols(
              updatedWaferDefinitionData,
              updatedWaferMapConfig,
            );
            this.runAfterNextPaint(() => {
              this.overlayReticle(false);
            });
          }
        },
      );
      return;
    }

    let streetWidth = 0;
    let streetHeight = 0;
    let rows = 0;
    let cols = 0;
    let waferBGOffsetXDies = 0; // X offset of wafer from the center of the wafermap canvas in terms of cols
    let waferBGOffsetYDies = 0; // Y offset of wafer from the center of the wafermap canvas in terms of rows
    let dieWidthToStreetWidthRatio = 1;
    let dieHeightToStreetHeightRatio = 1;

    const dieSizeX = UtilityFunctions.toBaseUnit({
      value: data.dieSizeX,
      UOM: data.dieUOM,
    });
    const dieSizeY = UtilityFunctions.toBaseUnit({
      value: data.dieSizeY,
      UOM: data.dieUOM,
    });
    const dieStepSizeX = UtilityFunctions.toBaseUnit({
      value: data.dieStepSizeX,
      UOM: data.dieUOM,
    });
    const dieStepSizeY = UtilityFunctions.toBaseUnit({
      value: data.dieStepSizeY,
      UOM: data.dieUOM,
    });
    const waferDiameter = UtilityFunctions.toBaseUnit({
      value: data.waferDiameter,
      UOM: data.waferDiameterUOM,
      isDiameter: true,
    });
    const reticleOffsetX = UtilityFunctions.toBaseUnit({
      value: data.reticleOffsetX,
      UOM: data.reticleUOM,
    });
    const reticleOffsetY = UtilityFunctions.toBaseUnit({
      value: data.reticleOffsetY,
      UOM: data.reticleUOM,
    });
    const waferEdgeExclusion = UtilityFunctions.toBaseUnit({
      value: data.waferEdgeExclusion,
      UOM: data.waferEdgeExclusionUOM,
    });

    streetWidth = dieStepSizeX - dieSizeX;
    streetHeight = dieStepSizeY - dieSizeY;
    let waferHeightToRowsRatio = 1;
    let waferWidthToColsRatio = 1;
    // Keep AUTO and RETICLE die-count generation aligned by using die step size.
    // This keeps grid generation consistent with placement pitch.
    const rowsRequired = Math.floor(waferDiameter / dieStepSizeY);
    const colsRequired = Math.floor(waferDiameter / dieStepSizeX);
    let waferHeight = waferDiameter / dieStepSizeY; // height in terms of number of rows taken
    let waferWidth = waferDiameter / dieStepSizeX; // wafer width in terms of number of cols taken
    let showDieText = false;
    let reticleSize = { x: 0, y: 0 };
    let dieTextField = "";
    dieWidthToStreetWidthRatio = dieStepSizeX / streetWidth;
    dieHeightToStreetHeightRatio = dieStepSizeY / streetHeight;
    if (data.calculationMethod === CalculationMethod.AUTO) {
      rows = rowsRequired;
      cols = colsRequired;
      waferHeightToRowsRatio = waferDiameter / dieStepSizeY / rows;
      waferWidthToColsRatio = waferDiameter / dieStepSizeX / cols;
    } else if (data.calculationMethod === CalculationMethod.ROWS_COLS) {
      rows = data.waferMaxRows;
      cols = data.waferMaxCols;
      waferHeight = rowsRequired;
      waferWidth = colsRequired;
      waferHeightToRowsRatio = rowsRequired / rows;
      waferWidthToColsRatio = colsRequired / cols;
    }
    let dies = this.getWaferData(rows, cols);
    let maxRowsAndCols = UtilityFunctions.getMaxRowsAndCols(dies);

    if (data.calculationMethod === CalculationMethod.RETICLE) {
      const waferData = this.getWaferDataUsingReticle(
        dieStepSizeX,
        dieStepSizeY,
        data.reticleSizeX,
        data.reticleSizeY,
        reticleOffsetX,
        reticleOffsetY,
        waferDiameter,
        data.standardReticle,
        data.reticleReference,
      );
      if (!waferData) return;
      dies = waferData.data;
      maxRowsAndCols = UtilityFunctions.getMaxRowsAndCols(dies);
      rows = maxRowsAndCols.maxRows;
      cols = maxRowsAndCols.maxCols;
      waferBGOffsetXDies = waferData.waferBGOffsetXDies;
      waferBGOffsetYDies = waferData.waferBGOffsetYDies;
      waferHeightToRowsRatio = waferData.waferHeightToRowsRatio!;
      waferWidthToColsRatio = waferData.waferWidthToColsRatio!;
      waferHeight = waferHeightToRowsRatio * rows;
      waferWidth = waferWidthToColsRatio * cols;
      showDieText = true;
      reticleSize = {
        x:
          data.standardReticle.reticle.length > 0
            ? data.standardReticle.reticle[0].length
            : 0,
        y: data.standardReticle.reticle.length,
      };
      dieTextField = "reticleSite";
    }

    // Preserve any manually added/edited dies when the user re-clicks "Define"
    // with the same wafer placement inputs (reticle/die/wafer geometry).
    // This prevents overwriting user-inserted die cells with the fresh defaults.
    const shouldPreserveDies =
      this.deviceWafer &&
      this.isWaferDefinitionInputsCompatibleForDieMerge(prevWaferDefinitionData, data);
    if (shouldPreserveDies) {
      const previousDies: Dies =
        this.deviceWafer?.waferMapVariables?.waferData?.dies ?? prevWaferMapConfig?.data?.dies ?? [];
      dies = this.mergeDiesPreservingEdits(dies, previousDies);
    }
    const waferMapConfig: WaferMapConfig = {
      data: {
        dies,
        waferMaxRows: maxRowsAndCols.maxRows,
        waferMaxCols: maxRowsAndCols.maxCols,
      },
      dieSize: {
        dieWidth:
          dieStepSizeX > dieStepSizeY ? 32 * (dieStepSizeX / dieStepSizeY) : 32,
        dieHeight:
          dieStepSizeY > dieStepSizeX ? 32 * (dieStepSizeY / dieStepSizeX) : 32,
      },
      reticleGridRectCoords: {},
      referenceReticleGridRectCoords: null,
      showDieText,
      reticleSize,
      dieTextField,
      dieWidthToStreetWidthRatio,
      dieHeightToStreetHeightRatio,
      waferWidthToColsRatio,
      waferHeightToRowsRatio,
      waferBGOffsetXDies,
      waferBGOffsetYDies,
    };
    this.setState(
      (prevState: WaferControlMapState) => {
        const newWaferDefinitionData = _.cloneDeep(data);
        newWaferDefinitionData.version += 1;
        const newDrawLayout = _.cloneDeep(prevState.drawLayout);
        newDrawLayout.overlayReticle =
          data.calculationMethod === CalculationMethod.RETICLE;
        newDrawLayout.showReferenceReticle =
          data.calculationMethod === CalculationMethod.RETICLE;
        Object.assign(
          newDrawLayout,
          this.applyWaferDiameterToDrawLayout(newDrawLayout, data),
        );
        newDrawLayout.showRing = false;
        return {
          currentDieTypeId:
            prevState.dieTypes.length > 0 ? prevState.dieTypes[0].id : null,
          ringDiameterToWaferDiameterRatio:
            (waferDiameter - 2 * waferEdgeExclusion) / waferDiameter,
          middleViewport: MiddleViewport.WAFER,
          orignalWaferDimensions: { height: waferHeight, width: waferWidth },
          waferMapConfig,
          waferDefinitionData: newWaferDefinitionData,
          drawLayout: newDrawLayout,
          zones: [],
          selectedZoneId: null,
          isInsertDieControlActive: false,
          isDeleteModeActive: false,
        };
      },
      () => {
        this.addWafer();
        if (data.calculationMethod === CalculationMethod.RETICLE) {
          this.syncPcmWatMaxReticleRowsCols(data, waferMapConfig);
        }
      },
    );
  };

  addWafer = (skipProcessData = false) => {
    const {
      waferMapConfig,
      waferDefinitionData,
      ringDiameterToWaferDiameterRatio,
      drawLayout,
      dieTypes,
      currentDieTypeId,
      zones,
      orignalWaferDimensions,
    } = this.state;
    if (this.plotter && waferMapConfig) {
      this.plotter.addOrReplaceWafer(
        {
          skipProcessData,
          reticleGridRectCoords: waferMapConfig.reticleGridRectCoords,
          referenceReticleGridRectCoords:
            waferMapConfig.referenceReticleGridRectCoords,
          featureSpecificWaferTags: [FeatureSpecificWaferTag.WAFER_CONTROL_MAP],
          outerViewport: this.getOuterViewportBasedOnRadar(true),
          shouldUseOnlyBinColor: false,
          dies: waferMapConfig!.data.dies,
          keyIndex: DEVICE_WAFER_KEY,
          hasMarkingFeature: true,
          hasRotationControls: true,
          dieSize: waferMapConfig.dieSize,
          dieHeightToStreetHeightRatio:
            waferMapConfig.dieHeightToStreetHeightRatio,
          dieWidthToStreetWidthRatio: waferMapConfig.dieWidthToStreetWidthRatio,
          notchPosition: UtilityFunctions.resolveWcmDisplayNotchPosition(
            waferDefinitionData.waferOutputNotchPosition,
            waferDefinitionData.waferInputNotchPosition,
          ),
          rowOffset: waferDefinitionData.waferRowOffset,
          colOffset: waferDefinitionData.waferColOffset,
          rotationAngle: 0,
          showRadar: true,
          showWaferInfo: true,
          setWaferInstanceHandler: this.setWaferInstanceHandler,
          dieTypeField: "dieType",
        ringDiameterToWaferDiameterRatio,
        waferHeightToRowsRatio: waferMapConfig.waferHeightToRowsRatio,
        waferWidthToColsRatio: waferMapConfig.waferWidthToColsRatio,
        waferBGOffsetXDies: waferMapConfig.waferBGOffsetXDies,
        waferBGOffsetYDies: waferMapConfig.waferBGOffsetYDies,
        overlayReticle: drawLayout.overlayReticle,
        markWaferCenter: drawLayout.markWaferCenter,
        dieTextField: waferMapConfig.dieTextField,
        showDieText: waferMapConfig.showDieText,
        reticleSize: waferMapConfig.reticleSize,
        reticleReference: waferDefinitionData.reticleReference,
        reticlePlotSequence: waferDefinitionData.reticlePlotSequence || ReticlePlotSequence.HORIZONTAL_LEFT_TO_RIGHT,
        reticleNumberStartX: waferDefinitionData.reticleNumberStartX !== undefined && 
                            waferDefinitionData.reticleNumberStartX !== null && 
                            waferDefinitionData.reticleNumberStartX !== '' 
                            ? Number(waferDefinitionData.reticleNumberStartX) 
                            : undefined,
        reticleNumberStartY: waferDefinitionData.reticleNumberStartY !== undefined && 
                            waferDefinitionData.reticleNumberStartY !== null && 
                            waferDefinitionData.reticleNumberStartY !== '' 
                            ? Number(waferDefinitionData.reticleNumberStartY) 
                            : undefined,
        reticleOriginStartX: waferDefinitionData.reticleOriginStartX !== undefined && 
                            waferDefinitionData.reticleOriginStartX !== null && 
                            waferDefinitionData.reticleOriginStartX !== '' 
                            ? Number(waferDefinitionData.reticleOriginStartX) 
                            : undefined,
        reticleOriginStartY: waferDefinitionData.reticleOriginStartY !== undefined && 
                            waferDefinitionData.reticleOriginStartY !== null && 
                            waferDefinitionData.reticleOriginStartY !== '' 
                            ? Number(waferDefinitionData.reticleOriginStartY) 
                            : undefined,
        dieTypes: { dieType: dieTypes },
        showReferenceReticle: drawLayout.showReferenceReticle,
        zones,
        currentDieType: currentDieTypeId,
          wcmWaferDiameter: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferDiameter,
            UOM: waferDefinitionData.waferDiameterUOM,
            isDiameter: true,
          }),
          wcmWaferEdgeExclusion: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferEdgeExclusion,
            UOM: waferDefinitionData.waferEdgeExclusionUOM,
          }),
          wcmWaferNotchKeepOut: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferNotchKeepOut,
            UOM: waferDefinitionData.waferNotchKeepOutUOM,
          }),
          wcmWaferFlatKeepOut: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferFlatKeepOut,
            UOM: waferDefinitionData.waferFlatKeepOutUOM,
          }),
          wcmWaferBaseFlat: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferBaseFlat,
            UOM: waferDefinitionData.waferBaseFlatUOM,
          }),
          wcmWaferScribeLine: UtilityFunctions.toBaseUnit({
            value: waferDefinitionData.waferScribeLine,
            UOM: waferDefinitionData.waferScribeLineUOM,
          }),
          wcmExclusionType: waferDefinitionData.exclusionType,
          edgeDieThreshold:
            waferDefinitionData.edgeDieThreshold !== undefined &&
            waferDefinitionData.edgeDieThreshold !== null
              ? waferDefinitionData.edgeDieThreshold
              : 0,
          standardReticle: waferDefinitionData.standardReticle,
          rowsTakenByWaferBG: orignalWaferDimensions.height,
          colsTakenByWaferBG: orignalWaferDimensions.width,
          colAxisDirection: UtilityFunctions.getColAndRowAxisDirection(
            waferDefinitionData.waferAxisDirection,
          ).colAxisDirection,
          rowAxisDirection: UtilityFunctions.getColAndRowAxisDirection(
            waferDefinitionData.waferAxisDirection,
          ).rowAxisDirection,
          waferOriginLocation: waferDefinitionData.waferOriginLocation,
          xOriginValue: waferDefinitionData.xOriginValue,
          yOriginValue: waferDefinitionData.yOriginValue,
          onWATPCMNumberMarked: this.onWATPCMNumberMarked,
        },
        () => {
          this.forceUpdate();
        },
      );
    }
  };

  onWATPCMNumberMarked = () => {
    this.setState((prevState: WaferControlMapState) => {
      const newPcmWatSiteNumber =
        prevState.pcmWatSiteNumber === null ||
        (prevState.pcmWatSiteNumber !== null &&
          prevState.pcmWatSiteNumber >= prevState.maxPcmWatSiteNumber)
          ? prevState.pcmWatSiteNumber
          : prevState.pcmWatSiteNumber + 1;
      this.changeWaferMapVariable(
        { currentWatPCMSiteNumber: newPcmWatSiteNumber },
        false,
      );
      return {
        pcmWatSiteNumber: newPcmWatSiteNumber,
      };
    });
  };

  // Enable home die selection and set up callback for coordinate shift
  enableHomeDieSelection = () => {
    HomeDieCoordsForm.setHomeDieSaveCallback(this.onSaveHomeDieCoordinates);
    toast.info('Click on a die to set it as the home die and define its coordinates');
  };

  // Disable home die selection  
  disableHomeDieSelection = () => {
    HomeDieCoordsForm.setHomeDieSaveCallback(null);
  };

  // Apply translation offset to all dies in the wafer map coordinates
  applyTranslationToDies = (dies: Dies, translationOffsetX: number, translationOffsetY: number): Dies => {
    const translatedDies = _.cloneDeep(dies);
    for (let i = 0; i < translatedDies.length; i += 1) {
      for (let j = 0; j < translatedDies[i].length; j += 1) {
        const die = translatedDies[i][j];
        if (die) {
          // Apply translation to both calculated and true coordinates
          // Both should be translated by the same offset since they represent the same die position
          if (die.x !== undefined) {
            die.x = (die.x || 0) - translationOffsetX;
          }
          if (die.y !== undefined) {
            die.y = (die.y || 0) - translationOffsetY;
          }
          // Update xTrue/yTrue with the same translation
          // These are also coordinate values and should shift identically to x/y
          if (die.xTrue !== undefined) {
            die.xTrue = (die.xTrue || 0) - translationOffsetX;
          }
          if (die.yTrue !== undefined) {
            die.yTrue = (die.yTrue || 0) - translationOffsetY;
          }
        }
      }
    }
    return translatedDies;
  };

  // Merge previously edited dies into a freshly generated dies grid.
  // Rule: if a previous die cell exists (non-null), keep it even if the new grid cell is null/default.
  mergeDiesPreservingEdits = (baseDies: Dies, previousDies: Dies): Dies => {
    if (!baseDies?.length || !previousDies?.length) return baseDies;

    const merged = _.cloneDeep(baseDies);
    const maxRows = Math.min(merged.length, previousDies.length);
    for (let r = 0; r < maxRows; r += 1) {
      const prevRow = previousDies[r];
      if (!prevRow) continue;
      const maxCols = Math.min(merged[r]?.length ?? 0, prevRow.length);
      for (let c = 0; c < maxCols; c += 1) {
        const prevDie = prevRow[c];
        if (prevDie !== null && prevDie !== undefined) {
          merged[r][c] = _.cloneDeep(prevDie);
        }
      }
    }
    return merged;
  };

  // True when x/y origin values are the sole difference between prev and next.
  // Reuses placement-field checks from isWaferDefinitionInputsCompatibleForDieMerge so
  // offset, axis direction, origin location, reticle geometry, etc. trigger a full rebuild.
  hasOnlyOriginValueChanged = (
    prev: WaferDefinitionData,
    next: WaferDefinitionData,
  ): boolean => {
    const originChanged =
      prev.xOriginValue !== next.xOriginValue
      || prev.yOriginValue !== next.yOriginValue;
    if (!originChanged) return false;

    const nextWithPrevOrigin = _.cloneDeep(next);
    nextWithPrevOrigin.xOriginValue = prev.xOriginValue;
    nextWithPrevOrigin.yOriginValue = prev.yOriginValue;
    return this.isWaferDefinitionInputsCompatibleForDieMerge(prev, nextWithPrevOrigin);
  };

  // Only preserve/merge dies if the die placement inputs are compatible.
  // We conservatively merge only when key geometry inputs did not change.
  isWaferDefinitionInputsCompatibleForDieMerge = (
    prev: WaferDefinitionData,
    next: WaferDefinitionData,
  ): boolean => {
    const prevAny = prev as any;
    const nextAny = next as any;

    if (prev.calculationMethod !== next.calculationMethod) return false;

    const baseKeysToCompare = [
      "dieUOM",
      "dieSpecType",
      "dieSizeX",
      "dieSizeY",
      "dieStepSizeX",
      "dieStepSizeY",
      "waferDiameterUOM",
      "waferDiameter",
      "waferEdgeExclusionUOM",
      "waferEdgeExclusion",
      "waferFlatKeepOutUOM",
      "waferFlatKeepOut",
      "waferNotchKeepOutUOM",
      "waferNotchKeepOut",
      "waferBaseFlatUOM",
      "waferBaseFlat",
      "waferScribeLineUOM",
      "waferScribeLine",
      "waferAxisDirection",
      "waferOriginLocation",
      "waferPGDW",
      "waferRowOffset",
      "waferColOffset",
      "exclusionType",
      "edgeDieThreshold",
      // Origin translation is already handled separately via hasOnlyOriginValueChanged.
      "xOriginValue",
      "yOriginValue",
    ];

    for (const key of baseKeysToCompare) {
      if (!_.isEqual(prevAny[key], nextAny[key])) return false;
    }

    if (next.calculationMethod === CalculationMethod.RETICLE) {
      const reticleKeysToCompare = [
        "reticleUOM",
        "reticleSizeX",
        "reticleSizeY",
        "reticleOffsetX",
        "reticleOffsetY",
        "reticleReference",
        "reticlePlotSequence",
        "reticleOriginStartX",
        "reticleOriginStartY",
        "standardReticle",
      ];
      for (const key of reticleKeysToCompare) {
        if (!_.isEqual(prevAny[key], nextAny[key])) return false;
      }
    } else {
      // Fixed rows/cols method: ensure grid bounds match.
      if (prevAny.waferMaxCols !== nextAny.waferMaxCols) return false;
      if (prevAny.waferMaxRows !== nextAny.waferMaxRows) return false;
    }

    return true;
  };

  // Save home die coordinate changes to the backend
  saveHomeDieChangesToBackend = async (newOriginX: number, newOriginY: number) => {
    const { match } = this.props;
    
    // Only save if this is an existing WCM (has an ID)
    if (!match.params.id) {
      return;
    }


    try {
      this.setState({ isInSavingState: true });
      
      // Get the request data
      const requestData = this.getWaferControlMapDataForRequest();
      
      // Explicitly set the new origin values to ensure they're included in the save
      requestData.xOriginValue = newOriginX;
      requestData.yOriginValue = newOriginY;
      // Do NOT override dies - use the ones from the plotter which now have the translated coordinates
      
      
      const response = await httpWaferControlMap.putWaferControlMap(
        requestData,
        match.params.id,
      );
      
      if (response && response.success && response.statusCode === 200) {
        // Reload the entire WCM data from backend to verify all changes were persisted
        const wcmDataResponse = await httpWaferControlMap.getWaferControlMap(match.params.id);
        const dieTypesResponse = await httpDieType.getDieTypes(match.params.id);
        
        
        if (wcmDataResponse && wcmDataResponse.success && wcmDataResponse.statusCode === 200) {
          // Reconstruct waferDefinitionData from the fresh response, just like in loadDataFromBackend
          const currentWaferDefData = this.state.waferDefinitionData;
          const currentWaferMapConfig = this.state.waferMapConfig;
          
          
          const updatedWaferDefData: WaferDefinitionData = {
            ...currentWaferDefData,
            calculationMethod: CalculationMethod[wcmDataResponse.data.drawMethod] as unknown as CalculationMethod,
            dieSizeX: wcmDataResponse.data.dieWidth,
            dieSizeY: wcmDataResponse.data.dieHeight,
            dieStepSizeX: wcmDataResponse.data.dieStepWidth,
            dieStepSizeY: wcmDataResponse.data.dieStepHeight,
            waferDiameter: wcmDataResponse.data.diameter,
            waferDiameterUOM: wcmDataResponse.data.diameterUOM,
            waferEdgeExclusion: wcmDataResponse.data.edgeExclusion,
            waferEdgeExclusionUOM: wcmDataResponse.data.edgeExclusionUOM,
            waferMaxRows: wcmDataResponse.data.fixedRows,
            waferMaxCols: wcmDataResponse.data.fixedCols,
            xOriginValue: wcmDataResponse.data.xOriginValue ?? 0,
            yOriginValue: wcmDataResponse.data.yOriginValue ?? 0,
            waferRowOffset: wcmDataResponse.data.axisOffsetY,
            waferColOffset: wcmDataResponse.data.axisOffsetX,
            version: wcmDataResponse.data.version || currentWaferDefData.version + 1,
          };
          
          // Keep the waferMapConfig with the translated dies we already have in state
          // Don't replace with backend dies as we've already manually translated them correctly
          const updatedWaferMapConfig: WaferMapConfig = {
            data: {
              // Keep the dies we already have (we translated them correctly locally)
              dies: currentWaferMapConfig?.data?.dies || [],
              waferMaxRows: wcmDataResponse.data.fixedRows,
              waferMaxCols: wcmDataResponse.data.fixedCols,
            },
            dieSize: currentWaferMapConfig?.dieSize || { dieWidth: 32, dieHeight: 32 },
            reticleGridRectCoords: currentWaferMapConfig?.reticleGridRectCoords || {},
            referenceReticleGridRectCoords: currentWaferMapConfig?.referenceReticleGridRectCoords || null,
            showDieText: currentWaferMapConfig?.showDieText ?? true,
            reticleSize: currentWaferMapConfig?.reticleSize || { x: 0, y: 0 },
            dieTextField: currentWaferMapConfig?.dieTextField || '',
            dieWidthToStreetWidthRatio: currentWaferMapConfig?.dieWidthToStreetWidthRatio ?? 1,
            dieHeightToStreetHeightRatio: currentWaferMapConfig?.dieHeightToStreetHeightRatio ?? 1,
            waferWidthToColsRatio: currentWaferMapConfig?.waferWidthToColsRatio ?? 1,
            waferHeightToRowsRatio: currentWaferMapConfig?.waferHeightToRowsRatio ?? 1,
            waferBGOffsetXDies: currentWaferMapConfig?.waferBGOffsetXDies ?? 0,
            waferBGOffsetYDies: currentWaferMapConfig?.waferBGOffsetYDies ?? 0,
          };
          
          let updatedDieTypes = this.state.dieTypes;
          if (dieTypesResponse && dieTypesResponse.success && dieTypesResponse.statusCode === 200) {
            updatedDieTypes = this.normalizeDieTypes(dieTypesResponse.data);
          }
          
          this.setState({
            isInSavingState: false,
            version: wcmDataResponse?.data?.version,
            waferDefinitionData: updatedWaferDefData,
            waferMapConfig: updatedWaferMapConfig,
            dieTypes: updatedDieTypes,
          }, () => {
            // Re-render the wafer with the confirmed persisted values
            this.addWafer();
            toast.success(`Home die coordinates saved successfully. New Origin: X=${wcmDataResponse.data.xOriginValue}, Y=${wcmDataResponse.data.yOriginValue}`);
          });
        } else {
          this.setState({ isInSavingState: false });
          toast.error('Failed to verify saved changes from backend');
        }
      } else {
        this.setState({ isInSavingState: false });
        if (response && response.message) {
          toast.error(response.message);
        }
      }
    } catch (error) {
      this.setState({ isInSavingState: false });
      toast.error('An error occurred while saving the home die coordinates');
      console.error('Home die save error:', error);
    }
  };

  // Handle home die coordinate save with translation logic
  onSaveHomeDieCoordinates = async (homeDieData: any) => {
    const { waferMapConfig, waferDefinitionData } = this.state;
    if (!waferMapConfig || !waferMapConfig.data || !waferMapConfig.data.dies) {
      toast.error('Wafer data not available');
      return;
    }

    // Show confirmation dialog
    const confirmed = await ModalPopup.confirm({
      header: 'Home Die Coordinate Shift',
      body: `Home Die has been set to (${homeDieData.standardX}, ${homeDieData.standardY}). The wafer map will be shifted so that the Home Die aligns with the provided coordinates, and the origin X and Y coordinates will also be updated accordingly. Do you want to proceed?`,
    });

    if (!confirmed) {
      return;
    }

    // The home die data provides the current and desired coordinates
    // homeDieData.standardX/Y = desired coordinates (what user entered)
    // homeDieData.currentX/Y = current coordinates (where the die currently is)
    // BUT: these might not be the actual grid coordinates - they're coming from the selected die's position
    // We need to use xTrue/yTrue which are the actual window coordinates
    
    const desiredX = homeDieData.standardX;
    const desiredY = homeDieData.standardY;
    const currentX = homeDieData.currentX || desiredX;
    const currentY = homeDieData.currentY || desiredY;

    // Calculate translation offset
    const translationOffsetX = currentX - desiredX;
    const translationOffsetY = currentY - desiredY;
    

    // Get the dies directly from the plotter (these will have proper x/y values)
    if (!this.plotter) {
      toast.error('Plotter not available');
      return;
    }

    const plotterDies = this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables.waferData?.dies;
    if (!plotterDies) {
      toast.error('Plotter dies not available');
      return;
    }

    // Apply translation to all dies in the plotter
    const translatedDies = this.applyTranslationToDies(plotterDies, translationOffsetX, translationOffsetY);
    

    // Update origin values by applying the same translation
    const newOriginX = waferDefinitionData.xOriginValue - translationOffsetX;
    const newOriginY = waferDefinitionData.yOriginValue - translationOffsetY;


    // Update wafer definition data with new origin values
    const updatedWaferDefinitionData = _.cloneDeep(waferDefinitionData);
    updatedWaferDefinitionData.xOriginValue = newOriginX;
    updatedWaferDefinitionData.yOriginValue = newOriginY;

    // Update wafer map config with translated dies from plotter
    const updatedWaferMapConfig = _.cloneDeep(waferMapConfig);
    updatedWaferMapConfig.data = {
      ...updatedWaferMapConfig.data,
      dies: translatedDies,
    };

    // Update state to reflect changes
    this.setState(
      {
        waferDefinitionData: updatedWaferDefinitionData,
        waferMapConfig: updatedWaferMapConfig,
      },
      async () => {
        // Trigger wafer re-render - this MUST complete before we save to backend
        // because the plotter needs to have the new dies
        this.addWafer();
        
        // Give the plotter a brief moment to update its internal state
        await new Promise(resolve => setTimeout(resolve, 100));
        
        toast.success('Home die coordinates applied and wafer map shifted successfully');
        // Do NOT auto-save to backend here. Persisting (and version increment)
        // must occur only when the user explicitly clicks "Save Wafer control map".
      },
    );
  };

  validateReticleData = (data: WaferDefinitionData) => {
    const errors: { [key: string]: any } = {};
    const waferRadius =
      UtilityFunctions.toBaseUnit({
        value: data.waferDiameter,
        UOM: data.waferDiameterUOM,
        isDiameter: true,
      }) / 2;
    if (data.reticleSizeX.toString() === "") {
      errors.reticleSizeX = "Required";
    } else if (+data.reticleSizeX <= 0) {
      errors.reticleSizeX = "Reticle cols must be greater than 0";
    }

    if (data.reticleSizeY.toString() === "") {
      errors.reticleSizeY = "Required";
    } else if (+data.reticleSizeY <= 0) {
      errors.reticleSizeY = "Reticle rows must be greater than 0";
    }

    if (
      UtilityFunctions.toBaseUnit({
        value: data.reticleOffsetX,
        UOM: data.reticleUOM,
      }) > waferRadius
    ) {
      errors.reticleOffsetX =
        "Reticle offset X cannot be greater than wafer radius";
    }
    if (
      UtilityFunctions.toBaseUnit({
        value: data.reticleOffsetY,
        UOM: data.reticleUOM,
      }) > waferRadius
    ) {
      errors.reticleOffsetX =
        "Reticle offset Y cannot be greater than wafer radius";
    }

    if (data.reticleOffsetX.toString() === "") {
      errors.reticleOffsetX = "Required";
    }

    if (data.reticleOffsetY.toString() === "") {
      errors.reticleOffsetY = "Required";
    }
    if (
      !(
        data.standardReticle.reticle.length > 0 &&
        data.standardReticle.reticle.length === +data.reticleSizeY &&
        data.standardReticle.reticle[0].length === +data.reticleSizeX
      )
    ) {
      errors.standardReticle = "Generate Reticle With New Dimensions";
    }
    return errors;
  };

  onSaveReticleData = (data: any) => {
    const { waferMapConfig, waferDefinitionData } = this.state;
    if (!waferMapConfig) return;
    const reticleSize = {
      x:
        data.standardReticle.reticle.length > 0
          ? data.standardReticle.reticle[0].length
          : 0,
      y: data.standardReticle.reticle.length,
    };
    const reticleOffset = {
      x:
        UtilityFunctions.toBaseUnit({
          value: data.reticleOffsetX,
          UOM: data.reticleUOM,
        }) /
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.dieStepSizeX,
          UOM: waferDefinitionData.dieUOM,
        }),
      y:
        UtilityFunctions.toBaseUnit({
          value: data.reticleOffsetY,
          UOM: data.reticleUOM,
        }) /
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.dieStepSizeY,
          UOM: waferDefinitionData.dieUOM,
        }),
    }; // in terms of die step size units
    const reticleTopLeft = this.getReticleTopLeft(
      waferMapConfig.data.dies.length,
      waferMapConfig.data.dies[0].length,
      data.reticleReference,
      reticleOffset,
      reticleSize,
      waferMapConfig.waferBGOffsetXDies,
      waferMapConfig.waferBGOffsetYDies,
    );
    if (reticleTopLeft.x % 1 === 0 && reticleTopLeft.y % 1 === 0) {
      this.setState((prevState: WaferControlMapState) => {
        const newWaferDefinitionData = _.cloneDeep(
          prevState.waferDefinitionData,
        );
        // When applying reticle edits, switch Draw Method to Reticle
        newWaferDefinitionData.calculationMethod = CalculationMethod.RETICLE;
        newWaferDefinitionData.version = data.version + 1;
        newWaferDefinitionData.reticleUOM = data.reticleUOM;
        newWaferDefinitionData.reticleSizeX = data.reticleSizeX;
        newWaferDefinitionData.reticleSizeY = data.reticleSizeY;
        newWaferDefinitionData.reticleOffsetX = data.reticleOffsetX;
        newWaferDefinitionData.reticleOffsetY = data.reticleOffsetY;
        newWaferDefinitionData.standardReticle = _.cloneDeep(
          data.standardReticle,
        );
        newWaferDefinitionData.reticleReference = data.reticleReference;
        newWaferDefinitionData.reticlePlotSequence = data.reticlePlotSequence;
        newWaferDefinitionData.reticleOriginStartX = data.reticleOriginStartX;
        newWaferDefinitionData.reticleOriginStartY = data.reticleOriginStartY;
        newWaferDefinitionData.reticleNumberStartX = data.reticleNumberStartX;
        newWaferDefinitionData.reticleNumberStartY = data.reticleNumberStartY;
        return {
          waferDefinitionData: newWaferDefinitionData,
        };
      }, () => {
        this.overlayReticle();
      });
    } else {
      toast.info(RETICLE_ALIGNMENT_ISSUE_TOAST, RETICLE_ALIGNMENT_TOAST_OPTIONS);
    }
  };

  overlayReticle = (showAlignmentWarning = true) => {
    // only used for methods other than draw using reticle
    // Always read fresh state to ensure we have the latest waferDefinitionData
    const { waferDefinitionData, waferMapConfig, dieLabelDisplayMode } = this.state;
    const dieLabelConfig = this.getDieLabelConfigForDisplayMode(dieLabelDisplayMode);
    const reticleSize = {
      x:
        waferDefinitionData.standardReticle.reticle.length > 0
          ? waferDefinitionData.standardReticle.reticle[0].length
          : 0,
      y: waferDefinitionData.standardReticle.reticle.length,
    };
    const reticleOffset = {
      x:
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.reticleOffsetX,
          UOM: waferDefinitionData.reticleUOM,
        }) /
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.dieStepSizeX,
          UOM: waferDefinitionData.dieUOM,
        }),
      y:
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.reticleOffsetY,
          UOM: waferDefinitionData.reticleUOM,
        }) /
        UtilityFunctions.toBaseUnit({
          value: waferDefinitionData.dieStepSizeY,
          UOM: waferDefinitionData.dieUOM,
        }),
    }; // in terms of die step size units
    if (!waferMapConfig) return;
    const reticleTopLeft = this.getReticleTopLeft(
      waferMapConfig.data.dies.length,
      waferMapConfig.data.dies[0].length,
      waferDefinitionData.reticleReference,
      reticleOffset,
      reticleSize,
      waferMapConfig.waferBGOffsetXDies,
      waferMapConfig.waferBGOffsetYDies,
    );
    // check if reticle overlay is possible by checking if top left coords are whole numbers
    if (reticleTopLeft.x % 1 === 0 && reticleTopLeft.y % 1 === 0) {
      const newDieTextField = dieLabelConfig.dieTextField;
      const newShowDieText = dieLabelConfig.showDieText;
      this.setState(
        (prevState: WaferControlMapState) => {
          let newWaferMapConfig = prevState.waferMapConfig;
          if (prevState.waferMapConfig) {
            newWaferMapConfig = {
              ...prevState.waferMapConfig,
              dieTextField: newDieTextField,
              showDieText: newShowDieText,
            };
          }
          return {
            drawLayout: { ...prevState.drawLayout, overlayReticle: true },
            waferMapConfig: newWaferMapConfig,
            zones: [],
            selectedZoneId: null,
          };
        },
        () => {
          // Read fresh state again in the callback to ensure we have the latest values
          const currentWaferDefinitionData = this.state.waferDefinitionData;
          const plotSequence =
            currentWaferDefinitionData.reticlePlotSequence
            || ReticlePlotSequence.HORIZONTAL_LEFT_TO_RIGHT;
          // Ensure 0 values are explicitly passed (not treated as undefined)
          const reticleNumberStartX =
            currentWaferDefinitionData.reticleNumberStartX !== undefined
            && currentWaferDefinitionData.reticleNumberStartX !== null
            && currentWaferDefinitionData.reticleNumberStartX !== ""
              ? Number(currentWaferDefinitionData.reticleNumberStartX)
              : 0;
          const reticleNumberStartY =
            currentWaferDefinitionData.reticleNumberStartY !== undefined
            && currentWaferDefinitionData.reticleNumberStartY !== null
            && currentWaferDefinitionData.reticleNumberStartY !== ""
              ? Number(currentWaferDefinitionData.reticleNumberStartY)
              : 0;
          const reticleOriginStartX = currentWaferDefinitionData.reticleOriginStartX;
          const reticleOriginStartY = currentWaferDefinitionData.reticleOriginStartY;
          this.changeWaferMapVariable({
            showDieText: newShowDieText,
            reticleSize,
            overlayReticle: true,
            dieTextField: newDieTextField,
            reticleReference: currentWaferDefinitionData.reticleReference,
            standardReticle: currentWaferDefinitionData.standardReticle,
            reticlePlotSequence: plotSequence,
          reticleNumberStartX: reticleNumberStartX,
          reticleNumberStartY: reticleNumberStartY,
          reticleOriginStartX: reticleOriginStartX,
          reticleOriginStartY: reticleOriginStartY,
          });
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            {
              action: ActionOnWaferData.APPLY_RETICLE,
              config: { reticleTopLeft },
            },
            "myid",
          );
        },
      );
    } else if (showAlignmentWarning) {
      toast.info(RETICLE_ALIGNMENT_ISSUE_TOAST, RETICLE_ALIGNMENT_TOAST_OPTIONS);
    }
  };

  getReticleTopLeft = (
    waferRows: number,
    waferCols: number,
    reticleReference: ReticleReference,
    reticleOffset: { x: number; y: number },
    reticleSize: { x: number; y: number },
    waferBGOffsetXDies: number,
    waferBGOffsetYDies: number,
  ) => {
    // helper method
    // reticle offset in terms of die step size units
    const waferCenter = { x: waferCols / 2, y: waferRows / 2 };
    const waferBGCenter = {
      x: waferCenter.x + waferBGOffsetXDies,
      y: waferCenter.y + waferBGOffsetYDies,
    };
    const reticleReferencePoint = {
      x: waferBGCenter.x + reticleOffset.x,
      y: waferBGCenter.y - reticleOffset.y,
    };
    let reticleTopLeft;
    switch (reticleReference) {
      case "BOTTOM_LEFT":
        reticleTopLeft = {
          x: reticleReferencePoint.x,
          y: reticleReferencePoint.y - reticleSize.y,
        };
        break;
      case "BOTTOM_RIGHT":
        reticleTopLeft = {
          x: reticleReferencePoint.x - reticleSize.x,
          y: reticleReferencePoint.y - reticleSize.y,
        };
        break;
      case "TOP_LEFT":
        reticleTopLeft = {
          x: reticleReferencePoint.x,
          y: reticleReferencePoint.y,
        };
        break;
      case "TOP_RIGHT":
        reticleTopLeft = {
          x: reticleReferencePoint.x - reticleSize.x,
          y: reticleReferencePoint.y,
        };
        break;
      case "CENTER":
        reticleTopLeft = {
          x: reticleReferencePoint.x - reticleSize.x / 2,
          y: reticleReferencePoint.y - reticleSize.y / 2,
        };
        break;
      default:
        reticleTopLeft = {
          x: reticleReferencePoint.x - reticleSize.x / 2,
          y: reticleReferencePoint.y - reticleSize.y / 2,
        };
        break;
    }
    reticleTopLeft.x = UtilityFunctions.ignoreDecimalsIfVerySmall(
      reticleTopLeft.x,
    );
    reticleTopLeft.y = UtilityFunctions.ignoreDecimalsIfVerySmall(
      reticleTopLeft.y,
    );
    return reticleTopLeft;
  };

  setDrawLayoutFromDbState = (drawLayout: DrawLayoutData) => {
    this.setState({ drawLayout });
  };

  getDrawLayoutData = () => {
    // eslint-disable-next-line react/destructuring-assignment
    return this.state.drawLayout;
  };

  getOrignalWaferDimensions = () => {
    // eslint-disable-next-line react/destructuring-assignment
    return this.state.orignalWaferDimensions;
  };

  getWaferDefinitionData = () => {
    // eslint-disable-next-line react/destructuring-assignment
    return this.state.waferDefinitionData;
  };

  getWCMAttributeDefinitions = () => {
    // eslint-disable-next-line react/destructuring-assignment
    return this.state.WCMAttributeDefinitions;
  };

  setWCMAttributeDefinitions = async (WCMAttributeDefinitions: any[]) => {
    this.setState({ WCMAttributeDefinitions });
  };

  getPCMWatSiteMapTabData = () => {
    // eslint-disable-next-line react/destructuring-assignment
    return this.state.pcmWatSiteMapTabData;
  };

  setPCMWatSiteMapTabData = async (
    pcmWatSiteMapTabData: PCMWATSiteMapTabData,
  ) => {
    this.setState({ pcmWatSiteMapTabData });
  };

  onWCMDefintionActionUndoRedo = (
    waferDefinitionData: WaferDefinitionData,
    orignalWaferDimensions: { height: number; width: number },
    waferMapVariables: WaferMapVariablesV2,
  ) => {
    this.setState((prevState: WaferControlMapState) => {
      const waferDiameter = UtilityFunctions.toBaseUnit({
        value: waferDefinitionData.waferDiameter,
        UOM: waferDefinitionData.waferDiameterUOM,
        isDiameter: true,
      });
      const waferEdgeExclusion = UtilityFunctions.toBaseUnit({
        value: waferDefinitionData.waferEdgeExclusion,
        UOM: waferDefinitionData.waferEdgeExclusionUOM,
      });
      const dieStepSizeX = UtilityFunctions.toBaseUnit({
        value: waferDefinitionData.dieStepSizeX,
        UOM: waferDefinitionData.dieUOM,
      });
      const dieStepSizeY = UtilityFunctions.toBaseUnit({
        value: waferDefinitionData.dieStepSizeY,
        UOM: waferDefinitionData.dieUOM,
      });

      const waferMapConfig: WaferMapConfig = {
        data: {
          dies: waferMapVariables.waferData.dies,
          waferMaxRows: waferMapVariables.waferData.waferMaxRows,
          waferMaxCols: waferMapVariables.waferData.waferMaxCols,
        },
        dieSize: {
          dieWidth:
            dieStepSizeX > dieStepSizeY
              ? 32 * (dieStepSizeX / dieStepSizeY)
              : 32,
          dieHeight:
            dieStepSizeY > dieStepSizeX
              ? 32 * (dieStepSizeY / dieStepSizeX)
              : 32,
        },
        reticleGridRectCoords: {},
        referenceReticleGridRectCoords: null,
        showDieText: waferMapVariables.showDieText,
        reticleSize: waferMapVariables.reticleSize,
        dieTextField: waferMapVariables.dieTextField,
        dieWidthToStreetWidthRatio:
          waferMapVariables.dieWidthToStreetWidthRatio,
        dieHeightToStreetHeightRatio:
          waferMapVariables.dieHeightToStreetHeightRatio,
        waferWidthToColsRatio: waferMapVariables.waferWidthToColsRatio,
        waferHeightToRowsRatio: waferMapVariables.waferHeightToRowsRatio,
        waferBGOffsetXDies: waferMapVariables.waferBGOffsetXDies,
        waferBGOffsetYDies: waferMapVariables.waferBGOffsetYDies,
      };

      return {
        currentDieTypeId:
          prevState.dieTypes.length > 0 ? prevState.dieTypes[0].id : null,
        ringDiameterToWaferDiameterRatio:
          (waferDiameter - 2 * waferEdgeExclusion) / waferDiameter,
        middleViewport: MiddleViewport.WAFER,
        orignalWaferDimensions,
        waferMapConfig,
        waferDefinitionData,
        zones: [],
        selectedZoneId: null,
      };
    });
  };

  onChangeDrawLayout = (data: DrawLayoutData, callback?: any) => {
    this.setState(
      (prevState: WaferControlMapState) => {
        const nextDrawLayout = _.cloneDeep(data);
        if (prevState.drawLayout.ringUOM !== data.ringUOM) {
          nextDrawLayout.ringSize = 0;
          nextDrawLayout.showRing = false;
          if (prevState.drawLayout.showRing) {
            this.changeWaferMapVariable({ showRing: false });
          }
        }
        if (
          +prevState.drawLayout.ringSize !== +nextDrawLayout.ringSize ||
          prevState.drawLayout.ringUOM !== nextDrawLayout.ringUOM
        ) {
          const ringToWaferDiameterRatio = this.getRingDiameterToWaferRatio(
            nextDrawLayout.ringSize,
            nextDrawLayout.ringUOM,
            prevState.waferDefinitionData,
          );
          if (ringToWaferDiameterRatio > 1) {
            toast.warning("Ring size can not be greater than the diameter");
            return { drawLayout: prevState.drawLayout };
          }
          this.setRingSize(
            nextDrawLayout.ringSize,
            nextDrawLayout.ringUOM,
          );
        }
        return { drawLayout: nextDrawLayout };
      },
      async () => {
        if (callback) await callback();
      },
    );
  };

  applyWaferDiameterToDrawLayout = (
    drawLayout: DrawLayoutData,
    waferDefinitionData: WaferDefinitionData,
  ): Pick<DrawLayoutData, "ringSize" | "ringUOM"> => ({
    ringSize: +waferDefinitionData.waferDiameter,
    ringUOM: waferDefinitionData.waferDiameterUOM,
  });

  getRingDiameterToWaferRatio = (
    ringSize: number | string,
    ringUOM: string,
    waferDefinitionData = this.state.waferDefinitionData,
  ) => {
    const ringValue = +ringSize;
    const waferValue = +waferDefinitionData.waferDiameter;
    if (ringUOM === waferDefinitionData.waferDiameterUOM) {
      return ringValue / waferValue;
    }
    return (
      UtilityFunctions.toBaseUnit({ value: ringValue, UOM: ringUOM, isDiameter: true })
      / UtilityFunctions.toBaseUnit({
        value: waferValue,
        UOM: waferDefinitionData.waferDiameterUOM,
        isDiameter: true
      })
    );
  };

  setRingSize = (
    ringSize: number | string,
    ringUOM: string,
    setShowRing = false,
  ) => {
    const newVars: any = {
      ringDiameterToWaferDiameterRatio: this.getRingDiameterToWaferRatio(
        ringSize,
        ringUOM,
      ),
    };
    if (setShowRing) {
      newVars.showRing = true;
    }
    this.changeWaferMapVariable(newVars);
  };

  changeWaferMapVariable = (
    waferData: { [key: string]: any },
    shouldReRender = true,
  ) => {
    PublishSubscribe().publishWithOthersID(
      EventTypes.CHANGE_WAFER_MAP_VARIABLES,
      { waferData, shouldReRender },
      "myid",
    );
  };

  getOuterViewportBasedOnRadar = (getWithRadar = false) => {
    if (getWithRadar || this.deviceWafer!.waferMapVariables.showRadar) {
      const outervpWidth = (3 * this.canvasDimension) / 4;
      return {
        x: 0,
        y: this.canvasDimension - outervpWidth,
        width: outervpWidth,
        height: outervpWidth,
      };
    }
    return {
      x: 0,
      y: 0,
      width: this.canvasDimension,
      height: this.canvasDimension,
    };
  };

  updateCanvasDimensions = () => {
    if (!this.deviceWafer) return;
    // update dimension after state update to ensure teh dimension changes on dom before its value gets updated
    this.canvasDimension = this.waferDiv.offsetWidth;
    // force update to ensure the new canvas dimensions are passed to the child component
    this.forceUpdate(() => {
      this.deviceWafer!.clearAll();
      this.deviceWafer!.waferMapVariables.outerViewPortWithRadar = null;
      this.deviceWafer!.waferMapVariables.outerViewPortWithoutRadar = null;
      this.deviceWafer!.waferMapVariables.onSetOuterViewport(
        this.getOuterViewportBasedOnRadar(),
      );
      this.deviceWafer!.renderWafer();
    });
  };

  onChangeLayout = (
    collapseTabsColumn: boolean | null,
    collapseDieSummaryColumn: boolean | null,
  ) => {
    this.setState((prevState: WaferControlMapState) => {
      return {
        collapseTabsColumn:
          collapseTabsColumn === null
            ? prevState.collapseTabsColumn
            : collapseTabsColumn,
        collapseDieSummaryColumn:
          collapseDieSummaryColumn === null
            ? prevState.collapseDieSummaryColumn
            : collapseDieSummaryColumn,
      };
    }, this.updateCanvasDimensions);
  };

  onResetRing = () => {
    const { waferDefinitionData } = this.state;
    const waferDiameter = UtilityFunctions.toBaseUnit({
      value: waferDefinitionData.waferDiameter,
      UOM: waferDefinitionData.waferDiameterUOM,
      isDiameter: true,
    });
    const waferEdgeExclusion = UtilityFunctions.toBaseUnit({
      value: waferDefinitionData.waferEdgeExclusion,
      UOM: waferDefinitionData.waferEdgeExclusionUOM,
    });
    this.setState(
      (prevState: WaferControlMapState) => {
        return {
          ringPanOffsetXMultiplier: 0,
          ringPanOffsetYMultiplier: 0,
          ringDiameterToWaferDiameterRatio:
            (waferDiameter - 2 * waferEdgeExclusion) / waferDiameter,
          drawLayout: {
            ...prevState.drawLayout,
            ringSize: 0,
            ringUOM: UOMs[0][0],
          },
        };
      },
      async () => {
        this.changeWaferMapVariable({
          ringDiameterToWaferDiameterRatio:
            (waferDiameter - 2 * waferEdgeExclusion) / waferDiameter,
          panOffsetXToDieStepSizeXRatio: 0,
          panOffsetYToDieStepSizeYRatio: 0,
        });
        if (this.plotter) {
          await this.plotter.actionHandler!(
            ActionType.PERFORM,
            DEVICE_WAFER_KEY,
            {
              actionDoMessage: "Reset ring",
              actionUndoMessage: "Reset ring",
            },
          );
        }
      },
    );
  };

  panRingOrWafer = (
    ringOrWafer: DrawLayoutPanResizeMode,
    xChange: number,
    yChange: number,
  ) => {
    const {
      drawLayout,
      waferDefinitionData,
      ringPanOffsetXMultiplier,
      ringPanOffsetYMultiplier,
      waferMapConfig,
    } = this.state;
    if (!waferMapConfig) return;
    const dieStepSizeX = UtilityFunctions.toBaseUnit({
      value: waferDefinitionData.dieStepSizeX,
      UOM: waferDefinitionData.dieUOM,
    });
    const dieStepSizeY = UtilityFunctions.toBaseUnit({
      value: waferDefinitionData.dieStepSizeY,
      UOM: waferDefinitionData.dieUOM,
    });
    const incrementX = UtilityFunctions.toBaseUnit({
      value: drawLayout.increment,
      UOM: drawLayout.incrementUOM,
      dieSide: "x",
      dieDimensions: {
        dieSizeX: waferDefinitionData.dieSizeX,
        dieSizeY: waferDefinitionData.dieSizeY,
        dieUOM: waferDefinitionData.dieUOM,
      },
    });
    const incrementY = UtilityFunctions.toBaseUnit({
      value: drawLayout.increment,
      UOM: drawLayout.incrementUOM,
      dieSide: "y",
      dieDimensions: {
        dieSizeX: waferDefinitionData.dieSizeX,
        dieSizeY: waferDefinitionData.dieSizeY,
        dieUOM: waferDefinitionData.dieUOM,
      },
    });
    const panOffsetXDelta = xChange * (incrementX / dieStepSizeX);
    const panOffsetYDelta = yChange * (incrementY / dieStepSizeY);
    if (ringOrWafer === DrawLayoutPanResizeMode.RING) {
      this.changeWaferMapVariable({
        panOffsetXToDieStepSizeXRatio:
          (incrementX / dieStepSizeX) * (ringPanOffsetXMultiplier + xChange),
        panOffsetYToDieStepSizeYRatio:
          (incrementY / dieStepSizeY) * (ringPanOffsetYMultiplier + yChange),
      });
      this.setState((prevState: WaferControlMapState) => {
        return {
          ringPanOffsetXMultiplier:
            prevState.ringPanOffsetXMultiplier + xChange,
          ringPanOffsetYMultiplier:
            prevState.ringPanOffsetYMultiplier + yChange,
        };
      });
    } else if (ringOrWafer === DrawLayoutPanResizeMode.WAFER) {
      this.changeWaferMapVariable({
        waferBGOffsetXDies:
          waferMapConfig.waferBGOffsetXDies + panOffsetXDelta,
        waferBGOffsetYDies:
          waferMapConfig.waferBGOffsetYDies + panOffsetYDelta,
        // Keep ring fixed on screen while panning wafer.
        panOffsetXToDieStepSizeXRatio:
          (incrementX / dieStepSizeX) * (ringPanOffsetXMultiplier - xChange),
        panOffsetYToDieStepSizeYRatio:
          (incrementY / dieStepSizeY) * (ringPanOffsetYMultiplier - yChange),
        radarWaferBgImageGLCoords: null,
      });
      this.setState((prevState: WaferControlMapState) => {
        if (!prevState.waferMapConfig)
          return {
            ringPanOffsetXMultiplier: prevState.ringPanOffsetXMultiplier,
            ringPanOffsetYMultiplier: prevState.ringPanOffsetYMultiplier,
            waferMapConfig: prevState.waferMapConfig,
          };
        const newWaferMapConfig = _.cloneDeep(prevState.waferMapConfig);
        newWaferMapConfig.waferBGOffsetXDies =
          prevState.waferMapConfig.waferBGOffsetXDies + panOffsetXDelta;
        newWaferMapConfig.waferBGOffsetYDies =
          prevState.waferMapConfig.waferBGOffsetYDies + panOffsetYDelta;
        return {
          ringPanOffsetXMultiplier:
            prevState.ringPanOffsetXMultiplier - xChange,
          ringPanOffsetYMultiplier:
            prevState.ringPanOffsetYMultiplier - yChange,
          waferMapConfig: newWaferMapConfig,
        };
      });
    }
  };

  mapAttributeDefinitions = (data: any) => {
    return data.map((x: any) => {
      return {
        id: x.id,
        label: x.attributeMeta.columnLabel,
        name: x.attributeMeta.id,
        value: x.expressionValue,
      };
    });
  };

  onAddAttributeMeta = async (columnInfo: any, callback: any) => {
    const { allWCMAttributeMetas } = this.state;
    if (
      commonFunctions.duplicateWcmAttributeMetaExists(
        columnInfo.columnName,
        columnInfo.entityType,
        allWCMAttributeMetas,
      )
    ) {
      toast.error(
        "An attribute with same name and entity type already exists.",
      );
      return;
    }
    const response = await httpWaferControlMap.postWaferControlMapAttributeMeta(
      {
        columnName: columnInfo.columnName,
        columnLabel: columnInfo.columnLabel,
        entityType: columnInfo.entityType,
      },
    );
    if (response) {
      if (response.success && response.statusCode === 200) {
        if (response.message) toast.success(response.message);
        this.setState(
          { allWCMAttributeMetas: response.data.attributeMetaDTOs },
          () => {
            callback(response.data.currentAttributeMetaId);
          },
        );
      } else if (response.message) toast.error(response.message);
    } else {
      this.setState({ WCMAttributeDefinitions: [], allWCMAttributeMetas: [] });
    }
  };

  onDeleteAttributeMeta = async (atrId: string, callback: () => void) => {
    const response =
      await httpWaferControlMap.deleteWaferControlMapAttributeMeta(atrId);
    if (response && response.message) {
      if (response.success) {
        toast.success(response.message);
        // Since attribute is not used, only reload metas to preserve unsaved rows
        this.setState(await this.loadAttributeMetaAndDefinitions("meta"), () => {
          callback();
        });
      } else {
        toast.error(response.message);
      }
    }
  };

  getColorObjectFromHex = (hexColor: string) => {
    const color = this.hexToRgb(hexColor);
    return {
      r: color?.r,
      g: color?.g,
      b: color?.b,
      key: hexColor,
    };
  };

  showErrorToasts = (errors: { [key: string]: any }) => {
    // eslint-disable-next-line no-restricted-syntax, no-unused-vars
    for (const [key, value] of Object.entries(errors)) {
      toast.warning(value);
    }
  };

  validateAndOverlayReticle = () => {
    const { waferDefinitionData } = this.state;
    if (this.waferDefinitionRef) {
      this.waferDefinitionRef.onSaveReticleData();
    } else {
      const errors = this.validateReticleData(waferDefinitionData);
      if (Object.keys(errors).length !== 0) {
        this.showErrorToasts(errors);
      } else {
        this.overlayReticle();
      }
    }
  };

  onCropSelectedReticles = () => {
    PublishSubscribe().publishWithOthersID(
      EventTypes.WAFER_DATA_REQUEST,
      { action: ActionOnWaferData.CROP_SELECTED_RETICLES_ON_WAFER },
      "myid",
    );
  };

  onOverlayReticleCheckBoxValueChanged = (value: boolean) => {
    const { drawLayout } = this.state;
    if (value) this.validateAndOverlayReticle();
    else {
      this.onChangeDrawLayout({ ...drawLayout, overlayReticle: value }, () => {
        this.onOverlayReticleChange(value);
      });
    }
  };

  onShowReferenceReticleCheckBoxValueChanged = (value: boolean) => {
    const { drawLayout } = this.state;
    this.onChangeDrawLayout(
      { ...drawLayout, showReferenceReticle: value },
      () => {
        this.onShowReferenceReticleChange(value);
      },
    );
  };

  onOverlayReticleChange = (value: boolean) => {
    const { waferDefinitionData } = this.state;
    const changedVariables: any = {
      reticleSize: {
        x:
          waferDefinitionData.standardReticle.reticle.length > 0
            ? waferDefinitionData.standardReticle.reticle[0].length
            : 0,
        y: waferDefinitionData.standardReticle.reticle.length,
      },
      overlayReticle: value,
    };
    if (!value) {
      changedVariables.isReticleCoordinatesSystemEnabled = false;
    }
    this.changeWaferMapVariable(changedVariables);
  };

  onShowReferenceReticleChange = (value: boolean) => {
    const { waferDefinitionData } = this.state;
    this.changeWaferMapVariable({
      reticleSize: {
        x:
          waferDefinitionData.standardReticle.reticle.length > 0
            ? waferDefinitionData.standardReticle.reticle[0].length
            : 0,
        y: waferDefinitionData.standardReticle.reticle.length,
      },
      showReferenceReticle: value,
    });
  };

  onMarkWaferCenterChange = (value: boolean) => {
    this.changeWaferMapVariable({ markWaferCenter: value });
  };

  getDieLabelConfigForDisplayMode = (displayMode: DieLabelDisplayMode) => {
    if (displayMode === "none") {
      return {
        showDieText: false,
        dieTextField: "",
      };
    }
    if (displayMode === "hardBin") {
      return {
        showDieText: true,
        dieTextField: "hardBinNumber",
      };
    }
    if (displayMode === "softBin") {
      return {
        showDieText: true,
        dieTextField: "softBinNumber",
      };
    }
    return {
      showDieText: true,
      dieTextField: displayMode,
    };
  };

  onDieLabelDisplayModeChanged = (displayMode: DieLabelDisplayMode) => {
    const dieLabelConfig = this.getDieLabelConfigForDisplayMode(displayMode);
    this.setState((prevState: WaferControlMapState) => {
      const nextState: Partial<WaferControlMapState> = {
        dieLabelDisplayMode: displayMode,
      };
      if (prevState.waferMapConfig) {
        nextState.waferMapConfig = {
          ...prevState.waferMapConfig,
          dieTextField: dieLabelConfig.dieTextField,
          showDieText: dieLabelConfig.showDieText,
        };
      }
      return nextState as Pick<
        WaferControlMapState,
        "dieLabelDisplayMode" | "waferMapConfig"
      >;
    }, () => {
      this.changeWaferMapVariable({
        showDieText: dieLabelConfig.showDieText,
        dieTextField: dieLabelConfig.dieTextField,
      });
    });
  };

  onClearDieTypesButtonClicked = async () => {
    if (
      await ModalPopup.confirm({
        header: "Clear Die Types",
        body: "Are you sure you want to clear all die types from the device map?",
      })
    ) {
      if (this.deviceWafer) {
        this.deviceWafer.clearAllDieTypesFromDies();
        this.changeWaferMapVariable({}, true);
        this.forceUpdate();
      }
    }
  };

  onMainControlSelectionChange = (
    keyIndex: string,
    _isSelectionActive: boolean
  ) => {
    if (keyIndex !== DEVICE_WAFER_KEY) return;
    const { isInsertDieControlActive, isDeleteModeActive } = this.state;
    if (
      (isInsertDieControlActive || isDeleteModeActive) &&
      this.plotter
    ) {
      // Only update wafer-control-map state; the WaferPlotter's selectionChangeHandler
      // has already set the correct wafer plotter state (selection/drag/waferUtils).
      // Calling addDieChangeHandler(false)/deleteModeChangeHandler(false) here would
      // override that state back to drag mode, requiring a second click.
      this.setState({
        isInsertDieControlActive: false,
        isDeleteModeActive: false,
      });
    }
  };

  uncheckReticleAndInsertOrDelete = (operationCallback: any) => {
    const { isInsertDieControlActive, isDeleteModeActive } = this.state;
    // If Insert Die mode is active, deactivate it when another button/mode from main controls is used
    if (isInsertDieControlActive && this.plotter) {
      this.plotter.addDieChangeHandler(false, DEVICE_WAFER_KEY);
      this.setState({ isInsertDieControlActive: false });
    }
    // If Delete mode is active, deactivate it when any mode from main controls is used
    if (isDeleteModeActive && this.plotter) {
      this.plotter.deleteModeChangeHandler(false, DEVICE_WAFER_KEY);
      this.setState({ isDeleteModeActive: false });
    }
    // Keep current reticle overlay state while performing die edit actions.
    // Turning overlay off here clears reticle/site text and never restores it.
    operationCallback();
  };

  onClickShowHideRing = () => {
    this.setState(
      (prevState: WaferControlMapState) => {
        const newDrawLayout = _.cloneDeep(prevState.drawLayout);
        if (prevState.drawLayout.showRing) {
          this.changeWaferMapVariable({ showRing: false });
          newDrawLayout.showRing = false;
        } else {
          this.setRingSize(
            prevState.drawLayout.ringSize,
            prevState.drawLayout.ringUOM,
            true,
          );
          newDrawLayout.showRing = true;
        }
        return {
          drawLayout: newDrawLayout,
        };
      },
      async () => {
        const { drawLayout } = this.state;
        if (this.plotter) {
          await this.plotter.actionHandler!(
            ActionType.PERFORM,
            DEVICE_WAFER_KEY,
            {
              actionDoMessage: `${drawLayout.showRing ? "show" : "hide"} ring`,
              actionUndoMessage: `${
                drawLayout.showRing ? "show" : "hide"
              } ring`,
            },
          );
        }
      },
    );
  };

  getAdditionalControls = (): WaferAdditionalControl[] => {
    const {
      drawLayout,
      showWATPCMSites,
      dieLabelDisplayMode,
      isInsertDieControlActive,
      isDeleteModeActive,
    } = this.state;
    const isNoDieSelected =
      !this.deviceWafer ||
      this.deviceWafer.waferMapVariables.selectedDieCount === 0;
    const selectDieTooltip = "Select die";
    return [
      {
        eventKey: "1",
        title: (
          <>
            <FontAwesomeIcon icon={faSpinner} className="mr5" />
            Ring Controls
          </>
        ),
        body: (
          <div className="wcm-control-body-container">
            <div className="custom-form mt0 pt0 wcm-control-form-text">
              <Label
                childrenItemsInline
                labelPosition="left-middle"
                labelSize="0"
                fieldSize="100"
                errorSize="100"
                labelTitle=""
              >
                <Label
                  labelTitle="Ring Size"
                  labelPosition="top"
                  labelSize="40"
                  fieldSize="60"
                  errorSize="100"
                  isFieldTouched
                  className="ring-uom-field"
                  fontSize="12px"
                >
                  <Textbox
                    containerClassName="small"
                    autoComplete="off"
                    type="number"
                    name="ringSize"
                    value={drawLayout.ringSize}
                    placeholder="0"
                    onChange={(e: any) => {
                      this.onChangeDrawLayout(
                        { ...drawLayout, ringSize: e.target.value },
                        async () => {
                          if (this.plotter) {
                            await this.plotter.actionHandler!(
                              ActionType.PERFORM,
                              DEVICE_WAFER_KEY,
                              {
                                actionDoMessage: "Change ring size",
                                actionUndoMessage: "Change ring size",
                              },
                            );
                          }
                        },
                      );
                    }}
                  />
                </Label>
                <Label
                  labelTitle="UOM"
                  labelPosition="top"
                  labelSize="40"
                  fieldSize="60"
                  errorSize="100"
                  isFieldTouched
                  className="ml5 ring-uom-field"
                  fontSize="12px"
                >
                  <CustomizedDropdown
                    containerClassName="small"
                    variant="clear"
                    full
                    list={UOMs}
                    selectedValue={drawLayout.ringUOM || UOMs[0][0]}
                    onChange={(value: any) => {
                      this.onChangeDrawLayout(
                        { ...drawLayout, ringUOM: value },
                        async () => {
                          if (this.plotter) {
                            await this.plotter.actionHandler!(
                              ActionType.PERFORM,
                              DEVICE_WAFER_KEY,
                              {
                                actionDoMessage: "Change ring UOM",
                                actionUndoMessage: "Change ring UOM",
                              },
                            );
                          }
                        },
                      );
                    }}
                  />
                </Label>
              </Label>
            </div>
            <div className="wcm-grid-2-columns">
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={this.onClickShowHideRing}
                  variant="clear"
                  size="sm"
                  className="w60 btn-config h40"
                >
                  {drawLayout.showRing ? "Hide" : "Draw"} Ring
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    PublishSubscribe().publishWithOthersID(
                      EventTypes.WAFER_DATA_REQUEST,
                      { action: ActionOnWaferData.CROP },
                      "myid",
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w60 btn-config h40"
                >
                  Crop Dies
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={this.onResetRing}
                  variant="clear"
                  size="sm"
                  className="w60 btn-config h40"
                >
                  Reset Ring
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    PublishSubscribe().publishWithOthersID(
                      EventTypes.WAFER_DATA_REQUEST,
                      { action: ActionOnWaferData.REDRAW },
                      "myid",
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w60 btn-config h40"
                >
                  Redraw Dies
                </Button>
              </div>
            </div>
          </div>
        ),
      },
      {
        eventKey: "2",
        title: (
          <>
            <FontAwesomeIcon icon={faArrowsAlt} className="mr5" />
            Pan Controls
          </>
        ),
        body: (
          <div className="wcm-control-body-container">
            <div className="custom-form mt0 pt0 wcm-control-form-text">
              <Label
                childrenItemsInline
                labelPosition="left-middle"
                labelSize="0"
                fieldSize="100"
                errorSize="100"
                labelTitle=""
                fontSize="12px"
              >
                <Label
                  labelTitle="Increment"
                  labelPosition="top"
                  labelSize="40"
                  fieldSize="60"
                  errorSize="100"
                  isFieldTouched
                  className="ml5 ring-uom-field"
                  fontSize="12px"
                >
                  <Textbox
                    containerClassName="small"
                    autoComplete="off"
                    type="number"
                    name="increment"
                    value={drawLayout.increment}
                    placeholder="0"
                    onChange={(e: any) => {
                      this.onChangeDrawLayout({
                        ...drawLayout,
                        increment: +e.target.value,
                      });
                    }}
                  />
                </Label>
                <Label
                  labelTitle="UOM"
                  labelPosition="top"
                  labelSize="40"
                  fieldSize="60"
                  errorSize="100"
                  isFieldTouched
                  className="ml5 ring-uom-field"
                  fontSize="10px"
                >
                  <CustomizedDropdown
                    containerClassName="small"
                    variant="clear"
                    full
                    list={UOMs.concat([["die", "Die"]])}
                    selectedValue={drawLayout.incrementUOM || UOMs[0][0]}
                    onChange={(value: any) => {
                      this.onChangeDrawLayout({
                        ...drawLayout,
                        incrementUOM: value,
                      });
                    }}
                  />
                </Label>
              </Label>
              <Row className="mb10">
                <Col className="wcm-center-text">
                  <CheckBox
                    value={
                      drawLayout.drawLayoutPanResizeMode ===
                      DrawLayoutPanResizeMode.RING
                    }
                    onValueChange={() => {
                      this.onChangeDrawLayout({
                        ...drawLayout,
                        drawLayoutPanResizeMode: DrawLayoutPanResizeMode.RING,
                      });
                    }}
                  />{" "}
                  Ring
                </Col>
                <Col className="wcm-center-text">
                  <CheckBox
                    value={
                      drawLayout.drawLayoutPanResizeMode ===
                      DrawLayoutPanResizeMode.WAFER
                    }
                    onValueChange={() => {
                      this.onChangeDrawLayout({
                        ...drawLayout,
                        drawLayoutPanResizeMode: DrawLayoutPanResizeMode.WAFER,
                      });
                    }}
                  />{" "}
                  Wafer
                </Col>
              </Row>
            </div>
            <div className="wcm-grid-2-columns">
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    this.panRingOrWafer(
                      drawLayout.drawLayoutPanResizeMode,
                      0,
                      -1,
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w40 btn-config"
                >
                  <small>
                    <FontAwesomeIcon icon={faArrowUp} />
                  </small>
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    this.panRingOrWafer(
                      drawLayout.drawLayoutPanResizeMode,
                      0,
                      1,
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w40 btn-config"
                >
                  <small>
                    <FontAwesomeIcon icon={faArrowDown} />
                  </small>
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    this.panRingOrWafer(
                      drawLayout.drawLayoutPanResizeMode,
                      -1,
                      0,
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w40 btn-config"
                >
                  <small>
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </small>
                </Button>
              </div>
              <div className="wcm-grid-button-cell">
                <Button
                  onClick={() => {
                    this.panRingOrWafer(
                      drawLayout.drawLayoutPanResizeMode,
                      1,
                      0,
                    );
                  }}
                  variant="clear"
                  size="sm"
                  className="w40 btn-config"
                >
                  <small>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </small>
                </Button>
              </div>
            </div>
          </div>
        ),
      },
      {
        eventKey: "3",
        title: (
          <>
            <FontAwesomeIcon icon={faEdit} className="mr5" />
            Die Edit Controls
          </>
        ),
        body: (
          <div className="wcm-control-section-title">
            <table
              className="table table-bordered table-sm"
              style={{ marginBottom: 0, width: "100%" }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "6px 8px" }}>Action</th>
                  <th
                    style={{
                      padding: "6px 8px",
                      width: "60px",
                      textAlign: "center",
                    }}
                  >
                    Insert (+)
                  </th>
                  <th
                    style={{
                      padding: "6px 8px",
                      width: "60px",
                      textAlign: "center",
                    }}
                  >
                    Delete (−)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Die
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      onClick={() => {
                        if (this.plotter) {
                          const nextState = !isInsertDieControlActive;
                          if (nextState && isDeleteModeActive) {
                            this.plotter.deleteModeChangeHandler(
                              false,
                              DEVICE_WAFER_KEY,
                            );
                          }
                          this.plotter.addDieChangeHandler(
                            nextState,
                            DEVICE_WAFER_KEY,
                          );
                          this.setState((prevState) => ({
                            isInsertDieControlActive:
                              !prevState.isInsertDieControlActive,
                            isDeleteModeActive: nextState
                              ? false
                              : prevState.isDeleteModeActive,
                          }));
                        }
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                      style={
                        isInsertDieControlActive
                          ? {
                              backgroundColor: "#ff9800",
                              borderColor: "#ff9800",
                              color: "#fff",
                            }
                          : undefined
                      }
                      title="Insert die at clicked position"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      onClick={() => {
                        if (this.plotter) {
                          const nextState = !isDeleteModeActive;
                          if (nextState) {
                            this.changeWaferMapVariable({
                              selectionMode: SelectionMode.DIE,
                            });
                            if (isInsertDieControlActive) {
                              this.plotter.addDieChangeHandler(
                                false,
                                DEVICE_WAFER_KEY,
                              );
                            }
                          }
                          this.plotter.deleteModeChangeHandler(
                            nextState,
                            DEVICE_WAFER_KEY,
                          );
                          this.setState((prevState) => ({
                            isDeleteModeActive: !prevState.isDeleteModeActive,
                            isInsertDieControlActive: nextState
                              ? false
                              : prevState.isInsertDieControlActive,
                          }));
                        }
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                      style={
                        isDeleteModeActive
                          ? {
                              backgroundColor: "#d32f2f",
                              borderColor: "#d32f2f",
                              color: "#fff",
                            }
                          : undefined
                      }
                      title={
                        isDeleteModeActive
                          ? "Select dies on wafer, then delete"
                          : "Activate to select dies to delete"
                      }
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Row Below
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.INSERT_ROW_COL,
                              config: { dimension: "row", direction: "below" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.DELETE_ROW_COL,
                              config: { dimension: "row", direction: "below" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Row Above
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.INSERT_ROW_COL,
                              config: { dimension: "row", direction: "above" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.DELETE_ROW_COL,
                              config: { dimension: "row", direction: "above" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Column Left
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.INSERT_ROW_COL,
                              config: { dimension: "col", direction: "left" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.DELETE_ROW_COL,
                              config: { dimension: "col", direction: "left" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Column Right
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.INSERT_ROW_COL,
                              config: { dimension: "col", direction: "right" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.DELETE_ROW_COL,
                              config: { dimension: "col", direction: "right" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Shift Down
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_INSERT_DIES,
                              config: { direction: "below" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_DELETE_DIES,
                              config: { direction: "below" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Shift Up
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_INSERT_DIES,
                              config: { direction: "above" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_DELETE_DIES,
                              config: { direction: "above" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Shift Left
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_INSERT_DIES,
                              config: { direction: "left" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_DELETE_DIES,
                              config: { direction: "left" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 8px", verticalAlign: "middle" }}>
                    Shift Right
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_INSERT_DIES,
                              config: { direction: "right" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td style={{ padding: "6px 8px", textAlign: "center" }}>
                    <Button
                      disabled={isNoDieSelected}
                      title={isNoDieSelected ? selectDieTooltip : undefined}
                      onClick={() => {
                        if (isNoDieSelected) return;
                        this.uncheckReticleAndInsertOrDelete(() => {
                          PublishSubscribe().publishWithOthersID(
                            EventTypes.WAFER_DATA_REQUEST,
                            {
                              action: ActionOnWaferData.SHIFT_DELETE_DIES,
                              config: { direction: "right" },
                            },
                            "myid",
                          );
                        });
                      }}
                      variant="clear"
                      size="sm"
                      className="btn-config die-edit-icon-btn"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
      {
        eventKey: "4",
        title: (
          <>
            <FontAwesomeIcon icon={faCrosshairs} className="mr5" />
            Other Controls
          </>
        ),
        body: (
          <div className="wcm-control-body-small-text">
            <div className="wcm-control-button-container">
              <Button
                onClick={this.onClearDieTypesButtonClicked}
                variant="clear"
                size="sm"
                style={{ width: "150px" }}
                className="btn-config"
              >
                Clear Die Types
              </Button>
            </div>
            <div className="mt15">
              <CheckBox
                className="mr15"
                value={drawLayout.overlayReticle}
                onValueChange={this.onOverlayReticleCheckBoxValueChanged}
              />{" "}
              Overlay Reticle
            </div>
            <div className="mt15">
              <CheckBox
                disabled={!drawLayout.overlayReticle}
                className="mr15"
                value={drawLayout.showReferenceReticle}
                onValueChange={this.onShowReferenceReticleCheckBoxValueChanged}
              />{" "}
              Show Reference Reticle
            </div>
            <div className="mt15">
              <CheckBox
                className="mr15"
                value={drawLayout.markWaferCenter}
                onValueChange={(value: boolean) => {
                  this.onChangeDrawLayout(
                    { ...drawLayout, markWaferCenter: value },
                    () => {
                      this.onMarkWaferCenterChange(value);
                    },
                  );
                }}
              />{" "}
              Wafer Center
            </div>
            {drawLayout.overlayReticle && (
              <div className="mt15">
                <CheckBox
                  className="mr15"
                  value={showWATPCMSites}
                  onValueChange={(value: boolean) => {
                    this.setState({ showWATPCMSites: value }, () => {
                      this.changeWaferMapVariable({
                        showReticleText: value,
                        reticleTextField: value ? "watPCMSiteNumber" : "",
                      });
                    });
                  }}
                />{" "}
                Show WAT/PCM Sites
              </div>
            )}
            <div className="mt15">
              <div className="font-weight-bold">DieType Label Filters</div>
              <div className="mt5">
                {DIE_LABEL_DISPLAY_OPTIONS.map((option) => {
                  return (
                    <div key={option.value} className="mt5">
                      <label className="mb0" style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize : '11px' }}>
                        <input
                          type="radio"
                          name="die-label-display-mode"
                          value={option.value}
                          checked={dieLabelDisplayMode === option.value}
                          onChange={() => this.onDieLabelDisplayModeChanged(option.value)}
                        />
                        {option.label}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ),
      },
    ];
  };

  syncPcmWatMaxReticleRowsCols = (
    waferDefinitionData = this.state.waferDefinitionData,
    waferMapConfig = this.state.waferMapConfig,
  ) => {
    const { maxReticleRows, maxReticleCols } = UtilityFunctions.getPcmWatMaxReticleRowsCols({
      waferDefinitionData,
      waferMapConfig,
    });

    this.setState((prevState: WaferControlMapState) => ({
      pcmWatSiteMapTabData: {
        ...prevState.pcmWatSiteMapTabData,
        maxReticleRows: maxReticleRows ?? 0,
        maxReticleCols: maxReticleCols ?? 0,
      },
    }));
  };

  onApplyReticleLayout = async () => {
    const { pcmWatSiteMapTabData, waferMapConfig, waferDefinitionData } =
      this.state;
    if (
      pcmWatSiteMapTabData.reticleCalculationMethod ===
      ReticleCalculationMethod.ROWS_COLS
    ) {
      if (!waferMapConfig) return;

      const defaultLayout = UtilityFunctions.getPcmWatMaxReticleRowsCols({
        waferDefinitionData,
        waferMapConfig,
      });
      const maxReticleRows =
        +pcmWatSiteMapTabData.maxReticleRows || defaultLayout.maxReticleRows;
      const maxReticleCols =
        +pcmWatSiteMapTabData.maxReticleCols || defaultLayout.maxReticleCols;
      if (!maxReticleRows || !maxReticleCols) return;

      let leastX = null;
      let leastXDie = null;
      let maxX = Number.MIN_VALUE;
      let maxXDie = null;
      let leastY = null;
      let leastYDie = null;
      let maxY = Number.MIN_VALUE;
      let maxYDie = null;
      for (let i = 0; i < waferMapConfig.data.dies.length; i += 1) {
        for (let j = 0; j < waferMapConfig.data.dies[i].length; j += 1) {
          const dieData = waferMapConfig.data.dies[i][j];
          if (dieData && !dieData.isCropped && !dieData.isDeleted) {
            if (leastX === null) {
              leastX = j;
              leastXDie = dieData;
            }
            if (j > maxX) {
              maxX = j;
              maxXDie = dieData;
            }
            if (leastY === null) {
              leastY = i;
              leastYDie = dieData;
            }
            if (i > maxY) {
              maxY = i;
              maxYDie = dieData;
            }
          }
        }
      }

      if (!leastXDie || !leastYDie || !maxXDie || !maxYDie) return;
      const reticleSize = {
        x: +waferDefinitionData.reticleSizeX,
        y: +waferDefinitionData.reticleSizeY,
      };
      const leastSx = UtilityFunctions.getReticleGridRectCoordOfDie(
        leastXDie,
        reticleSize,
      ).startX;
      const leastSy = UtilityFunctions.getReticleGridRectCoordOfDie(
        leastYDie,
        reticleSize,
      ).startY;
      const maxEx = UtilityFunctions.getReticleGridRectCoordOfDie(
        maxXDie,
        reticleSize,
      ).endX;
      const maxEy = UtilityFunctions.getReticleGridRectCoordOfDie(
        maxYDie,
        reticleSize,
      ).endY;

      const reticleRows =
        (maxEy - leastSy + 1) / waferDefinitionData.reticleSizeY;
      const reticleCols =
        (maxEx - leastSx + 1) / waferDefinitionData.reticleSizeX;

      const colsBefore = Math.ceil((maxReticleCols - reticleCols) / 2);
      const startX = leastSx - colsBefore * waferDefinitionData.reticleSizeX;
      const endX = startX + waferDefinitionData.reticleSizeX - 1;
      const rowsBefore = Math.ceil((maxReticleRows - reticleRows) / 2);
      const startY = leastSy - rowsBefore * waferDefinitionData.reticleSizeY;
      const endY = startY + waferDefinitionData.reticleSizeY - 1;

      const data: { [key: string]: any } = {};
      for (let i = 0; i < maxReticleRows; i += 1) {
        for (let j = 0; j < maxReticleCols; j += 1) {
          data[
            JSON.stringify({
              startX: startX + j * waferDefinitionData.reticleSizeX,
              startY: startY + i * waferDefinitionData.reticleSizeY,
              endX: endX + j * waferDefinitionData.reticleSizeX,
              endY: endY + i * waferDefinitionData.reticleSizeY,
            })
          ] = {
            isSelected: false,
            isUnderSelection: false,
            watPCMSiteNumber: null,
          };
        }
      }
      this.setState((prevState: WaferControlMapState) => {
        if (!prevState.waferMapConfig) {
          return { waferMapConfig: prevState.waferMapConfig };
        }
        return {
          waferMapConfig: {
            ...prevState.waferMapConfig,
            reticleGridRectCoords: _.cloneDeep(data),
            referenceReticleGridRectCoords: null,
          },
        };
      });
      this.changeWaferMapVariable({
        reticleGridRectCoords: data,
        referenceReticleGridRectCoords: null,
      });
      if (this.plotter) {
        await this.plotter.actionHandler!(
          ActionType.PERFORM,
          DEVICE_WAFER_KEY,
          {
            actionDoMessage: "Apply reticle layout",
            actionUndoMessage: "Apply reticle layout",
          },
        );
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  onChangePCMWATMapTabData = (key: string, value: any, callback?: any) => {
    this.setState((prevState: WaferControlMapState) => {
      if (key in prevState.pcmWatSiteMapTabData) {
        const newPcmWatSiteMapTabData = _.cloneDeep(
          prevState.pcmWatSiteMapTabData,
        );
        newPcmWatSiteMapTabData[key] = value;
        return { pcmWatSiteMapTabData: newPcmWatSiteMapTabData };
      }
      return { pcmWatSiteMapTabData: prevState.pcmWatSiteMapTabData };
    });
  };

  onSaveZone = async (zoneData: ZoneData) => {
    if (!this.deviceWafer) return;
    let proceed = false;
    if (this.deviceWafer.getMarkedPCMSiteNumbers().length > 0) {
      if (zoneData.zoneType === "RADIAL") {
        const numberOfRadialZonesWithNoPCMSites =
          this.deviceWafer.getNumberOfRadialZonesWithNoPCMSites(
            zoneData.numberOfZones!,
          );
        if (numberOfRadialZonesWithNoPCMSites > 0) {
          if (
            await ModalPopup.confirm({
              header: "Confirmation",
              body: `${numberOfRadialZonesWithNoPCMSites} ${
                numberOfRadialZonesWithNoPCMSites > 1
                  ? "radial zones have"
                  : "radial zone has"
              } no PCM Site. Do you want to proceed?`,
            })
          ) {
            proceed = true;
          }
        } else {
          proceed = true;
        }
      } else if (zoneData.zoneType === "VERTICAL") {
        const numberOfVerticalZonesWithNoPCMSites =
          this.deviceWafer.getNumberOfVerticalZonesWithNoPCMSites(
            zoneData.numberOfZones!,
          );
        if (numberOfVerticalZonesWithNoPCMSites !== null) {
          if (numberOfVerticalZonesWithNoPCMSites > 0) {
            if (
              await ModalPopup.confirm({
                header: "Confirmation",
                body: `${numberOfVerticalZonesWithNoPCMSites} ${
                  numberOfVerticalZonesWithNoPCMSites > 1
                    ? "vertical zones have"
                    : "vertical zone has"
                } no PCM Site. Do you want to proceed?`,
              })
            ) {
              proceed = true;
            }
          } else {
            proceed = true;
          }
        }
      } else if (zoneData.zoneType === "HORIZONTAL") {
        const numberOfHoriontalZonesWithNoPCMSites =
          this.deviceWafer.getNumberOfHorizontalZonesWithNoPCMSites(
            zoneData.numberOfZones!,
          );
        if (numberOfHoriontalZonesWithNoPCMSites !== null) {
          if (numberOfHoriontalZonesWithNoPCMSites > 0) {
            if (
              await ModalPopup.confirm({
                header: "Confirmation",
                // eslint-disable-next-line max-len
                body: `${numberOfHoriontalZonesWithNoPCMSites} ${
                  numberOfHoriontalZonesWithNoPCMSites > 1
                    ? "horizontal zones have"
                    : "horizontal zone has"
                } no PCM Site. Do you want to proceed?`,
              })
            ) {
              proceed = true;
            }
          } else {
            proceed = true;
          }
        }
      } else {
        proceed = true;
      }
    } else {
      toast.error("Can not add / update zone. No PCM site is marked");
    }

    this.setState(
      (prevState: WaferControlMapState) => {
        if (proceed) {
          const newZones = _.cloneDeep(prevState.zones);
          const filteredZones = newZones.filter((z: ZoneData) => {
            return z.id === zoneData.id;
          });
          if (filteredZones.length === 0) {
            newZones.push(zoneData);
            toast.success("New zone added.");
            return {
              zones: newZones,
              selectedZoneId: zoneData.id,
            };
            // eslint-disable-next-line no-else-return
          } else {
            toast.success("Zone updated.");
            newZones.forEach((z: ZoneData, index: number) => {
              if (z.id === zoneData.id) {
                newZones[index] = zoneData;
              }
            });
            return {
              zones: newZones,
              selectedZoneId: prevState.selectedZoneId,
            };
          }
          // eslint-disable-next-line no-else-return
        } else {
          return {
            zones: prevState.zones,
            selectedZoneId: prevState.selectedZoneId,
          };
        }
      },
      async () => {
        const { selectedZoneId, zones } = this.state;
        this.changeWaferMapVariable(
          { currentZoneId: selectedZoneId, zones },
          false,
        );
        if (
          zoneData.zoneType === "RADIAL" &&
          zoneData.numberOfZones !== undefined &&
          proceed
        ) {
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            {
              action: ActionOnWaferData.APPLY_RADIAL_ZONE,
              config: {
                selectedZoneId,
              },
            },
            "myid",
          );
        } else if (zoneData.zoneType === "VERTICAL" && proceed) {
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            {
              action: ActionOnWaferData.APPLY_VERTICAL_ZONE,
              config: {
                selectedZoneId,
              },
            },
            "myid",
          );
        } else if (zoneData.zoneType === "HORIZONTAL" && proceed) {
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            {
              action: ActionOnWaferData.APPLY_HORIZONTAL_ZONE,
              config: {
                selectedZoneId,
              },
            },
            "myid",
          );
        } else if (zoneData.zoneType === "GROUPED_PER_SITE" && proceed) {
          PublishSubscribe().publishWithOthersID(
            EventTypes.WAFER_DATA_REQUEST,
            {
              action: ActionOnWaferData.APPLY_GROUPED_PER_SITE_ZONE,
              config: {
                selectedZoneId,
              },
            },
            "myid",
          );
        }
      },
    );
  };

  getSelectedZoneData = () => {
    const { zones, selectedZoneId } = this.state;
    let selectedZoneData: ZoneData = {
      id: null,
      zoneName: "",
      zoneType: "FREE_FORM",
      zoneApplication: [],
      createdBy: null,
      createdOn: null,
      updatedBy: null,
      updatedOn: null,
      numberOfZones: undefined,
      markedPCMSiteNumbers: [],
    };
    if (selectedZoneId) {
      const filteredZones = zones.filter((zone: ZoneData) => {
        return zone.id === selectedZoneId;
      });
      if (filteredZones.length > 0) {
        selectedZoneData = _.cloneDeep(filteredZones[0]);
      }
    }
    return selectedZoneData;
  };

  getTabContent = () => {
    const {
      waferDefinitionData,
      activeTab,
      pcmWatSiteMapTabData,
      middleViewport,
      waferMapConfig,
    } = this.state;
    let tabContent = null;
    let deviceMapBounds: {
      minX: number,
      maxX: number,
      minY: number,
      maxY: number,
    } | null = null;

    if (waferMapConfig?.data?.dies) {
      let minX = Number.POSITIVE_INFINITY;
      let maxX = Number.NEGATIVE_INFINITY;
      let minY = Number.POSITIVE_INFINITY;
      let maxY = Number.NEGATIVE_INFINITY;

      for (let rowIndex = 0; rowIndex < waferMapConfig.data.dies.length; rowIndex += 1) {
        const row = waferMapConfig.data.dies[rowIndex];
        if (!row) continue;
        for (let colIndex = 0; colIndex < row.length; colIndex += 1) {
          const die = row[colIndex];
          if (!die) continue;
          const rawX: unknown = die.x;
          const rawY: unknown = die.y;
          if (
            rawX === undefined || rawX === null || rawX === ''
            || rawY === undefined || rawY === null || rawY === ''
          ) continue;
          const dieX = Number(rawX);
          const dieY = Number(rawY);
          if (!Number.isFinite(dieX) || !Number.isFinite(dieY)) continue;
          if (dieX < minX) minX = dieX;
          if (dieX > maxX) maxX = dieX;
          if (dieY < minY) minY = dieY;
          if (dieY > maxY) maxY = dieY;
        }
      }

      if (Number.isFinite(minX) && Number.isFinite(maxX) && Number.isFinite(minY) && Number.isFinite(maxY)) {
        deviceMapBounds = {
          minX,
          maxX,
          minY,
          maxY,
        };
      }
    }

    switch (activeTab) {
      case ActiveTab.WAFER_DEFINTION:
        tabContent = (
          <div className="wafer-definition">
            <WaferDefinition
              ref={(ref: any) => {
                this.waferDefinitionRef = ref;
              }}
              waferDefinitionData={waferDefinitionData}
              deviceMapBounds={deviceMapBounds}
              onSaveWaferDefinitionData={this.onSaveWaferDefinitionData}
              onSaveReticleData={this.onSaveReticleData}
            />
          </div>
        );
        break;
      case ActiveTab.ADDITIONAL_ATTRIBUTES:
        tabContent = null;
        break;
      case ActiveTab.SITE_MAP:
        tabContent = (
          <PCMWATSiteMapTab
            pcmWatSiteMapTabData={pcmWatSiteMapTabData}
            formErrors={{}}
            onChangePCMWATMapTabData={this.onChangePCMWATMapTabData}
            onApplyReticleLayout={this.onApplyReticleLayout}
            onResetReticle={this.validateAndOverlayReticle}
            onCropSelectedReticles={this.onCropSelectedReticles}
            onPanReticle={(direction: ReticlePanDirection) => {
              PublishSubscribe().publishWithOthersID(
                EventTypes.WAFER_DATA_REQUEST,
                {
                  action: ActionOnWaferData.PAN_RETICLE,
                  config: {
                    direction,
                    increment: +pcmWatSiteMapTabData.panIncrement,
                    UOM: pcmWatSiteMapTabData.panIncrementUOM,
                    mode: pcmWatSiteMapTabData.panMode,
                  },
                },
                "myid",
              );
            }}
            onInsert={(direction: ReticleInsertDirection) => {
              PublishSubscribe().publishWithOthersID(
                EventTypes.WAFER_DATA_REQUEST,
                {
                  action: ActionOnWaferData.SHIFT_INSERT_RETICLE,
                  config: {
                    direction,
                  },
                },
                "myid",
              );
            }}
          />
        );
        break;
      case ActiveTab.DEFINE_ZONES:
        tabContent = this.deviceWafer ? (
          <DefineZonesTab
            viewDefineZonesBtnText={
              middleViewport === MiddleViewport.WAFER
                ? "View Defined Zones List"
                : "Device Map"
            }
            onClickDefineZones={() => {
              this.setState((prevState: WaferControlMapState) => {
                return {
                  middleViewport:
                    prevState.middleViewport === MiddleViewport.WAFER
                      ? MiddleViewport.ZONES
                      : MiddleViewport.WAFER,
                };
              });
            }}
            onChangeFreeFormPCMSiteNumber={(
              freeFormZonePCMSiteNumber: number | null,
            ) => {
              this.changeWaferMapVariable({ freeFormZonePCMSiteNumber }, false);
            }}
            zoneData={this.getSelectedZoneData()}
            onClear={() => {
              this.changeWaferMapVariable({ currentZoneId: "" }, true);
              this.setState({ selectedZoneId: null });
            }}
            onSaveZone={this.onSaveZone}
            deviceWafer={this.deviceWafer}
          />
        ) : null;
        break;
      default:
        tabContent = null;
        break;
    }
    return tabContent;
  };

  getWaferControlMapDataForRequest = () => {
    const {
      name,
      access,
      state,
      description,
      version,
      zones,
      owner,
      facility,
      workCenter,
      programName,
      lotId,
      waferId,
      waferDefinitionData,
      orignalWaferDimensions,
      WCMAttributeDefinitions,
      allWCMAttributeMetas,
    } = this.state;

    let dieWidthToStreetWidthRatio = 0;
    if (
      this.plotter &&
      waferDefinitionData.dieSizeX !== waferDefinitionData.dieStepSizeX
    ) {
      dieWidthToStreetWidthRatio =
        this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
          .dieWidthToStreetWidthRatio;
    }
    let dieHeightToStreetHeightRatio = 0;
    if (
      this.plotter &&
      waferDefinitionData.dieSizeY !== waferDefinitionData.dieStepSizeY
    ) {
      dieHeightToStreetHeightRatio =
        this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
          .dieHeightToStreetHeightRatio;
    }

    return {
      name,
      owner,
      state,
      version,
      description,
      access,
      diameter: waferDefinitionData.waferDiameter,
      diameterUOM: waferDefinitionData.waferDiameterUOM,
      edgeExclusion: waferDefinitionData.waferEdgeExclusion,
      edgeExclusionUOM: waferDefinitionData.waferEdgeExclusionUOM,
      exclusionOption: ExclusionType[waferDefinitionData.exclusionType],
      threshold: waferDefinitionData.edgeDieThreshold,
      scribeLine: waferDefinitionData.waferScribeLine,
      scribeLineUOM: waferDefinitionData.waferScribeLineUOM,
      baseFlat: waferDefinitionData.waferBaseFlat,
      baseFlatUOM: waferDefinitionData.waferBaseFlatUOM,
      notchKeepOut: waferDefinitionData.waferNotchKeepOut,
      notchKeepOutUOM: waferDefinitionData.waferNotchKeepOutUOM,
      flatKeepOut: waferDefinitionData.waferFlatKeepOut,
      flatKeepOutUOM: waferDefinitionData.waferFlatKeepOutUOM,
      inputNotchPosition: waferDefinitionData.waferInputNotchPosition,
      outputNotchPosition: waferDefinitionData.waferOutputNotchPosition,
      originLocation:
        WaferOriginLocation[waferDefinitionData.waferOriginLocation],
      axisDirection: WaferAxisDirection[waferDefinitionData.waferAxisDirection],
      xOriginValue: waferDefinitionData.xOriginValue ?? 0,
      yOriginValue: waferDefinitionData.yOriginValue ?? 0,
      axisOffsetX: waferDefinitionData.waferColOffset,
      axisOffsetY: waferDefinitionData.waferRowOffset,
      pGDW: waferDefinitionData.waferPGDW,
      dieUOM: waferDefinitionData.dieUOM,
      dieDimensionType: DieSpecType[waferDefinitionData.dieSpecType],
      dieWidth: waferDefinitionData.dieSizeX,
      dieHeight: waferDefinitionData.dieSizeY,
      dieStepWidth: waferDefinitionData.dieStepSizeX,
      dieStepHeight: waferDefinitionData.dieStepSizeY,
      reticleCols: waferDefinitionData.reticleSizeX,
      reticleRows: waferDefinitionData.reticleSizeY,
      reticleUOM: waferDefinitionData.reticleUOM,
      reticleOffsetX: waferDefinitionData.reticleOffsetX,
      reticleOffsetY: waferDefinitionData.reticleOffsetY,
      reticleReference: waferDefinitionData.reticleReference,
      reticlePlotSequence: waferDefinitionData.reticlePlotSequence || ReticlePlotSequence.HORIZONTAL_LEFT_TO_RIGHT,
      reticleNumberStartX: waferDefinitionData.reticleNumberStartX !== undefined && waferDefinitionData.reticleNumberStartX !== null && waferDefinitionData.reticleNumberStartX !== '' ? Number(waferDefinitionData.reticleNumberStartX) : 0,
      reticleNumberStartY: waferDefinitionData.reticleNumberStartY !== undefined && waferDefinitionData.reticleNumberStartY !== null && waferDefinitionData.reticleNumberStartY !== '' ? Number(waferDefinitionData.reticleNumberStartY) : 0,
      reticleOriginStartX: waferDefinitionData.reticleOriginStartX !== undefined && waferDefinitionData.reticleOriginStartX !== null && waferDefinitionData.reticleOriginStartX !== '' ? waferDefinitionData.reticleOriginStartX : 0,
      reticleOriginStartY: waferDefinitionData.reticleOriginStartY !== undefined && waferDefinitionData.reticleOriginStartY !== null && waferDefinitionData.reticleOriginStartY !== '' ? waferDefinitionData.reticleOriginStartY : 0,
      reticleWATPCMSite: waferDefinitionData.standardReticle.WATPCMSite,
      drawMethod: CalculationMethod[waferDefinitionData.calculationMethod],
      fixedCols: waferDefinitionData.waferMaxCols,
      fixedRows: waferDefinitionData.waferMaxRows,
      areStandardCoordinatesEnabled: this.plotter
        ? this.plotter.state.waferStates[DEVICE_WAFER_KEY]
            .isDieCoordinatesSystemEnabled
        : false,
      areReticleCoordinatesEnabled: this.plotter
        ? this.plotter.state.waferStates[DEVICE_WAFER_KEY]
            .isReticleCoordinatesSystemEnabled
        : false,
      dieWidthToStreetWidthRatio,
      dieHeightToStreetHeightRatio,
      waferWidthToColsRatio: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
            .waferWidthToColsRatio
        : 0,
      waferHeightToRowsRatio: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
            .waferHeightToRowsRatio
        : 0,
      waferBGOffsetXDies: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
            .waferBGOffsetXDies
        : 0,
      waferBGOffsetYDies: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
            .waferBGOffsetYDies
        : 0,
      overlayReticle: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].waferMapVariables
            .overlayReticle
        : false,
      waferWidthOrignal: orignalWaferDimensions.width,
      waferHeightOrignal: orignalWaferDimensions.height,
      hasSiteAttributes: waferDefinitionData.standardReticle.hasSiteAttributes,
      dies: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].getDiesList()
        : null,
      reticles: this.plotter
        ? this.plotter.waferUtils[DEVICE_WAFER_KEY].getReticlesList()
        : null,
      reticleSites: this.getReticleSites(waferDefinitionData.standardReticle),
      reticleSiteAttributes:
        waferDefinitionData.standardReticle.reticleSiteAttributesMeta.map(
          (rsam: ReticleSiteAttributeMeta) => {
            return {
              ...rsam,
              columnMeta: {
                ...rsam.columnMeta,
                type: MetaColumnType[rsam.columnMeta.type],
              },
            };
          },
        ),
      reticleSiteAttributeMappings: this.getReticleSiteAttributeMappings(
        waferDefinitionData.standardReticle,
      ),
      zones: zones.map((zoneData: ZoneData) => {
        return {
          id: zoneData.id,
          name: zoneData.zoneName,
          type: zoneData.zoneType,
          zoneApplication: zoneData.zoneApplication,
          markedPCMSiteNumbers: zoneData.markedPCMSiteNumbers,
          numberOfZones:
            zoneData.numberOfZones !== undefined &&
            zoneData.zoneType === "RADIAL"
              ? zoneData.numberOfZones
              : 0,
          verticalZoneColNumbers:
            zoneData.verticalZoneColNumbers === undefined
              ? null
              : zoneData.verticalZoneColNumbers,
          horizontalZoneRowNumbers:
            zoneData.horizontalZoneRowNumbers === undefined
              ? null
              : zoneData.horizontalZoneRowNumbers,
          ycoords: zoneData.ycoords === undefined ? null : zoneData.ycoords,
          xcoords: zoneData.xcoords === undefined ? null : zoneData.xcoords,
        };
      }),
      WCMAttributeDefinitions: WCMAttributeDefinitions.map((def: any) => {
        const lMeta = allWCMAttributeMetas?.find((m: any) => m.id === def.name);
        return {
          attributeMeta: {
            id: def.name,
            columnName: lMeta?.columnName ?? null,
          },
          expressionValue: def.value,
        };
      }),
      // Metadata fields
      facility,
      workCenter: workCenter || "Device Map",
      programName,
      lotId,
      waferId,
      memoryDetails: {
        ...this.state.memoryDetails,
        rows: this.state.memoryDetails.rows ?? 0,
        columns: this.state.memoryDetails.columns ?? 0,
      },
      patternDefinition: this.state.patternDefinition,
      complexPatterns: this.state.drawPattern.patterns.flatMap((pattern) => {
        const points = [];
        for (let r = 0; r < pattern.rows; r += 1) {
          for (let c = 0; c < pattern.cols; c += 1) {
            points.push({
              deviceID: pattern.id,
              x: c,
              y: r,
              isSelected: Boolean(pattern.grid?.[r]?.[c]),
            });
          }
        }
        return points;
      }),
    };
  };

  postWaferControlMap = async () => {
    this.setState({ isInSavingState: true }, async () => {
      const { history } = this.props;
      try {
        const response = await httpWaferControlMap.postWaferControlMap(
          this.getWaferControlMapDataForRequest(),
        );
        if (response) {
          if (response.success && response.statusCode === 200) {
            toast.success(response.message);
            this.setState({ isInSavingState: false }, () => {
              // Navigate to the new WCM - this will trigger a full reload via componentDidMount
              history.push(`/wafer-control-map/${response.data.id}`);
              // Note: After navigation, componentDidMount will be called which will reload all data
              // including die types with proper flags and values from the backend
            });
          } else {
            toast.error(response.message);
            this.setState({ isInSavingState: false });
          }
        } else {
          this.setState({ isInSavingState: false });
        }
      } catch (error) {
        toast.error('An error occurred while saving the wafer control map');
        this.setState({ isInSavingState: false });
      }
    });
  };

  putWaferControlMap = async () => {
    this.setState({ isInSavingState: true }, async () => {
      const { match, history } = this.props;
      try {
        const response = await httpWaferControlMap.putWaferControlMap(
          this.getWaferControlMapDataForRequest(),
          match.params.id,
        );
        if (response) {
          if (response.success && response.statusCode === 200) {
            toast.success(response.message);
            // Reload die types after successful save to ensure state is in sync
            const dieTypesResponse = await httpDieType.getDieTypes(match.params.id);
            let updatedDieTypes = this.state.dieTypes;
            if (dieTypesResponse && dieTypesResponse.success && dieTypesResponse.statusCode === 200) {
              updatedDieTypes = this.normalizeDieTypes(dieTypesResponse.data);
            }
            this.setState((prevState) => ({
              isInSavingState: false,
              version: response?.data?.version,
              WCMAttributeDefinitions: this.mapAttributeDefinitions(
                response.data.wcmAttributeDefinitions,
              ),
              dieTypes: updatedDieTypes,
            }), () => {
              // Update wafer map variables with the reloaded die types
              const { dieTypes } = this.state;
              if (this.deviceWafer) {
                this.changeWaferMapVariable({ dieTypes: { dieType: dieTypes } });
              }
              // Force grid refresh to ensure icons are properly displayed and data is shown
              if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
                this.runAfterNextPaint(() => {
                  try {
                    // Refresh the grid to show updated data including flags and values
                    this.dieTypesGridInstance!.instance.refresh();
                    // Ensure add button and icons are visible
                    this.onContentReadyForDieTypes();
                    // Force a repaint to ensure all values are displayed
                    this.dieTypesGridInstance!.instance.repaint();
                  } catch (error) {
                    console.warn("WCM die-types grid: non-critical error during post-save refresh", error);
                  }
                });
              }
            });
          } else {
            toast.error(response.message);
            this.setState({ isInSavingState: false });
            history.push("/wafer-control-map");
          }
        } else {
          this.setState({ isInSavingState: false });
          history.push("/wafer-control-map");
        }
      } catch (error) {
        console.error('Error updating wafer control map:', error);
        toast.error('An error occurred while updating the wafer control map');
        this.setState({ isInSavingState: false });
      }
    });
  };

  getReticleSiteAttributeMappings = (standardReticle: StandardReticle) => {
    const reticleSiteAttributeMappings: {
      [siteNumber: number]: { [columnName: string]: string };
    } = {};
    for (let i = 0; i < standardReticle.siteAttributesData.length; i += 1) {
      reticleSiteAttributeMappings[
        standardReticle.siteAttributesData[i].siteNumber
      ] = { ...standardReticle.siteAttributesData[i] };
      delete reticleSiteAttributeMappings[
        standardReticle.siteAttributesData[i].siteNumber
      ].siteNumber;
    }
    return reticleSiteAttributeMappings;
  };

  getReticleSites = (standardReticle: StandardReticle) => {
    const reticleSites: {
      siteRow: number;
      siteCol: number;
      siteNumber: number;
    }[] = [];
    for (let i = 0; i < standardReticle.reticle.length; i += 1) {
      for (let j = 0; j < standardReticle.reticle[i].length; j += 1) {
        reticleSites.push({
          siteRow: i,
          siteCol: j,
          siteNumber: standardReticle.reticle[i][j],
        });
      }
    }
    return reticleSites;
  };

  onSaveWCM = (data: ComponentHeaderData) => {
    const { waferDefinitionData } = this.state;
    let shouldSendRequest = false;
    if (this.waferDefinitionRef) {
      const waferDefinitionDataFromRef: WaferDefinitionData =
        this.waferDefinitionRef.state.waferDefinitionData;
      if (waferDefinitionDataFromRef.version === 1) {
        toast.warn("Please define wafer from the 'Wafer Definition' tab.");
      } else if (_.isEqual(waferDefinitionData, waferDefinitionDataFromRef)) {
        shouldSendRequest = true;
      } else {
        toast.warn(
          "Please define wafer from the 'Wafer Definition' tab using the new changes.",
        );
      }
    } else {
      shouldSendRequest = true;
    }
    if (shouldSendRequest) {
      this.setState(
        {
          name: data.name,
          owner: data.owner,
          access: data.access,
          version: data.version,
          description: data.description,
          state: data.state,
          // Store metadata fields from componentHeaderData
          facility: data.facility,
          workCenter: data.workCenter,
          programName: data.programName,
          lotId: data.lotId,
          waferId: data.waferId,
        },
        async () => {
          const { match } = this.props;

          await this.postWaferControlMap();
        },
      );
    }
  };

  private getWcmIdForDieTypeCalls = (): string | undefined => {
    const { match } = this.props;
    return this.isUpdateWCM ? match.params.id : undefined;
  };

  private normalizeDieTypes = (dieTypes: DieType[]): DieType[] => {
    return dieTypes.map((dieType: any) => {
      // Handle both possible field names from backend (hardBinFlag from JsonPropertyName or hardBinPassFlag from model)
      const hardBinFlagValue = dieType.hardBinFlag !== undefined 
        ? dieType.hardBinFlag 
        : (dieType.hardBinPassFlag !== undefined ? dieType.hardBinPassFlag : false);
      const softBinFlagValue = dieType.softBinFlag !== undefined 
        ? dieType.softBinFlag 
        : (dieType.softBinPassFlag !== undefined ? dieType.softBinPassFlag : false);
      
      // Handle hardBin and softBin - check both camelCase and PascalCase, and handle 0 as valid value
      let hardBinValue: number | null = null;
      if (dieType.hardBin !== undefined && dieType.hardBin !== null) {
        const parsed = Number(dieType.hardBin);
        if (!isNaN(parsed)) {
          hardBinValue = parsed; // This will preserve 0
        }
      } else if (dieType.HardBin !== undefined && dieType.HardBin !== null) {
        const parsed = Number(dieType.HardBin);
        if (!isNaN(parsed)) {
          hardBinValue = parsed; // This will preserve 0
        }
      }
      
      let softBinValue: number | null = null;
      if (dieType.softBin !== undefined && dieType.softBin !== null) {
        const parsed = Number(dieType.softBin);
        if (!isNaN(parsed)) {
          softBinValue = parsed; // This will preserve 0
        }
      } else if (dieType.SoftBin !== undefined && dieType.SoftBin !== null) {
        const parsed = Number(dieType.SoftBin);
        if (!isNaN(parsed)) {
          softBinValue = parsed; // This will preserve 0
        }
      }
      
      return {
        ...dieType,
        isDefaultDieType: dieType.isDefaultDieType !== undefined && dieType.isDefaultDieType !== null
          ? Boolean(dieType.isDefaultDieType)
          : (dieType.IsDefaultDieType !== undefined && dieType.IsDefaultDieType !== null
            ? Boolean(dieType.IsDefaultDieType)
            : false),
        // Ensure flags are always proper booleans and use consistent field names
        hardBinFlag: hardBinFlagValue !== undefined && hardBinFlagValue !== null 
          ? Boolean(hardBinFlagValue) 
          : false,
        softBinFlag: softBinFlagValue !== undefined && softBinFlagValue !== null 
          ? Boolean(softBinFlagValue) 
          : false,
        // Also ensure hardBin and softBin are properly set (including 0)
        hardBin: hardBinValue,
        softBin: softBinValue,
      };
    });
  };

  dieTypesGridInstance: any = null;

  // Track grid visibility issues and refresh when needed
  componentDidUpdate(prevProps: any, prevState: WaferControlMapState) {
    const { middleViewport } = this.state;
    const prevMiddleViewport = prevState.middleViewport;
    
    // Refresh grid when middleViewport changes to DIE_TYPES
    if (prevMiddleViewport !== middleViewport && middleViewport === MiddleViewport.DIE_TYPES) {
      // Refresh grid when it becomes visible to ensure rows render
      if (!(this as any)._gridVisibilityUpdateScheduled) {
        (this as any)._gridVisibilityUpdateScheduled = true;
        this.runAfterNextPaint(async () => {
          (this as any)._gridVisibilityUpdateScheduled = false;
          if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
            const grid = this.dieTypesGridInstance.instance;
            try {
              // Await grid refresh to complete before layout operations
              await grid.refresh();
              grid.repaint();
              // Also update dimensions in case container size changed
              if (typeof grid.updateDimensions === 'function') grid.updateDimensions();
              // Update scrollable without resetting position
              this.updateGridScrollable(grid);
              this.setupScrollGuard(grid);
            } catch (error) {
              console.warn("WCM die-types grid: error refreshing grid after visibility change", error);
            }
          }
        });
      }
    }
  }

  isUnassignedDieType = (dieType?: DieType | null) => {
    return dieType?.name?.trim().toLowerCase() === "unassigned";
  };

  canModifyDieType = (dieType?: DieType | null) => {
    if (!dieType) return false;
    if (this.isUnassignedDieType(dieType)) return false;
    return !this.isUpdateWCM || Boolean(dieType.sourceDieTypeId?.trim());
  };

  onRowPreparedForDieTypes = (e: any) => {
      const rowElement = e.rowElement;
    if (!rowElement) return;
        
    // Find command column cell
    const commandCell = this.findCommandCell(rowElement);
    if (!commandCell) return;
    
    // Ensure command cell is visible and properly styled
    // Remove any fixed positioning to allow scrolling with table
    commandCell.style.display = 'table-cell';
    commandCell.style.visibility = 'visible';
    commandCell.style.minWidth = '120px';
    commandCell.style.padding = '5px';
    commandCell.style.textAlign = 'center';
    
    // Remove fixed positioning using helper function
    this.removeCommandColumnFixedPositioning(undefined, commandCell);
    
    // Also ensure the command column header is not fixed
    const table = commandCell.closest('table');
    const commandColumn = table?.querySelector('colgroup col:last-child, colgroup col.dx-command-column');
    if (commandColumn) {
      (commandColumn as HTMLElement).style.position = '';
      (commandColumn as HTMLElement).style.left = '';
      (commandColumn as HTMLElement).style.right = '';
    }
    
    const grid = this.dieTypesGridInstance?.instance;
    if (!grid) return;
    
    // Check if row is new or in edit mode
    const isNewRow = e.rowType === 'new';
    const editRowKey = grid?.option('editing.editRowKey');
    const rowKey = e.key || e.data?.id;
    const isEditing = isNewRow || 
                      (editRowKey !== undefined && editRowKey !== null && editRowKey === rowKey) ||
                      (e.rowElement && e.rowElement.classList.contains('dx-row-edit')) ||
                      (e.row && e.row.isEditing) ||
                      (rowElement.querySelectorAll('.dx-editor-cell').length > 0);
    
    // Get all buttons in the command cell
    const editButton = commandCell.querySelector('.dx-command-edit') as HTMLElement ||
                       commandCell.querySelector('a.dx-link[aria-label*="Edit"], a.dx-link[aria-label*="edit"]') as HTMLElement;
    const deleteButton = commandCell.querySelector('.dx-command-delete') as HTMLElement ||
                         commandCell.querySelector('a.dx-link[aria-label*="Delete"], a.dx-link[aria-label*="delete"]') as HTMLElement;
    const saveButton = commandCell.querySelector('.dx-command-save') as HTMLElement ||
                       commandCell.querySelector('a.dx-link-save, a.dx-link[aria-label*="Save"], a.dx-link[aria-label*="save"]') as HTMLElement;
    const cancelButton = commandCell.querySelector('.dx-command-cancel') as HTMLElement ||
                        commandCell.querySelector('a.dx-link-cancel, a.dx-link[aria-label*="Cancel"], a.dx-link[aria-label*="cancel"]') as HTMLElement;
    
    if (isNewRow || isEditing) {
      // For new rows or rows in edit mode: Hide Edit/Delete, Show Save/Cancel
      
      // Ensure command cell is not fixed during edit mode
      commandCell.style.position = '';
      commandCell.style.left = '';
      commandCell.style.right = '';
      commandCell.style.top = '';
      commandCell.style.zIndex = '';
      commandCell.classList.remove('dx-command-column-fixed', 'dx-fixed-column', 'dx-fixed');
      
      // Hide Edit and Delete buttons
      this.setButtonVisibility(editButton, false);
      this.setButtonVisibility(deleteButton, false);
      
      // Just ensure existing Save and Cancel buttons are visible (DevExtreme creates them automatically)
      // Don't create new buttons, just show/hide existing ones and remove duplicates
      const allSaveButtons = commandCell.querySelectorAll('a.dx-link-save, .dx-command-save, [class*="save"]');
      const allCancelButtons = commandCell.querySelectorAll('a.dx-link-cancel, .dx-command-cancel, [class*="cancel"]');
      
      // Show only the first save button, remove duplicates
      allSaveButtons.forEach((btn: any, index: number) => {
        if (index === 0) {
          btn.style.display = 'inline-block';
          btn.style.visibility = 'visible';
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
          btn.style.marginRight = '5px';
                } else {
          // Remove duplicate save buttons
          if (btn.parentNode) {
            btn.parentNode.removeChild(btn);
          }
        }
      });
      
      // Show only the first cancel button, remove duplicates
      allCancelButtons.forEach((btn: any, index: number) => {
        if (index === 0) {
          btn.style.display = 'inline-block';
          btn.style.visibility = 'visible';
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        } else {
          // Remove duplicate cancel buttons
          if (btn.parentNode) {
            btn.parentNode.removeChild(btn);
          }
        }
      });
    } else {
      // For rows not in edit mode: Show Edit/Delete (if sourceDieTypeId exists), Hide Save/Cancel
      
      // Hide Save and Cancel buttons
      this.setButtonVisibility(saveButton, false);
      this.setButtonVisibility(cancelButton, false);
      
      // Show/hide Edit and Delete buttons based on sourceDieTypeId
      // Only show Edit/Delete for die types that belong to this WCM (have sourceDieTypeId)
      if (e.rowType === 'data' && e.data) {
        const dieType = e.data as DieType;
        const shouldShowEditDelete = this.canModifyDieType(dieType);
        
        if (!shouldShowEditDelete) {
          // Remove edit/delete buttons completely if they shouldn't be shown
          this.removeEditDeleteButtons(commandCell);
          // Set up MutationObserver to watch for new buttons being added and remove them
          this.setupEditDeleteObserver(commandCell);
        } else {
          // If buttons should be shown, disconnect observer if it exists
          if ((commandCell as any)._editDeleteObserver) {
            (commandCell as any)._editDeleteObserver.disconnect();
            delete (commandCell as any)._editDeleteObserver;
          }
        }
      } else {
        // For non-data rows, remove all edit/delete buttons
        this.removeEditDeleteButtons(commandCell);
      }
    }
  };

  onContentReadyForDieTypes = () => {
    // Process all visible rows after grid is ready to ensure icons are hidden/shown correctly
    if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
      const grid = this.dieTypesGridInstance.instance;
      
      // Set up scroll guard to prevent DOM mutations during scrolling
      this.setupScrollGuard(grid);
      
      // Ensure command column is not fixed - remove fixed positioning immediately
      this.removeCommandColumnFixedPositioning();
      
      // Function to process all data rows and hide/show edit/delete buttons
      const processAllDataRows = () => {
        try {
          const visibleRows = grid.getVisibleRows();
          visibleRows.forEach((row: any) => {
            if (row.rowType === 'data' && row.data && row.rowElement) {
              const dieType = row.data as DieType;
              const rowElement = row.rowElement;
              
              // Find command cell
              const commandCell = this.findCommandCell(rowElement);
              
              if (commandCell) {
                const shouldShowEditDelete = this.canModifyDieType(dieType);
                
                if (!shouldShowEditDelete) {
                  // Remove all edit and delete buttons from DOM
                  this.removeEditDeleteButtons(commandCell);
                  // Set up MutationObserver to watch for new buttons being added and remove them
                  this.setupEditDeleteObserver(commandCell);
                } else {
                  // If buttons should be shown, disconnect observer if it exists
                  if ((commandCell as any)._editDeleteObserver) {
                    (commandCell as any)._editDeleteObserver.disconnect();
                    delete (commandCell as any)._editDeleteObserver;
                  }
                }
              }
            }
          });
        } catch (error) {
          console.warn("WCM die-types grid: error in processAllDataRows", error);
        }
      };
      
      // Function to check and add buttons for rows in edit mode
      const checkEditModeRows = () => {
        try {
          const visibleRows = grid.getVisibleRows();
          visibleRows.forEach((row: any) => {
            // Check if row is in edit mode - try multiple methods
            // In DevExtreme, when a row is in edit mode, it has editor cells
            const hasEditorCells = row.rowElement && row.rowElement.querySelectorAll('.dx-editor-cell').length > 0;
            const hasEditClass = row.rowElement && row.rowElement.classList.contains('dx-row-edit');
            const isEditing = row.isEditing || hasEditClass || hasEditorCells;
            
            if (isEditing && row.rowElement) {
              const rowElement = row.rowElement;
              
              // Find command cell
              const commandCell = this.findCommandCell(rowElement);
              
              if (commandCell) {
                commandCell.style.display = 'table-cell';
                commandCell.style.visibility = 'visible';
                commandCell.style.minWidth = '120px';
                commandCell.style.padding = '5px';
                commandCell.style.textAlign = 'center';
                
                // Ensure command cell is not fixed during edit mode
                commandCell.style.position = '';
                commandCell.style.left = '';
                commandCell.style.right = '';
                commandCell.style.top = '';
                commandCell.style.zIndex = '';
                commandCell.classList.remove('dx-command-column-fixed', 'dx-fixed-column', 'dx-fixed');
                
                // Just ensure existing Save and Cancel buttons are visible
                // DevExtreme creates them automatically, we don't need to create new ones
                const existingSaveButton = commandCell.querySelector('a.dx-link-save, .dx-command-save') as HTMLElement;
                const existingCancelButton = commandCell.querySelector('a.dx-link-cancel, .dx-command-cancel') as HTMLElement;
                
                this.setButtonVisibility(existingSaveButton, true);
                this.setButtonVisibility(existingCancelButton, true);
              }
            }
          });
        } catch (error) {
          console.warn("WCM die-types grid: error in checkEditModeRows", error);
        }
      };
      
      // Process all data rows to hide/show edit/delete buttons
      processAllDataRows();
      this.runAfterNextPaint(processAllDataRows);
      
      // Check immediately and after next paint for edit mode rows
      checkEditModeRows();
      this.runAfterNextPaint(checkEditModeRows);
      
      // Also check for new rows after next paint
      this.runAfterNextPaint(() => this.ensureNewRowButtonsVisible());
      
      // Set up MutationObserver to watch for fixed positioning being applied - only if not already set
      if (!(this as any)._commandColumnObserver) {
        const observer = new MutationObserver(() => {
          // Skip mutations if user is scrolling
          if (this.isUserScrolling) {
            return;
          }
          this.removeCommandColumnFixedPositioning();
        });
        
        try {
          const gridElement = grid.element();
          observer.observe(gridElement, {
            attributes: true,
            attributeFilter: ['style', 'class'],
            childList: false,
            subtree: false
          });
          (this as any)._commandColumnObserver = observer;
        } catch (error) {
          console.warn("WCM die-types grid: error setting up command column MutationObserver", error);
        }
      }
      
      // Set up interval to check for edit mode rows and process data rows - but only if not already set
      if (!(this as any)._editModeCheckInterval) {
        (this as any)._editModeCheckInterval = setInterval(() => {
          checkEditModeRows();
          processAllDataRows();
          this.removeCommandColumnFixedPositioning();
        }, 500);
      }
    }
  };

  ensureNewRowButtonsVisible = () => {
    if (!this.dieTypesGridInstance || !this.dieTypesGridInstance.instance) {
      return;
    }
    
    try {
      const grid = this.dieTypesGridInstance.instance;
      const gridElement = grid.element();
      
      // Ensure add button is always visible in toolbar - try multiple selectors
      const toolbar = gridElement.querySelector('.dx-toolbar') as HTMLElement;
      if (toolbar) {
        // Try multiple selectors to find the add button
        let addButton = toolbar.querySelector('.dx-datagrid-addrow-button') as HTMLElement;
        if (!addButton) {
          addButton = toolbar.querySelector('a[aria-label*="Add"]') as HTMLElement;
        }
        if (!addButton) {
          addButton = toolbar.querySelector('a[aria-label*="add"]') as HTMLElement;
        }
        if (!addButton) {
          addButton = toolbar.querySelector('.dx-button.dx-button-success') as HTMLElement;
        }
        if (!addButton) {
          // Try finding by class containing 'add'
          const allButtons = toolbar.querySelectorAll('a, button, .dx-button');
          allButtons.forEach((btn: any) => {
            if (btn.className && (btn.className.includes('add') || btn.className.includes('Add'))) {
              addButton = btn as HTMLElement;
            }
            if (btn.getAttribute && btn.getAttribute('aria-label') && btn.getAttribute('aria-label').toLowerCase().includes('add')) {
              addButton = btn as HTMLElement;
            }
          });
        }
        if (addButton) {
          addButton.style.display = '';
          addButton.style.visibility = 'visible';
          addButton.style.opacity = '1';
          addButton.style.pointerEvents = 'auto';
          addButton.style.width = '';
          addButton.style.height = '';
        } else {
          // If add button not found, try to find and show the command column add button
          const commandColumn = gridElement.querySelector('.dx-command-column') as HTMLElement;
          if (commandColumn) {
            commandColumn.style.display = 'table-cell';
            commandColumn.style.visibility = 'visible';
          }
        }
      }
      
      const rows = grid.getVisibleRows();
      if (rows) {
        rows.forEach((row: any) => {
          // Handle new row (for adding)
          if (row.rowType === 'new') {
            const rowElement = row.rowElement;
            if (rowElement) {
              // Ensure new row is visible and editable
              rowElement.style.display = '';
              rowElement.style.visibility = 'visible';
              
              // Ensure command column is visible
              const commandCell = this.findCommandCell(rowElement);
              
              if (commandCell) {
                commandCell.style.display = 'table-cell';
                commandCell.style.visibility = 'visible';
                commandCell.style.minWidth = '120px';
                
                // Just ensure DevExtreme's default save and cancel buttons are visible
                // Don't create new ones, just show existing ones
                const saveButtons = commandCell.querySelectorAll('a.dx-link-save, .dx-command-save');
                const cancelButtons = commandCell.querySelectorAll('a.dx-link-cancel, .dx-command-cancel');
                
                // Show only the first save button, hide duplicates
                saveButtons.forEach((btn: any, index: number) => {
                  if (index === 0) {
                    this.setButtonVisibility(btn, true);
                    btn.style.marginRight = '5px';
                  } else {
                    // Remove duplicate save buttons
                    if (btn.parentNode) {
                      btn.parentNode.removeChild(btn);
                    }
                  }
                });
                
                // Show only the first cancel button, hide duplicates
                cancelButtons.forEach((btn: any, index: number) => {
                  if (index === 0) {
                    this.setButtonVisibility(btn, true);
                  } else {
                    // Remove duplicate cancel buttons
                    if (btn.parentNode) {
                      btn.parentNode.removeChild(btn);
                    }
                  }
                });
              }
            }
          }
          
          // Handle data rows
          if (row.rowType === 'data' && row.data) {
            const dieType = row.data as DieType;
            const rowElement = row.rowElement;
            if (rowElement) {
              // Find command column cell
              const commandCell = this.findCommandCell(rowElement);
              
              if (commandCell) {
                // Ensure command cell is always visible, has proper dimensions, and is rendered
                commandCell.style.display = 'table-cell';
                commandCell.style.visibility = 'visible';
                commandCell.style.width = '';
                commandCell.style.minWidth = '80px';
                commandCell.style.height = '';
                commandCell.style.padding = '';
                commandCell.style.margin = '';
                // Ensure the cell takes up space even if empty
                if (!commandCell.textContent && !commandCell.querySelector('.dx-command-edit') && !commandCell.querySelector('.dx-command-delete')) {
                  commandCell.innerHTML = '<span style="display: inline-block; width: 1px; height: 1px;">&nbsp;</span>';
                }
                
                const shouldShowEditDelete = this.canModifyDieType(dieType);
                
                if (!shouldShowEditDelete) {
                  // Remove all edit and delete buttons from DOM
                  this.removeEditDeleteButtons(commandCell);
                }
              }
            }
          }
        });
      }
    } catch (error) {
      console.warn("WCM die-types grid: error in ensureNewRowButtonsVisible", error);
    }
  };

  onEditingStartForDieTypes = (e: any) => {
    if (!this.canModifyDieType(e.data)) {
      e.cancel = true;
      this.runAfterNextPaint(() => this.refreshGridAfterEdit());
      return;
    }

    // When a row enters edit mode, ensure the grid repaints to show correct icons
    // The onRowPreparedForDieTypes handler will take care of showing Save/Cancel icons
    if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
      const grid = this.dieTypesGridInstance.instance;
      
      // Ensure command column is not fixed when entering edit mode
      const rowElement = e.row?.rowElement || e.event?.currentTarget?.closest('tr.dx-row');
      const commandCell = rowElement ? this.findCommandCell(rowElement) : null;
      this.removeCommandColumnFixedPositioning(undefined, commandCell || undefined);
      
      this.runAfterNextPaint(() => {
        try {
          grid.repaint();
          this.removeCommandColumnFixedPositioning(undefined, commandCell || undefined);
        } catch (error) {
          console.warn("WCM die-types grid: error in onEditingStartForDieTypes", error);
        }
      });
    }
  };

  onEditorPreparingForDieTypes = (e: any) => {
    if (e.parentType !== "dataRow" || e.dataField !== "name") {
      return;
    }

    const dieType = e.row?.data as DieType | undefined;
    if (!dieType?.isDefaultDieType) {
      return;
    }

    e.editorOptions = {
      ...e.editorOptions,
      disabled: true,
      readOnly: true,
    };
  };

  onInitNewRowForDieTypes = (e: any) => {
    // When a new row is initialized, ensure it's in edit mode
    // The onRowPreparedForDieTypes handler will take care of showing the correct icons
    // We just need to ensure the row is properly initialized
    
    // Initialize hardBin and softBin with 0 instead of null to trigger validation
    if (e.data) {
      if (e.data.hardBin === null || e.data.hardBin === undefined) {
        e.data.hardBin = 0;
      }
      if (e.data.softBin === null || e.data.softBin === undefined) {
        e.data.softBin = 0;
      }
    }
    
    if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
      const grid = this.dieTypesGridInstance.instance;
      
      // Ensure the new row is in edit mode (run after next paint so DOM is ready)
      this.runAfterNextPaint(() => {
        try {
          const visibleRows = grid.getVisibleRows();
          const newRow = visibleRows.find((r: any) => r.rowType === 'new');
          if (newRow && newRow.rowElement) {
            newRow.rowElement.style.display = '';
            newRow.rowElement.style.visibility = 'visible';
            grid.repaint();
          }
        } catch (error) {
          console.warn("WCM die-types grid: error in onInitNewRowForDieTypes", error);
        }
      });
    }
  };

  onRowInsertingForDieTypes = (e: any) => {
    // Validate before insert - cancel insert if validation fails to keep edit mode open
    const eventData = e.data;
    
    // Validate hardBin - required for new rows
    if (!("hardBin" in eventData) || eventData.hardBin === null || eventData.hardBin === undefined || eventData.hardBin === "") {
      toast.error("Hard Bin Number is required. Please enter a valid non-negative integer (0 or greater).");
      e.cancel = true;
      return;
    }
    const hardBinParsed = Number(eventData.hardBin);
    if (isNaN(hardBinParsed) || !Number.isInteger(hardBinParsed) || hardBinParsed < 0) {
      toast.error("Hard Bin Number must be a non-negative integer (0 or greater). Special characters, alphabets, decimal values, and negative numbers are not allowed.");
      e.cancel = true;
      return;
    }
    
    // Validate softBin - required for new rows
    if (!("softBin" in eventData) || eventData.softBin === null || eventData.softBin === undefined || eventData.softBin === "") {
      toast.error("Soft Bin Number is required. Please enter a valid non-negative integer (0 or greater).");
      e.cancel = true;
      return;
    }
    const softBinParsed = Number(eventData.softBin);
    if (isNaN(softBinParsed) || !Number.isInteger(softBinParsed) || softBinParsed < 0) {
      toast.error("Soft Bin Number must be a non-negative integer (0 or greater). Special characters, alphabets, decimal values, and negative numbers are not allowed.");
      e.cancel = true;
      return;
    }
  };

  // Run callback after next paint (replaces setTimeout for DOM/layout updates - no arbitrary delay)
  private runAfterNextPaint = (callback: () => void): void => {
    requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });
  };

  // Track if user is currently scrolling to avoid interfering with scroll
  private isUserScrolling = false;
  private scrollTimeoutId: any = null;

  // Set up scroll event tracking
  private setupScrollGuard = (grid: any): void => {
    if (!grid) return;
    try {
      const gridElement = typeof grid.element === 'function' ? grid.element() : grid.element;
      if (gridElement) {
        const scrollableEl = gridElement.querySelector('.dx-scrollable-container, .dx-scrollable-wrapper, .dx-viewport');
        if (scrollableEl && !scrollableEl._hasScrollGuard) {
          scrollableEl._hasScrollGuard = true;
          scrollableEl.addEventListener('scroll', () => {
            this.isUserScrolling = true;
            clearTimeout(this.scrollTimeoutId);
            this.scrollTimeoutId = setTimeout(() => {
              this.isUserScrolling = false;
            }, 150);
          }, { passive: true });
        }
      }
    } catch (e) {
      // ignore
    }
  };

  // Simplified scroll update - only update scrollable dimensions, don't reset position
  private updateGridScrollable = (grid: any): void => {
    if (!grid) return;
    try {
      const scrollable = grid.getScrollable && grid.getScrollable();
      if (scrollable && typeof scrollable.update === 'function') {
        scrollable.update();
      }
    } catch (e) {
      // ignore
    }
  };

  // Helper function to find command cell from row element
  findCommandCell = (rowElement: HTMLElement): HTMLElement | null => {
    let commandCell = rowElement.querySelector('td.dx-command-column') as HTMLElement;
    if (!commandCell) {
      commandCell = rowElement.querySelector('td[class*="command"]') as HTMLElement;
    }
    if (!commandCell) {
      const allCells = rowElement.querySelectorAll('td');
      if (allCells.length > 0) {
        commandCell = allCells[allCells.length - 1] as HTMLElement;
      }
    }
    return commandCell;
  };

  // Helper function to set button visibility
  setButtonVisibility = (button: HTMLElement | null, visible: boolean) => {
    if (!button) return;
    if (visible) {
      button.style.display = 'inline-block';
      button.style.visibility = 'visible';
      button.style.opacity = '1';
      button.style.pointerEvents = 'auto';
    } else {
      button.style.display = 'none';
      button.style.visibility = 'hidden';
      button.style.opacity = '0';
      button.style.pointerEvents = 'none';
    }
  };

  // Helper function to remove edit/delete buttons from command cell
  removeEditDeleteButtons = (commandCell: HTMLElement) => {
    const allEditButtons = commandCell.querySelectorAll(
      '.dx-command-edit, a.dx-link[aria-label*="Edit"], a.dx-link[aria-label*="edit"], .dx-datagrid-edit-button, [class*="edit"], [class*="Edit"]'
    );
    const allDeleteButtons = commandCell.querySelectorAll(
      '.dx-command-delete, a.dx-link[aria-label*="Delete"], a.dx-link[aria-label*="delete"], .dx-datagrid-delete-button, [class*="delete"], [class*="Delete"]'
    );
    
    allEditButtons.forEach((btn: any) => {
      if (btn && btn.parentNode) {
        btn.parentNode.removeChild(btn);
      }
    });
    
    allDeleteButtons.forEach((btn: any) => {
      if (btn && btn.parentNode) {
        btn.parentNode.removeChild(btn);
      }
    });
  };

  // Helper function to remove fixed positioning from command columns
  removeCommandColumnFixedPositioning = (gridElement?: HTMLElement, specificCell?: HTMLElement) => {
    try {
      const grid = this.dieTypesGridInstance?.instance;
      if (!grid && !gridElement) return;
      
      const element = gridElement || grid?.element();
      if (!element) return;
      
      // If a specific cell is provided, fix that cell
      if (specificCell) {
        specificCell.style.position = '';
        specificCell.style.left = '';
        specificCell.style.right = '';
        specificCell.style.top = '';
        specificCell.style.zIndex = '';
        specificCell.classList.remove('dx-command-column-fixed', 'dx-fixed-column', 'dx-fixed');
      }
      
      // Find all command columns and cells using multiple selectors
      const allSelectors = [
        '.dx-command-column',
        'td.dx-command-column',
        'col.dx-command-column',
        '[class*="command-column"]',
        '.dx-datagrid-rowsview .dx-command-column',
        '.dx-datagrid-headers .dx-command-column',
        'tr.dx-row-edit .dx-command-column',
        'tr.dx-row-edit td.dx-command-column'
      ];
      
      allSelectors.forEach(selector => {
        const elements = element.querySelectorAll(selector);
        elements.forEach((el: any) => {
          if (el) {
            el.style.setProperty('position', 'static', 'important');
            el.style.setProperty('left', 'auto', 'important');
            el.style.setProperty('right', 'auto', 'important');
            el.style.setProperty('top', 'auto', 'important');
            el.style.setProperty('z-index', 'auto', 'important');
            el.style.setProperty('transform', 'none', 'important');
            el.classList.remove('dx-command-column-fixed', 'dx-fixed-column', 'dx-fixed', 'dx-command-column-fixed-left', 'dx-command-column-fixed-right');
            
            // Also check computed style and force it
            const computedStyle = window.getComputedStyle(el);
            if (computedStyle.position === 'fixed' || computedStyle.position === 'sticky') {
              el.style.setProperty('position', 'static', 'important');
            }
          }
        });
      });
      
      // Also check all table cells in the last column (usually command column)
      const allRows = element.querySelectorAll('tr.dx-row, tr.dx-data-row, tr.dx-row-edit');
      allRows.forEach((row: any) => {
        if (row) {
          const cells = row.querySelectorAll('td');
          if (cells.length > 0) {
            const lastCell = cells[cells.length - 1];
            if (lastCell && (lastCell.classList.contains('dx-command-column') || lastCell.querySelector('.dx-command-edit, .dx-command-delete, .dx-command-save, .dx-command-cancel'))) {
              lastCell.style.position = 'static';
              lastCell.style.left = 'auto';
              lastCell.style.right = 'auto';
              lastCell.style.top = 'auto';
              lastCell.style.zIndex = 'auto';
              lastCell.classList.remove('dx-command-column-fixed', 'dx-fixed-column', 'dx-fixed');
            }
          }
        }
      });
    } catch (error) {
      console.warn("WCM die-types grid: error in removeCommandColumnFixedPositioning", error);
    }
  };

  // Helper function to setup MutationObserver for edit/delete buttons
  setupEditDeleteObserver = (commandCell: HTMLElement) => {
    if ((commandCell as any)._editDeleteObserver) {
      return; // Already set up
    }
    
    const observer = new MutationObserver((mutations) => {
      // Skip DOM mutations if user is actively scrolling
      if (this.isUserScrolling) {
        return;
      }

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node: any) => {
            if (node.nodeType === 1) { // Element node
              const isEditButton = node.classList?.contains('dx-command-edit') ||
                                 node.classList?.contains('dx-datagrid-edit-button') ||
                                 node.getAttribute?.('aria-label')?.toLowerCase().includes('edit') ||
                                 node.className?.toLowerCase().includes('edit');
              const isDeleteButton = node.classList?.contains('dx-command-delete') ||
                                    node.classList?.contains('dx-datagrid-delete-button') ||
                                    node.getAttribute?.('aria-label')?.toLowerCase().includes('delete') ||
                                    node.className?.toLowerCase().includes('delete');
              
              if ((isEditButton || isDeleteButton) && node.parentNode) {
                node.parentNode.removeChild(node);
              }
              
              // Also check children
              const childEditButtons = node.querySelectorAll?.(
                '.dx-command-edit, a.dx-link[aria-label*="Edit"], a.dx-link[aria-label*="edit"], .dx-datagrid-edit-button, [class*="edit"]'
              );
              const childDeleteButtons = node.querySelectorAll?.(
                '.dx-command-delete, a.dx-link[aria-label*="Delete"], a.dx-link[aria-label*="delete"], .dx-datagrid-delete-button, [class*="delete"]'
              );
              
              childEditButtons?.forEach((btn: any) => {
                if (btn && btn.parentNode) {
                  btn.parentNode.removeChild(btn);
                }
              });
              
              childDeleteButtons?.forEach((btn: any) => {
                if (btn && btn.parentNode) {
                  btn.parentNode.removeChild(btn);
                }
              });
            }
          });
        }
      });
    });
    
    observer.observe(commandCell, {
      childList: true,
      subtree: true
    });
    
    (commandCell as any)._editDeleteObserver = observer;
  };

  refreshGridAfterEdit = () => {
    // Helper function to refresh grid after edit operations
    if (this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
      this.runAfterNextPaint(() => {
        try {
          const grid = this.dieTypesGridInstance!.instance;
          const gridElement = grid.element();
          const editRows = gridElement.querySelectorAll('tr.dx-row-edit');
          editRows.forEach((row: any) => {
            row.classList.remove('dx-row-edit');
          });
          grid.cancelEditData();
          grid.option('editing.editRowKey', null);
          grid.refresh();
          if (this.onContentReadyForDieTypes) {
            this.onContentReadyForDieTypes();
          }
        } catch (error) {
          console.warn("WCM die-types grid: error in refreshGridAfterEdit", error);
        }
      });
    }
  };


  onRowUpdatingForDieTypes = (e: any) => {
    // Validate before update - cancel update if validation fails to keep edit mode open
    const eventData = e.newData;
    const currentDieType = this.state.dieTypes.find((dt: DieType) => dt.id === e.key);
    
    // Validate hardBin if being edited
    if ("hardBin" in eventData) {
      if (eventData.hardBin === null || eventData.hardBin === undefined || eventData.hardBin === "") {
        toast.error("Hard Bin Number cannot be null or empty. Please enter a valid non-negative integer (0 or greater).");
        e.cancel = true;
        return;
      }
      const parsed = Number(eventData.hardBin);
      if (isNaN(parsed) || !Number.isInteger(parsed) || parsed < 0) {
        toast.error("Hard Bin Number must be a non-negative integer (0 or greater). Special characters, alphabets, decimal values, and negative numbers are not allowed.");
        e.cancel = true;
        return;
      }
    }
    
    // Validate softBin if being edited
    if ("softBin" in eventData) {
      if (eventData.softBin === null || eventData.softBin === undefined || eventData.softBin === "") {
        toast.error("Soft Bin Number cannot be null or empty. Please enter a valid non-negative integer (0 or greater).");
        e.cancel = true;
        return;
      }
      const parsed = Number(eventData.softBin);
      if (isNaN(parsed) || !Number.isInteger(parsed) || parsed < 0) {
        toast.error("Soft Bin Number must be a non-negative integer (0 or greater). Special characters, alphabets, decimal values, and negative numbers are not allowed.");
        e.cancel = true;
        return;
      }
    }
  };

  onUpdateDieType = async (event: any) => {
    const lWcmId = this.getWcmIdForDieTypeCalls();

    // Get the current die type to preserve existing values
    const currentDieType = this.state.dieTypes.find((dt: DieType) => dt.id === event.key);

    // Ensure flags are always sent as proper booleans
    const hardBinFlagValue = "hardBinFlag" in event.data 
      ? Boolean(event.data.hardBinFlag) 
      : (currentDieType?.hardBinFlag !== undefined ? Boolean(currentDieType.hardBinFlag) : false);
    const softBinFlagValue = "softBinFlag" in event.data 
      ? Boolean(event.data.softBinFlag) 
      : (currentDieType?.softBinFlag !== undefined ? Boolean(currentDieType.softBinFlag) : false);
    
    // Handle hardBin and softBin - values are already validated in onRowUpdatingForDieTypes
    let hardBinValue = null;
    if ("hardBin" in event.data) {
      const parsed = Number(event.data.hardBin);
      if (!isNaN(parsed) && Number.isInteger(parsed) && parsed >= 0) {
        hardBinValue = parsed;
      }
    } else {
      // Field not being edited - preserve existing value
      hardBinValue = currentDieType?.hardBin !== undefined ? currentDieType.hardBin : null;
    }
    
    let softBinValue = null;
    if ("softBin" in event.data) {
      const parsed = Number(event.data.softBin);
      if (!isNaN(parsed) && Number.isInteger(parsed) && parsed >= 0) {
        softBinValue = parsed;
      }
    } else {
      // Field not being edited - preserve existing value
      softBinValue = currentDieType?.softBin !== undefined ? currentDieType.softBin : null;
    }
    
    const response = await httpDieType.putDieType(
      {
        name: event.data.name,
        color: event.data.color,
        isProbed: "isProbed" in event.data ? event.data.isProbed : (currentDieType?.isProbed ?? false),
        isYielded: "isYielded" in event.data ? event.data.isYielded : (currentDieType?.isYielded ?? false),
        isTouchDownAllowed:
          "isTouchDownAllowed" in event.data
            ? event.data.isTouchDownAllowed
            : (currentDieType?.isTouchDownAllowed ?? false),
        character: "character" in event.data ? event.data.character : (currentDieType?.character ?? ""),
        hardBin: hardBinValue,
        softBin: softBinValue,
        hardBinFlag: hardBinFlagValue,
        softBinFlag: softBinFlagValue,
        // IMPORTANT: Preserve isAssociated value 
        isAssociated: currentDieType?.isAssociated !== undefined ? currentDieType.isAssociated : true,
      },
      event.key,
      lWcmId,
    );
    if (response && response.success && response.statusCode === 200) {
      toast.success(response.message);
      this.setState((prevState: WaferControlMapState) => {
        // Find the updated die type from the response
        const updatedDieType = response.data.find((dt: DieType) => dt.id === event.key);
        if (updatedDieType) {
          // Merge the updated die type with the event data to ensure all changes are preserved
          // Always prioritize event.data values as they represent what the user actually entered
          const mergedDieType = {
            ...updatedDieType,
            // Always use event data values if they exist, otherwise use response data, otherwise use false
            hardBinFlag: event.data.hardBinFlag !== undefined 
              ? Boolean(event.data.hardBinFlag) 
              : (updatedDieType.hardBinFlag !== undefined ? Boolean(updatedDieType.hardBinFlag) : false),
            softBinFlag: event.data.softBinFlag !== undefined 
              ? Boolean(event.data.softBinFlag) 
              : (updatedDieType.softBinFlag !== undefined ? Boolean(updatedDieType.softBinFlag) : false),
            // Also preserve other fields from event data
            hardBin: event.data.hardBin !== undefined ? event.data.hardBin : (updatedDieType.hardBin ?? null),
            softBin: event.data.softBin !== undefined ? event.data.softBin : (updatedDieType.softBin ?? null),
          };
          const updatedDieTypes = prevState.dieTypes.map((dt: DieType) =>
            dt.id === event.key ? mergedDieType : dt
          );
          return { dieTypes: updatedDieTypes };
        }
        // If updated die type not found in response, update from event data
        const updatedDieTypes = prevState.dieTypes.map((dt: DieType) => {
          if (dt.id === event.key) {
            return {
              ...dt,
              ...event.data,
              hardBinFlag: event.data.hardBinFlag !== undefined ? Boolean(event.data.hardBinFlag) : (dt.hardBinFlag ?? false),
              softBinFlag: event.data.softBinFlag !== undefined ? Boolean(event.data.softBinFlag) : (dt.softBinFlag ?? false),
            };
          }
          return dt;
        });
        return { dieTypes: updatedDieTypes };
      }, () => {
        const { dieTypes } = this.state;
        this.changeWaferMapVariable({ dieTypes: { dieType: dieTypes } });
        this.refreshGridAfterEdit();
      });
    }
  };

  onAddDieType = async (event: any) => {
    const lWcmId = this.getWcmIdForDieTypeCalls();

    // Values are already validated in onRowInsertingForDieTypes
    // Parse hardBin and softBin values
    let hardBinValue = null;
    if ("hardBin" in event.data && event.data.hardBin !== null && event.data.hardBin !== undefined && event.data.hardBin !== "") {
      const parsed = Number(event.data.hardBin);
      if (!isNaN(parsed) && Number.isInteger(parsed) && parsed >= 0) {
        hardBinValue = parsed;
      }
    }
    
    let softBinValue = null;
    if ("softBin" in event.data && event.data.softBin !== null && event.data.softBin !== undefined && event.data.softBin !== "") {
      const parsed = Number(event.data.softBin);
      if (!isNaN(parsed) && Number.isInteger(parsed) && parsed >= 0) {
        softBinValue = parsed;
      }
    }

    const response = await httpDieType.postDieType({
      name: event.data.name,
      color: event.data.color,
      isProbed: "isProbed" in event.data ? event.data.isProbed : false,
      isYielded: "isYielded" in event.data ? event.data.isYielded : false,
      isTouchDownAllowed:
        "isTouchDownAllowed" in event.data
          ? event.data.isTouchDownAllowed
          : false,
      character: "character" in event.data ? event.data.character : "",
      hardBin: hardBinValue,
      softBin: softBinValue,
      hardBinFlag: "hardBinFlag" in event.data ? Boolean(event.data.hardBinFlag) : false,
      softBinFlag: "softBinFlag" in event.data ? Boolean(event.data.softBinFlag) : false,
    }, lWcmId);
    if (response && response.success && response.statusCode === 200) {
      toast.success(response.message);
      this.setState({ dieTypes: this.normalizeDieTypes(response.data) }, () => {
        const { dieTypes } = this.state;
        this.changeWaferMapVariable({ dieTypes: { dieType: dieTypes } });
        this.refreshGridAfterEdit();
      });
    }
  };

  sendDietypeDeletionRequest = async (
    checkUsage: boolean,
    dieTypeId: string,
    originalDieTypes?: DieType[],
  ) => {
    const lWcmId = this.getWcmIdForDieTypeCalls();
    const response = await httpDieType.deleteDieType(dieTypeId, checkUsage, lWcmId);
    if (response) {
      if (checkUsage && response.statusCode === 409) {
        if (
          await ModalPopup.confirm({
            header: "Confirmation",
            body: "This dietype is marked in some wafer control map. Do you want to proceed deleting it?",
          })
        ) {
          this.sendDietypeDeletionRequest(false, dieTypeId, originalDieTypes);
        } else {
          // User canceled - restore the row
          if (originalDieTypes) {
            this.setState({ dieTypes: originalDieTypes }, () => {
              this.refreshGridAfterEdit();
            });
          } else {
            this.setState((prevState: WaferControlMapState) => {
              return {
                dieTypes: prevState.dieTypes,
              };
            }, () => {
              this.refreshGridAfterEdit();
            });
          }
        }
      } else if (!response.success) {
        toast.error(response.message);
        // Restore the row if deletion failed
        if (originalDieTypes) {
          this.setState({ dieTypes: originalDieTypes }, () => {
            this.refreshGridAfterEdit();
          });
        }
      } else {
        toast.success(response.message);
        if (this.deviceWafer) this.deviceWafer.removeDieTypeFromDies(dieTypeId);
        this.changeWaferMapVariable({ dieTypes: { dieType: response.data } });
        this.setState({ dieTypes: response.data });
      }
    } else {
      // Response is null/undefined - restore the row
      toast.error("Failed to delete dietype. Please try again.");
      if (originalDieTypes) {
        this.setState({ dieTypes: originalDieTypes }, () => {
          this.refreshGridAfterEdit();
        });
      }
    }
  };

  onSavedForDieTypes = (event: any) => {
    // After save, ensure the row exits edit mode and icons are updated
    this.refreshGridAfterEdit();
  };

  onRowRemovingDieType = async (event: any) => {
    // Always cancel the deletion first - handle it manually after confirmation
    event.cancel = true;
    
    const dieTypeId = event.key || (event.data && event.data.id);
    if (!dieTypeId) {
      return;
    }

    const dieType = this.state.dieTypes.find((dt: DieType) => dt.id === dieTypeId);
    if (!this.canModifyDieType(dieType)) {
      return;
    }

    if (dieType && !dieType.isAssociated) {
      toast.error("Cannot delete default die type");
      return;
    }

    let shouldConfirmDeletion = false;
    let checkUsage = true;
    if (
      this.deviceWafer &&
      dieTypeId in this.deviceWafer!.waferMapVariables.dieTypeCountInfo &&
      this.deviceWafer!.waferMapVariables.dieTypeCountInfo[dieTypeId] > 0
    ) {
      shouldConfirmDeletion = true;
    }

    let proceedWithDeletion = false;
    if (shouldConfirmDeletion) {
      const confirmed = await ModalPopup.confirm({
        header: "Confirmation",
        body: "This dietype is marked in some wafer control map. Do you want to proceed deleting it?",
      });
      proceedWithDeletion = Boolean(confirmed);
      if (proceedWithDeletion) {
        checkUsage = false;
      }
    } else {
      // No confirmation needed, proceed with deletion
      proceedWithDeletion = true;
    }

    if (proceedWithDeletion) {
      // Manually delete the row and call the API
      await this.handleDieTypeDeletion(dieTypeId, checkUsage);
    }
    // If user cancels, event.cancel remains true, so row stays in grid
  };

  handleDieTypeDeletion = async (dieTypeId: string, checkUsage: boolean) => {
    // Store the original dieTypes in case we need to restore
    const originalDieTypes = [...this.state.dieTypes];
    
    // Remove from state first 
    const updatedDieTypes = this.state.dieTypes.filter((dt: DieType) => dt.id !== dieTypeId);
    this.setState({ dieTypes: updatedDieTypes });
    
    // Call the API
    await this.sendDietypeDeletionRequest(checkUsage, dieTypeId, originalDieTypes);
  };

  render() {
    const {
      waferMapConfig,
      dieTypes,
      allWCMAttributeMetas,
      WCMAttributeDefinitions,
      drawLayout,
      isInSavingState,
      isLoading,
      middleViewport,
      currentDieTypeId,
      activeTab,
      collapseTabsColumn,
      collapseDieSummaryColumn,
      waferDefinitionData,
      name,
      access,
      version,
      state,
      description,
      pcmWatTestMethod,
      pcmWatSiteNumber,
      maxPcmWatSiteNumber,
      watProbingSequence,
      zones,
      selectedZoneId,
      owner,
      facility,
      workCenter,
      programName,
      lotId,
      waferId,
      memoryDetails,
      patternDefinition,
      partialRowFailureBitsType,
      partialColumnFailureBitsType,
      drawPattern,
    } = this.state;
    const { history } = this.props;
    let centerArea = 7;
    if (collapseTabsColumn && collapseDieSummaryColumn) centerArea = 12;
    if (!collapseTabsColumn && collapseDieSummaryColumn) centerArea = 9;
    if (collapseTabsColumn && !collapseDieSummaryColumn) centerArea = 10;
    let totalRemovedDies = 0;
    let removedDiesPercentage = 0;
    const waferDataDies = this.deviceWafer?.waferMapVariables?.waferData?.dies;
    if (Array.isArray(waferDataDies)) {
      let nullCount = 0;
      let deletedCount = 0;
      for (let i = 0; i < waferDataDies.length; i += 1) {
        const row = waferDataDies[i];
        if (!Array.isArray(row)) continue;
        for (let j = 0; j < row.length; j += 1) {
          const d = row[j];
          if (!d) nullCount += 1;
          else if (d.isDeleted) deletedCount += 1;
        }
      }
      totalRemovedDies = nullCount + deletedCount;
      const currentTotalDies = this.deviceWafer ? this.deviceWafer.waferMapVariables.dieCount : 0;
      const denom = currentTotalDies + totalRemovedDies;
      removedDiesPercentage = denom !== 0 ? Math.round((totalRemovedDies / denom) * 100 * 100) / 100 : 0;
    }

    let rightSideBar: any = (
      <DieCountSummary
        isLoading={isLoading}
        dieTypes={dieTypes}
        middleViewport={middleViewport}
        currentDieTypeId={currentDieTypeId}
        onDieTypeDoubleClick={() => {
          this.setState({ middleViewport: MiddleViewport.DIE_TYPES });
        }}
        onDieTypeClick={(dieType: DieType | null) => {
          const newDietypeId = dieType === null ? null : dieType.id;
          this.changeWaferMapVariable({ currentDieType: newDietypeId }, false);
          this.setState({ currentDieTypeId: newDietypeId });
        }}
        enabledDieTypes={this.state.enabledDieTypes}
        onDieTypeToggle={this.onDieTypeToggle}
        countSummary={{
          dieTypeCountInfo: this.deviceWafer
            ? this.deviceWafer.waferMapVariables.dieTypeCountInfo
            : {},
          rowCount: this.deviceWafer
            ? this.deviceWafer.waferMapVariables.rowCount
            : 0,
          colCount: this.deviceWafer
            ? this.deviceWafer.waferMapVariables.colCount
            : 0,
          totalDieCount: this.deviceWafer
            ? this.deviceWafer.waferMapVariables.dieCount
            : 0,
          selectedDieCount: this.deviceWafer
            ? this.deviceWafer.waferMapVariables.selectedDieCount
            : 0,
        }}
        removedDiesCount={totalRemovedDies}
        removedDiesPercentage={removedDiesPercentage}
        onDefineDieTypesButtonClicked={async () => {
          if (this.dieTypesDatagrid) {
            if (!UtilityFunctions.isDataGridInEditMode(this.dieTypesDatagrid)) {
              this.setState((prevState) => {
                return {
                  middleViewport:
                    prevState.middleViewport === MiddleViewport.WAFER
                      ? MiddleViewport.DIE_TYPES
                      : MiddleViewport.WAFER,
                };
              });
            } else {
              // eslint-disable-next-line no-lonely-if
              if (
                middleViewport === MiddleViewport.DIE_TYPES &&
                (await ModalPopup.confirm({
                  header: "Changes Unsaved",
                  body: "You have unsaved changes in the die types grid. Do you want to proceed?",
                }))
              ) {
                this.setState((prevState) => {
                  return {
                    middleViewport:
                      prevState.middleViewport === MiddleViewport.WAFER
                        ? MiddleViewport.DIE_TYPES
                        : MiddleViewport.WAFER,
                  };
                });
              }
            }
          } else {
            this.setState((prevState) => {
              return {
                middleViewport:
                  prevState.middleViewport === MiddleViewport.WAFER
                    ? MiddleViewport.DIE_TYPES
                    : MiddleViewport.WAFER,
              };
            });
          }
        }}
      />
    );

    if (activeTab === ActiveTab.SITE_MAP) {
      rightSideBar = (
        <PCMWATSiteMapSideBar
          pcmWatTestMethod={pcmWatTestMethod}
          watProbingSequence={watProbingSequence}
          maxPcmWatSiteNumber={maxPcmWatSiteNumber}
          onChangePcmWatTestMethod={(newPcmWatTestMethod: string) => {
            this.changeWaferMapVariable(
              { currentWatTestMethod: newPcmWatTestMethod },
              false,
            );
            this.setState({ pcmWatTestMethod: newPcmWatTestMethod });
          }}
          onChangeWatProbingSequence={(newWatProbingSequence: string) => {
            this.setState({ watProbingSequence: newWatProbingSequence });
          }}
          pcmWatSiteNumber={pcmWatSiteNumber}
          onChangePcmWatSiteNumber={(value: string) => {
            const newPcmWatSiteNumber: number | null =
              value === "null" ? null : +value;
            this.changeWaferMapVariable(
              { currentWatPCMSiteNumber: newPcmWatSiteNumber },
              false,
            );
            this.setState({ pcmWatSiteNumber: newPcmWatSiteNumber });
          }}
          onAddPcmWatSite={() => {
            this.setState(
              (prevState: WaferControlMapState) => {
                return {
                  maxPcmWatSiteNumber: prevState.maxPcmWatSiteNumber + 1,
                };
              },
              () => {
                toast.success("PCM WAT Site number added to dropdown");
              },
            );
          }}
          onApplyFullWatMap={() => {
            PublishSubscribe().publishWithOthersID(
              EventTypes.WAFER_DATA_REQUEST,
              { action: ActionOnWaferData.APPLY_FULL_WAT_MAP, config: {} },
              "myid",
            );
          }}
        />
      );
    } else if (activeTab === ActiveTab.DEFINE_ZONES) {
      rightSideBar = null;
    }

    return (
      <Container fluid className="body-content-scroll wafer-control-map">
        <HomeDieCoordsForm onHomeDieSave={this.onSaveHomeDieCoordinates} />
        <TopbarNav
          title="Wafer Control Map"
          items={[]}
          showAvatar={false}
          showNotifications={false}
        />
        <Row className="pt0 pl30 pr30 mt10">
          <Col lg={12} className="mb20 pl0 pr0">
            <div className="custom-form mb0">
              <ComponentHeader
                isInSavingState={isInSavingState}
                componentHeaderData={{
                  name,
                  version,
                  access,
                  description,
                  state,
                  owner,
                  facility: facility || "",
                  workCenter: workCenter || "",
                  programName: programName || "",
                  lotId: lotId || "",
                  waferId: waferId || "",
                }}
                saveButtonText="Save wafer control map"
                onParentSave={this.onSaveWCM}
                onBack={async () => {
                  if (
                    await ModalPopup.confirm({
                      header: "Override Alert",
                      body: "Are you sure that you have saved all your changes. Do you want to proceed?",
                    })
                  ) {
                    history.push("/wafer-control-maps");
                  }
                }}
                isUpdateWCM={this.isUpdateWCM}
                showMetadata
                isEditMode={this.isUpdateWCM}
              />
            </div>
          </Col>
          <Col lg={12} className="mb20 pl0 pr0">
            <Row className="ml0 mr0 pt10 pl10 pr10 pb30 border-all background-color-light border-radius-4 wcm-main-row">
              {!collapseTabsColumn && (
                <Col
                  lg={3}
                  className="pr0 pl0 wcm-tabs-col"
                >
                  <Container style={{ borderBottom: "1px solid #ddd" }}>
                    <Row>
                      <Col className="pr1 pl1">
                        <div
                          onClick={() => {
                            this.changeWaferMapVariable({
                              selectionMode: SelectionMode.DIE,
                              markingMode: MarkingMode.DIE_TYPE,
                              dieColorType: DieColorType.DIE_TYPE,
                            });
                            this.setState({
                              activeTab: ActiveTab.WAFER_DEFINTION,
                              middleViewport: MiddleViewport.WAFER,
                            });
                          }}
                          className={`custom-tab ${
                            activeTab === ActiveTab.WAFER_DEFINTION
                              ? "active-custom-tab"
                              : ""
                          }`}
                        >
                          Wafer Definition
                        </div>
                      </Col>
                      <Col className="pr1 pl1">
                        <div
                          onClick={() => {
                            // TODO: Change this version after backend done
                            if (waferDefinitionData.version === 1) {
                              toast.warning("Please define wafer first");
                            } else {
                              this.setState({
                                activeTab: ActiveTab.ADDITIONAL_ATTRIBUTES,
                                middleViewport: MiddleViewport.UDA,
                              });
                            }
                          }}
                          className={`custom-tab ${
                            activeTab === ActiveTab.ADDITIONAL_ATTRIBUTES
                              ? "active-custom-tab"
                              : ""
                          }`}
                        >
                          Advanced Configurations
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr1 pl1">
                        <div
                          onClick={() => {
                            // TODO: Change this version after backend done
                            if (waferDefinitionData.version === 1) {
                              toast.warning("Please define wafer first");
                            } else {
                              const errors =
                                this.validateReticleData(waferDefinitionData);
                              if (Object.keys(errors).length !== 0) {
                                this.showErrorToasts(errors);
                              } else if (drawLayout.overlayReticle) {
                                this.changeWaferMapVariable({
                                  selectionMode: SelectionMode.RETICLE,
                                  markingMode: MarkingMode.WAT_PCM_SITE_NUMBER,
                                  dieTextField: "reticleSite",
                                  dieColorType: DieColorType.DIE_TYPE,
                                });
                                this.setState(
                                  (prevState: WaferControlMapState) => {
                                    let newWaferMapConfig =
                                      prevState.waferMapConfig;
                                    if (prevState.waferMapConfig) {
                                      newWaferMapConfig = {
                                        ...prevState.waferMapConfig,
                                        dieTextField: "reticleSite",
                                      };
                                    }
                                    const maxReticleLayout =
                                      UtilityFunctions.getPcmWatMaxReticleRowsCols({
                                        waferDefinitionData: prevState.waferDefinitionData,
                                        waferMapConfig: newWaferMapConfig,
                                      });
                                    return {
                                      waferMapConfig: newWaferMapConfig,
                                      activeTab: ActiveTab.SITE_MAP,
                                      middleViewport: MiddleViewport.WAFER,
                                      pcmWatSiteMapTabData:
                                        maxReticleLayout.maxReticleRows > 0
                                        && maxReticleLayout.maxReticleCols > 0
                                          ? {
                                            ...prevState.pcmWatSiteMapTabData,
                                            maxReticleRows: maxReticleLayout.maxReticleRows,
                                            maxReticleCols: maxReticleLayout.maxReticleCols,
                                          }
                                          : prevState.pcmWatSiteMapTabData,
                                    };
                                  },
                                );
                              } else {
                                toast.warning(
                                  "Please use other controls to overlay reticle first",
                                );
                              }
                            }
                          }}
                          className={`custom-tab ${
                            activeTab === ActiveTab.SITE_MAP
                              ? "active-custom-tab"
                              : ""
                          }`}
                        >
                          PCM/WAT Site Map
                        </div>
                      </Col>
                      <Col className="pr1 pl1">
                        <div
                          onClick={() => {
                            // TODO: Change this version after backend done
                            if (waferDefinitionData.version === 1) {
                              toast.warning("Please define wafer first");
                            } else {
                              const errors =
                                this.validateReticleData(waferDefinitionData);
                              if (Object.keys(errors).length !== 0) {
                                this.showErrorToasts(errors);
                              } else if (drawLayout.overlayReticle) {
                                this.changeWaferMapVariable({
                                  selectionMode: SelectionMode.RETICLE,
                                  markingMode: MarkingMode.ZONE_SITE,
                                  dieTextField: "zoneInfo",
                                  dieColorType: DieColorType.ZONE,
                                });
                                this.setState(
                                  (prevState: WaferControlMapState) => {
                                    let newWaferMapConfig =
                                      prevState.waferMapConfig;
                                    if (prevState.waferMapConfig) {
                                      newWaferMapConfig = {
                                        ...prevState.waferMapConfig,
                                        dieTextField: "zoneInfo",
                                      };
                                    }
                                    return {
                                      waferMapConfig: newWaferMapConfig,
                                      activeTab: ActiveTab.DEFINE_ZONES,
                                      middleViewport: MiddleViewport.WAFER,
                                    };
                                  },
                                );
                              } else {
                                toast.warning(
                                  "Please use other controls to overlay reticle first",
                                );
                              }
                            }
                          }}
                          className={`custom-tab ${
                            activeTab === ActiveTab.DEFINE_ZONES
                              ? "active-custom-tab"
                              : ""
                          }`}
                        >
                          Define Zones
                        </div>
                      </Col>
                    </Row>
                  </Container>
                  <Container>{this.getTabContent()}</Container>
                </Col>
              )}
              <Col lg={centerArea} className="wcm-center-area-col">
                <div
                  className="wcm-wafer-viewport"
                  style={{
                    display:
                      middleViewport === MiddleViewport.WAFER
                        ? "block"
                        : "none",
                  }}
                  ref={(ref: any) => {
                    this.waferDiv = ref;
                  }}
                >
                  {isLoading && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "430px" }}
                    >
                      <Spinner animation="border" />
                    </div>
                  )}
                  {!isLoading && waferMapConfig !== null && (
                    <WaferPlotter
                      WCMAttributeDefinitionsGetterSetter={{
                        get: this.getWCMAttributeDefinitions,
                        set: this.setWCMAttributeDefinitions,
                      }}
                      PCMWatSiteMapTabDataGetterSetter={{
                        get: this.getPCMWatSiteMapTabData,
                        set: this.setPCMWatSiteMapTabData,
                      }}
                      onWCMDefintionActionUndoRedo={
                        this.onWCMDefintionActionUndoRedo
                      }
                      getWaferDefinitionData={this.getWaferDefinitionData}
                      getOrignalWaferDimensions={this.getOrignalWaferDimensions}
                      drawLayoutGetterSetter={{
                        get: this.getDrawLayoutData,
                        set: this.setDrawLayoutFromDbState,
                      }}
                      draggableControlsWidth={250}
                      width={this.canvasDimension}
                      height={this.canvasDimension}
                      ref={(r) => {
                        this.plotter = r;
                      }}
                      onMainControlSelectionChange={
                        this.onMainControlSelectionChange
                      }
                      plotterKey={DEVICE_WAFER_KEY}
                      config={{
                        [DEVICE_WAFER_KEY]: {
                          additionalControls: this.getAdditionalControls(),
                          dieTextField: waferMapConfig.dieTextField,
                          onContextMenuItemClick: (event: any) => {
                            switch (event.itemData.action) {
                              case WCMContextMenuAction.EXPAND_WAFER:
                                this.onChangeLayout(true, true);
                                break;
                              case WCMContextMenuAction.COLLAPSE_WAFER:
                                this.onChangeLayout(false, false);
                                break;
                              case WCMContextMenuAction.COLLAPSE_DIE_SUMMARY:
                                this.onChangeLayout(null, true);
                                break;
                              case WCMContextMenuAction.EXPAND_DIE_SUMMARY:
                                this.onChangeLayout(null, false);
                                break;
                              case WCMContextMenuAction.COLLAPSE_DEFINITION_TABS:
                                this.onChangeLayout(true, null);
                                break;
                              case WCMContextMenuAction.EXPAND_DEFINITION_TABS:
                                this.onChangeLayout(false, null);
                                break;
                              default:
                                break;
                            }
                          },
                          contextMenuDataSource: [
                            {
                              text: "Layout",
                              items: [
                                {
                                  text:
                                    collapseTabsColumn &&
                                    collapseDieSummaryColumn
                                      ? "Collapse Wafer"
                                      : "Expand Wafer",
                                  action:
                                    collapseTabsColumn &&
                                    collapseDieSummaryColumn
                                      ? WCMContextMenuAction.COLLAPSE_WAFER
                                      : WCMContextMenuAction.EXPAND_WAFER,
                                },
                                {
                                  text: collapseTabsColumn
                                    ? "Expand Definition Tabs"
                                    : "Collapse Definition Tabs",
                                  action: collapseTabsColumn
                                    ? WCMContextMenuAction.EXPAND_DEFINITION_TABS
                                    : WCMContextMenuAction.COLLAPSE_DEFINITION_TABS,
                                },
                                {
                                  text: collapseDieSummaryColumn
                                    ? "Expand Die Summary"
                                    : "Collapse Die Summary",
                                  action: collapseDieSummaryColumn
                                    ? WCMContextMenuAction.EXPAND_DIE_SUMMARY
                                    : WCMContextMenuAction.COLLAPSE_DIE_SUMMARY,
                                },
                              ],
                            },
                          ],
                        },
                      }}
                    />
                  )}
                </div>

                <div
                  className="die-types-grid"
                  style={{
                    display:
                      middleViewport === MiddleViewport.DIE_TYPES
                        ? "block"
                        : "none",
                  }}
                  ref={(el) => {
                    if (el && middleViewport === MiddleViewport.DIE_TYPES && this.dieTypesGridInstance && this.dieTypesGridInstance.instance) {
                      // Mark grid as visible - setRef will handle the actual refresh
                      if (!(this as any)._gridVisibilityRefreshScheduled) {
                        (this as any)._gridVisibilityRefreshScheduled = true;
                        this.runAfterNextPaint(async () => {
                          (this as any)._gridVisibilityRefreshScheduled = false;
                          const grid = this.dieTypesGridInstance.instance;
                          if (grid) {
                            try {
                              // Await grid refresh to complete before layout operations
                              await grid.refresh();
                              grid.repaint();
                              if (typeof grid.updateDimensions === 'function') grid.updateDimensions();
                              this.updateGridScrollable(grid);
                              this.setupScrollGuard(grid);
                            } catch (error) {
                              console.warn("WCM die-types grid: error refreshing grid in container ref", error);
                            }
                          }
                        });
                      }
                    }
                  }}
                >
                  <EditableDataGrid
                    key={`die-types-grid-${this.isUpdateWCM ? (this.props.match?.params?.id || 'new') : 'new'}`}
                    height={400}
                    showFilterRow
                    showAdvancedFilters={false}
                    enableColumnChooser={false}
                    showGroupPanel={false}
                    showRowLines
                    showColumnLines
                    allowAdding
                    allowUpdating
                    allowDeleting
                    columnAutoWidth
                    columnFixing={false}
                    columnHidingEnabled
                    // Use standard scrolling to avoid virtualization render issues when toggling visibility
                    scrollMode="standard"
                    editingMode="row"
                    newRowPosition="last"
                    keyExpr="id"
                    totalRowsToDisplay={Array.isArray(dieTypes) && dieTypes.length > 0 ? dieTypes.length : 1000}
                    setRef={(ref: any) => {
                      this.dieTypesGridInstance = ref;
                      if (ref && ref.instance) {
                        // Only refresh if grid is currently visible
                        if (this.state.middleViewport === MiddleViewport.DIE_TYPES) {
                          if (!(this as any)._gridRefreshScheduled) {
                            (this as any)._gridRefreshScheduled = true;
                            this.runAfterNextPaint(async () => {
                              (this as any)._gridRefreshScheduled = false;
                              const grid = ref.instance;
                              if (grid) {
                                try {
                                  // Await grid refresh to complete before layout operations
                                  await grid.refresh();
                                  grid.repaint();
                                  if (typeof grid.updateDimensions === 'function') grid.updateDimensions();
                                  this.updateGridScrollable(grid);
                                  this.setupScrollGuard(grid);
                                } catch (error) {
                                  console.warn("WCM die-types grid: error refreshing grid in setRef", error);
                                }
                              }
                            });
                          }
                        }
                      }
                    }}
                    onContentReady={this.onContentReadyForDieTypes}
                    onRowUpdating={this.onRowUpdatingForDieTypes}
                    onRowUpdated={this.onUpdateDieType}
                    onRowInserted={this.onAddDieType}
                    onRowRemoving={this.onRowRemovingDieType}
                 // onRowRemoved={this.onDeleteDieType}
                    onSaved={this.onSavedForDieTypes}
                    onRowPrepared={this.onRowPreparedForDieTypes}
                    onInitNewRow={this.onInitNewRowForDieTypes}
                    onRowInserting={this.onRowInsertingForDieTypes}
                    onEditingStart={this.onEditingStartForDieTypes}
                    onEditorPreparing={this.onEditorPreparingForDieTypes}
                    tableData={dieTypes}
                    fields={[
                      {
                        caption: "Name",
                        dataField: "name",
                        dataType: "string",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        cellType: "textBox",
                        isRequired: true,
                        width: 200,
                        minWidth: 150,
                        wordWrap: true,
                        validationRules: [
                          <PatternRule
                            message="Die Name Should Not Exceed 30 Characters"
                            pattern={/^.{1,30}$/i}
                          />,
                        ],
                      },
                      {
                        caption: "Color",
                        dataField: "color",
                        dataType: "string",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: false,
                        allowSorting: false,
                        cellType: "textBox",
                        isRequired: true,
                        width: 90,
                        minWidth: 90,
                        editCellRender: (cell: any) => {
                            // Configure positioning to ensure color picker is fully visible - use body as container
                          const colorPickerOptions: any = {
                            onShowing: (e: any) => {
                              // Use document.body as container to avoid grid container constraints
                              // This allows the popup to render outside the grid and be fully visible
                              e.component.option({
                                container: document.body,
                                position: {
                                 collision: 'fit flip' // Fit within viewport, flip if needed
                                },
                                // Ensure popup stays within viewport bounds
                                maxHeight: Math.min(window.innerHeight * 0.9, 600),
                                height: 'auto',
                                width: 'auto'
                              });
                            }
                          };
                          return (
                            <ColorBox
                              defaultValue={cell.value || "#000000"}
                              width="100%"
                              // eslint-disable-next-line react/jsx-props-no-spreading
                              {...cell.column.lookup}
                              dropDownOptions={colorPickerOptions}
                              onValueChanged={(event: any) => {
                                cell.setValue(event.value);
                              }}
                            />
                          );
                        },
                        cellRender: (e: any) => {
                          if (e.data) {
                            return (
                              <div
                                className="h20 mr5 mt0 ml0 mb0 "
                                style={{ backgroundColor: e.data.color }}
                              />
                            );
                          }
                          return null;
                        },
                      },
                      {
                        caption: "Probed",
                        dataField: "isProbed",
                        dataType: "boolean",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        isRequired: false,
                        cellType: "textBox",
                      },
                      {
                        caption: "Yielded",
                        dataField: "isYielded",
                        dataType: "boolean",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        isRequired: false,
                        cellType: "textBox",
                      },
                      {
                        caption: "Touch Down Allowed",
                        dataField: "isTouchDownAllowed",
                        dataType: "boolean",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        isRequired: false,
                        cellType: "textBox",
                      },
                      {
                        caption: "Character",
                        dataField: "character",
                        dataType: "string",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        cellType: "textBox",
                        isRequired: false,
                        validationRules: [
                          <PatternRule
                            message="Character Should Not Exceed 255 Characters"
                            pattern={/^.{1,255}$/i}
                          />,
                        ],
                      },
                      // Add Hard Bin Number column
                      {
                        caption: "Hard Bin Number",
                        dataField: "hardBin",
                        dataType: "number",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        cellType: "textBox",
                        isRequired: false, // Optional; set to true if required
                        editCellRender: (cell: any) => (
                          <DevExtremeTextBox
                            defaultValue={cell.value}
                            onValueChanged={(e) => { cell.setValue(e.value); }}
                            maxLength={9}
                            mode="text"
                          />
                        ),
                        validationRules: [
                          <NumericRule
                            key="hardBin-numeric"
                            message="Hard Bin must be a positive integer"
                          />,
                          <RangeRule
                            key="hardBin-range"
                            min={0}
                            message="Hard Bin must be a non-negative integer (0 or greater)"
                          />,
                          <StringLengthRule
                            key="hardBin-length"
                            max={9}
                            message="Cannot enter more than 9 digits"
                          />,
                          <PatternRule
                            key="hardBin-pattern"
                            message="Hard Bin must be a non-negative integer. Special characters, alphabets, decimal values, and negative numbers are not allowed"
                            pattern={/^\d+$/} // Regex for non-negative integers (0, 1, 2, 3, ...)
                          />,
                        ],
                      },
                      // Add Soft Bin Number column
                      {
                        caption: "Soft Bin Number",
                        dataField: "softBin",
                        dataType: "number",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        cellType: "textBox",
                        isRequired: false, // Optional; set to true if required
                        editCellRender: (cell: any) => (
                          <DevExtremeTextBox
                            defaultValue={cell.value}
                            onValueChanged={(e) => { cell.setValue(e.value); }}
                            maxLength={9}
                            mode="text"
                          />
                        ),
                        validationRules: [
                          <NumericRule
                            key="softBin-numeric"
                            message="Soft Bin must be a positive integer"
                          />,
                          <RangeRule
                            key="softBin-range"
                            min={0}
                            message="Soft Bin must be a non-negative integer (0 or greater)"
                          />,
                          <StringLengthRule
                            key="softBin-length"
                            max={9}
                            message="Cannot enter more than 9 digits"
                          />,
                          <PatternRule
                            key="softBin-pattern"
                            message="Soft Bin must be a non-negative integer. Special characters, alphabets, decimal values, and negative numbers are not allowed"
                            pattern={/^\d+$/} // Regex for non-negative integers (0, 1, 2, 3, ...)
                          />,
                        ],
                      },
                      // Add Hard Bin Flag column
                      {
                        caption: "Hard Bin Flag",
                        dataField: "hardBinFlag",
                        dataType: "boolean",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        isRequired: false,
                        cellType: "textBox",
                        cellRender: (data: any) => (data.value ? "Pass" : "Fail"),
                        lookup: {
                          dataSource: [
                            { value: true, text: "Pass" },
                            { value: false, text: "Fail" },
                          ],
                          valueExpr: "value",
                          displayExpr: "text",
                        },
                      } as any,
                      // Add Soft Bin Flag column
                      {
                        caption: "Soft Bin Flag",
                        dataField: "softBinFlag",
                        dataType: "boolean",
                        allowEditing: true,
                        showInfo: false,
                        allowFiltering: true,
                        allowSorting: true,
                        isRequired: false,
                        cellType: "textBox",
                        cellRender: (data: any) => (data.value ? "Pass" : "Fail"),
                        lookup: {
                          dataSource: [
                            { value: true, text: "Pass" },
                            { value: false, text: "Fail" },
                          ],
                          valueExpr: "value",
                          displayExpr: "text",
                        },
                      } as any,
                    ]}
                  />
                </div>

                <div
                  style={{
                    display:
                      middleViewport === MiddleViewport.ZONES
                        ? "block"
                        : "none",
                  }}
                >
                  <h5>Defined Zones</h5>
                  <DataGrid
                    keyExpr="id"
                    ref={(datagrid: any) => {
                      this.zonesDatagrid = datagrid;
                    }}
                    style={{
                      marginTop: "20px",
                      clear: "both",
                      fontSize: "8px",
                    }}
                    dataSource={zones}
                    hoverStateEnabled
                    height="400px"
                    allowColumnReordering
                    rowAlternationEnabled
                    showColumnLines={false}
                    showRowLines={false}
                    onRowRemoved={() => {
                      this.changeWaferMapVariable({ currentZoneId: null });
                      this.setState({ selectedZoneId: null });
                    }}
                    columnMinWidth={200}
                    selectedRowKeys={[selectedZoneId]}
                    onSelectedRowKeysChange={(e: any) => {
                      if (e.length > 0) {
                        this.changeWaferMapVariable({ currentZoneId: e[0] });
                        this.setState({ selectedZoneId: e[0] });
                      }
                    }}
                  >
                    <Selection mode="single" />
                    <Scrolling mode="standard" />
                    <Column dataField="zoneName" />
                    <Column dataField="zoneType" />
                    <Column dataField="zoneApplication" width={450} />
                    <Column dataField="createdBy" />
                    <Column dataField="createdOn" />
                    <Column dataField="updatedBy" />
                    <Column dataField="updatedOn" />

                    <Editing
                      useIcons
                      allowDeleting
                      confirmDelete={false}
                      mode="row"
                    />
                  </DataGrid>
                </div>

                <div
                  className="wcm-uda-viewport"
                  style={{
                    display:
                      middleViewport === MiddleViewport.UDA ? "block" : "none",
                  }}
                >
                  <h4 style={{ marginTop: "10px" }}>Additional Attributes</h4>
                  <AttributesGrid
                    needAccess={false}
                    needLevel={false}
                    needDatatype={false}
                    needUDAAccess={false}
                    needUDAConstraints={false}
                    needUDAType={false}
                    parentId="myid"
                    onDeleteAttributeDefinition={async () => {
                      if (this.plotter) {
                        await this.plotter.actionHandler!(
                          ActionType.PERFORM,
                          DEVICE_WAFER_KEY,
                          {
                            actionDoMessage: "Delete attribute",
                            actionUndoMessage: "Delete attribute",
                          },
                        );
                      }
                    }}
                    onAddAttributeDefinition={async () => {
                      if (this.plotter) {
                        await this.plotter.actionHandler!(
                          ActionType.PERFORM,
                          DEVICE_WAFER_KEY,
                          {
                            actionDoMessage: "Add attribute",
                            actionUndoMessage: "Add attribute",
                          },
                        );
                      }
                    }}
                    onUpdateAttributeDefinition={async () => {
                      if (this.plotter) {
                        await this.plotter.actionHandler!(
                          ActionType.PERFORM,
                          DEVICE_WAFER_KEY,
                          {
                            actionDoMessage: "Update attribute",
                            actionUndoMessage: "Update attribute",
                          },
                        );
                      }
                    }}
                    attributes={WCMAttributeDefinitions}
                    allAttributes={allWCMAttributeMetas}
                    onDeleteAttribute={this.onDeleteAttributeMeta}
                    onAddAttribute={this.onAddAttributeMeta}
                  />
                  <hr className="wcm-section-divider" />
                  <h4 style={{ marginBottom: "25px" }}>Memory Block Details</h4>
                  <div className="custom-form wcm-form-section">
                    <Label labelTitle="Block Name:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb5">
                      <Textbox
                        name="memoryDetailsName"
                        type="text"
                        placeholder="Block Name"
                        value={memoryDetails.name}
                        onChange={(e: any) => {
                          this.setState((prevState) => ({
                            memoryDetails: {
                              ...prevState.memoryDetails,
                              name: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Label>
                    <Label labelTitle="Block No. of Rows:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb5">
                      <Textbox
                        name="memoryDetailsRows"
                        type="number"
                        placeholder="0"
                        value={memoryDetails.rows ?? ""}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (val === "") {
                            this.setState((prevState) => ({
                              memoryDetails: { ...prevState.memoryDetails, rows: null },
                            }));
                          } else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num) && num > 0 && val.indexOf(".") === -1) {
                              this.setState((prevState) => ({
                                memoryDetails: { ...prevState.memoryDetails, rows: num },
                              }));
                            }
                          }
                        }}
                      />
                    </Label>
                    <Label labelTitle="Block No. of Columns:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb5">
                      <Textbox
                        name="memoryDetailsColumns"
                        type="number"
                        placeholder="0"
                        value={memoryDetails.columns ?? ""}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (val === "") {
                            this.setState((prevState) => ({
                              memoryDetails: { ...prevState.memoryDetails, columns: null },
                            }));
                          } else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num) && num > 0 && val.indexOf(".") === -1) {
                              this.setState((prevState) => ({
                                memoryDetails: { ...prevState.memoryDetails, columns: num },
                              }));
                            }
                          }
                        }}
                      />
                    </Label>
                  </div>
                  <hr className="wcm-section-divider" />
                  <h4 style={{ marginBottom: "25px" }}>Pattern Definition</h4>
                  <div className="custom-form wcm-form-section">
                    <h5>Single Row Failure</h5>
                    <Label labelTitle="Max number of consecutive bits:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb15">
                      <Textbox
                        style={{ marginLeft: '10px' }}
                        name="singleRowFailureBits"
                        type="number"
                        min="1"
                        placeholder="0"
                        value={patternDefinition.singleRowFailureBits ?? ""}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (val === "" || (/^\d+$/.test(val) && parseInt(val, 10) > 0)) {
                            this.setState((prevState) => ({
                              patternDefinition: { ...prevState.patternDefinition, singleRowFailureBits: val === "" ? null : `${val}` },
                            }));
                          }
                        }}
                      />
                    </Label>

                    <h5 className="wcm-section-margin-title">Single Column Failure</h5>
                    <Label labelTitle="Max number of consecutive bits:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb15">
                      <Textbox
                        style={{ marginLeft: '10px' }}
                        name="singleColumnFailureBits"
                        type="number"
                        min="1"
                        placeholder="0"
                        value={patternDefinition.singleColumnFailureBits ?? ""}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (val === "" || (/^\d+$/.test(val) && parseInt(val, 10) > 0)) {
                            this.setState((prevState) => ({
                              patternDefinition: { ...prevState.patternDefinition, singleColumnFailureBits: val === "" ? null : `${val}` },
                            }));
                          }
                        }}
                      />
                    </Label>

                    <h5 className="wcm-section-margin-title">Partial Row Failure</h5>
                    <Label labelTitle="Consecutive Or % of Number of bits:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb15">
                      <div className="wcm-flex-with-gap">
                        {partialRowFailureBitsType === 'Count' ? (
                          <Textbox
                            name="partialRowFailureBits"
                            type="number"
                            min="1"
                            placeholder="0"
                            value={patternDefinition.partialRowFailureBits?.replace('%', '') ?? ""}
                            onChange={(e: any) => {
                              const val = e.target.value;
                              if (val === "" || (/^\d+$/.test(val) && parseInt(val, 10) > 0)) {
                                this.setState((prevState) => ({
                                  patternDefinition: { ...prevState.patternDefinition, partialRowFailureBits: val === "" ? null : `${val}` },
                                }));
                              }
                            }}
                          />
                        ) : (
                          <div className="wcm-flex-full-width">
                            <input
                              name="partialRowFailureBitsPercent"
                              type="range"
                              min="0"
                              max="100"
                              style={{ width: '100%' }}
                              value={patternDefinition.partialRowFailureBits?.replace('%', '') ?? "0"}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                this.setState((prevState) => ({
                                  patternDefinition: { ...prevState.patternDefinition, partialRowFailureBits: `${val}%` },
                                }));
                              }}
                            />
                            <span className="wcm-percentage-display">{patternDefinition.partialRowFailureBits ?? "0%"}</span>
                          </div>
                        )}
                        <CustomizedDropdown
                          list={[['Count', 'Count'], ['Percentage', 'Percentage']]}
                          selectedValue={partialRowFailureBitsType}
                          onChange={(value: string) => {
                            const val = value as 'Count' | 'Percentage';
                            this.setState((prevState) => ({
                              partialRowFailureBitsType: val,
                              patternDefinition: { ...prevState.patternDefinition, partialRowFailureBits: val === 'Percentage' ? '0%' : null },
                            }));
                          }}
                        />
                      </div>
                    </Label>

                    <h5 className="wcm-section-margin-title">Partial Column Failure</h5>
                    <Label labelTitle="Consecutive or % of Number of bits:" labelPosition="left-middle" labelSize="40" fieldSize="60" errorSize="0" className="mb15">
                      <div className="wcm-flex-with-gap">
                        {partialColumnFailureBitsType === 'Count' ? (
                          <Textbox
                            name="partialColumnFailureBits"
                            type="number"
                            min="1"
                            placeholder="0"
                            value={patternDefinition.partialColumnFailureBits?.replace('%', '') ?? ""}
                            onChange={(e: any) => {
                              const val = e.target.value;
                              if (val === "" || (/^\d+$/.test(val) && parseInt(val, 10) > 0)) {
                                this.setState((prevState) => ({
                                  patternDefinition: { ...prevState.patternDefinition, partialColumnFailureBits: val === "" ? null : `${val}` },
                                }));
                              }
                            }}
                          />
                        ) : (
                          <div className="wcm-flex-full-width">
                            <input
                              name="partialColumnFailureBitsPercent"
                              type="range"
                              min="0"
                              max="100"
                              style={{ width: '100%' }}
                              value={patternDefinition.partialColumnFailureBits?.replace('%', '') ?? "0"}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                this.setState((prevState) => ({
                                  patternDefinition: { ...prevState.patternDefinition, partialColumnFailureBits: `${val}%` },
                                }));
                              }}
                            />
                            <span className="wcm-percentage-display">{patternDefinition.partialColumnFailureBits ?? "0%"}</span>
                          </div>
                        )}
                        <CustomizedDropdown
                          list={[['Count', 'Count'], ['Percentage', 'Percentage']]}
                          selectedValue={partialColumnFailureBitsType}
                          onChange={(value: string) => {
                            const val = value as 'Count' | 'Percentage';
                            this.setState((prevState) => ({
                              partialColumnFailureBitsType: val,
                              patternDefinition: { ...prevState.patternDefinition, partialColumnFailureBits: val === 'Percentage' ? '0%' : null },
                            }));
                          }}
                        />
                      </div>
                    </Label>
                  </div>
                  <hr className="wcm-section-divider" />
                  <h4>Draw Pattern</h4>
                  <div></div>
                <DrawPattern
                    drawPattern={drawPattern}
                    onChange={(val) => this.setState({ drawPattern: val })}
                  />  
                </div>
              </Col>
              {!collapseDieSummaryColumn && rightSideBar}
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default withRouter(WaferControlMap);
